<template>
  <div class="app" ref="app">
    <div onselectstart="return false" v-if="!moveMode" class="fixtop">
      <div class="left">
        <!-- <img
          @click="studentVisible = true"
          style="width: 35px; height: 35px; margin-right: 10px"
          :src="
            studentNum
              ? require('../assets/person1.png')
              : require('../assets/person.png')
          "
          alt=""
        /> -->
        <div
          @click="handleShowPageModel"
          class="npage"
          style="width: 35px; height: 35px; position: relative"
        >
          <img
            style="width: 35px; height: 35px"
            :src="require('../assets/yema.png')"
            alt=""
          />
          <div
            v-if="pages2.length"
            style="
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              text-align: center;
              line-height: 35px;
              font-size: 12px;
              color: #fff;
            "
          >
            {{
              pages2[page].type == 1
                ? "首"
                : pages2[page].type == 3
                ? "底"
                : pages2[page].page_num
            }}
          </div>
        </div>

        <div @click="nextStep" class="icon">
          <img
            style="width: 18px; margin-bottom: 1px"
            :src="require('../assets/next.png')"
            alt=""
          />
          <div class="name">前进</div>
        </div>
        <div @click="cancelStep" class="icon">
          <img
            style="width: 18px; margin-bottom: 1px"
            :src="require('../assets/back.png')"
            alt=""
          />
          <div class="name">后退</div>
        </div>
        <div style="margin-right: 12px" class="network">
          <a-tooltip v-if="netWork == -1" :title="网络已断开">
            <img
              style="width: 18px"
              v-if="netWork <= 1"
              src="../assets/online3.gif"
              alt=""
            />
            <div class="name">网络断开</div>
          </a-tooltip>
          <a-tooltip
            v-if="netWork > 0"
            :title="
              netWork > 200
                ? '网络较差' + netWork
                : netWork > 100
                ? '网络一般' + netWork
                : '网络极佳' + netWork
            "
          >
            <img
              style="width: 18px"
              v-if="netWork > 200"
              src="../assets/network-bad.jpg"
              alt=""
            />
            <img
              style="width: 18px"
              v-else-if="netWork > 100"
              src="../assets/network-good.png"
              alt=""
            />
            <img
              style="width: 18px"
              v-else
              src="../assets/network-good.png"
              alt=""
            />
            <div class="name">
              {{
                netWork > 200
                  ? "网络较差"
                  : netWork > 100
                  ? "网络一般"
                  : "网络极佳"
              }}
            </div>
          </a-tooltip>
        </div>
      </div>
      <div class="right">
        <div class="savebox">
          <a-icon :type="saveDraging ? 'loading' : 'check'" />
          <div>{{ saveDraging ? "上传中..." : "保存成功！" }}</div>
        </div>
        <!-- <div class="btn">预览</div>
        <div class="btn">分享</div> -->
      </div>
    </div>
    <!-- <div v-if="moveMode" class="fixtop">
      <div class="icon-wrapper">
        <div class="item">
        <img @click="fangda" src="../assets/fangda.png" alt="" />
        <div class="name">放大</div>

      </div>
      <div @click="suoxiao" class="item">
        <img @click="suoxiao" src="../assets/suoxiao.png" alt="" />
        <div class="name">缩小</div>

      </div>
      <div
          @click="handleCatePic" class="item">
        <i class="miconfont icon-retweet"></i>
          <div class="name">完成裁切</div>
      </div>
      </div>
      
    </div> -->
    <div
      ref="body"
      onselectstart="return false"
      class="body"
      :key="dragKey"
      :style="wrapperStyle"
    >
      <img
        v-if="backgroundImage"
        class="backimg"
        :src="backgroundImage"
        alt=""
      />
      <vue-draggable-resizable
        ref="drag"
        @changeLevel="changeLevel"
        @changeLevelData="changeLevelData"
        @rotating="dragRotating"
        @dragging="dragMoving"
        @resizing="dragResizing"
        @handleUnlock="handleUnlock"
        v-show="!moveMode || index == activeIndex"
        :spinning="item.spinning"
        :w="item.width"
        :h="item.height"
        :x="item.left"
        :y="item.top"
        :cateMode="moveMode"
        :r="item.rotate"
        :z="item.zIndex"
        :parent="true"
        :minWidth="12"
        :minHeight="12"
        :level="item.level"
        :levelType="item.levelType"
        :levelNum="item.levelNum"
        :fontFamily="item.fontFamily"
        :textDecoration="item.textDecoration"
        @changeHeight="changeHeight"
        :frameId="'frame' + index"
        :photoScale="item.photoScale"
        :photoLeft="item.photoLeft"
        :photoTop="item.photoTop"
        :showPhoto="item.showPhoto"
        :shadow="item.shadow ? true : false"
        :allIndex="allIndex"
        :dIndex="index"
        :debug="false"
        :isEdit="false"
        :textIndent="item.textIndent"
        :photoRotate="item.photoRotate"
        :writingMode="item.writeMode"
        :lineHeight="item.lineHeight"
        :fontWeight="item.fontWeight"
        :fontStyle="item.fontStyle"
        :textAlign="item.textAlign"
        :type="item.type"
        :isConflictCheck="false"
        :snap="true"
        :snapTolerance="1"
        :lockAspectRatio="item.lockAspectRatio ? true : false"
        :backImg="item.backgroundImg ? item.backgroundImg : ''"
        :bImg2="item.backImg2"
        :bRadius="item.borderRadius"
        :draggable="item.draggable"
        @refLineParams="getRefLineParams"
        @activated="changeDrag(index)"
        @changeContent="changeContent"
        @showEdit="showEdit"
        @photoChange="photoChange"
        :fontColor="item.fColor"
        :text="item.textarea"
        :o="item.opacity"
        :l="item.lock || pageDetail.is_locked ? true : false"
        :backColor="item.bColor"
        :borderColor="item.bordersColor"
        :borderLeft="item.bLeft"
        :borderTop="item.bTop"
        :borderRight="item.bRight"
        :borderBottom="item.bBottom"
        :borderStyle="item.bStyle"
        :paddingLeft="item.paddingLeft"
        :paddingTop="item.paddingTop"
        :paddingRight="item.paddingRight"
        :paddingBottom="item.paddingBottom"
        :active="item.active ? true : false"
        :fontSize="item.fSize"
        v-for="(item, index) in drags"
        :key="item.ec_id"
        @changeDrag="changeDragHistory"
        @pmoving="pmoving"
        @resizestop="resizing"
        @movingStop="movingStop"
        @rotatingStop="rotating"
        @dragstop="dragging"
        @upTop="upTop(index)"
        @mouseEnter="listenMouseEnter"
        @mouserLeave="listenMouseLeave"
        @confirmComb="confirmComb"
        @dropImg="dropImg"
      >
        <div v-if="item.type == 3" class="look" style="z-index: -1">
          <div
            class="wrap"
            :style="{
              width: item.width + 'px',
              height: item.height + 'px',
              transform: `scale(${item.width / item.orignWidth},${item.height /
                item.orignHeight})`,
              transformOrigin: '0px 0px',
            }"
          >
            <vue-draggable-resizable
              v-for="(item2, index2) in item.coms"
              :key="index2"
              :w="item2.width"
              :h="item2.height"
              :x="item2.left"
              :y="item2.top"
              :r="item2.rotate"
              :z="item2.zIndex"
              :frameId="'frame' + index + '_' + index2"
              :photoScale="item2.photoScale"
              :photoLeft="item2.photoLeft"
              :photoTop="item2.photoTop"
              :showPhoto="item2.showPhoto"
              :shadow="item2.shadow ? true : false"
              :allIndex="allIndex"
              :dIndex="index"
              :debug="false"
              :disable="true"
              :textDecoration="item.textDecoration"
              :textIndent="item.textIndent"
              :writingMode="item.writeMode"
              :lineHeight="item2.lineHeight"
              :fontWeight="item2.fontWeight"
              :fontStyle="item2.fontStyle"
              :textAlign="item2.textAlign"
              :type="item2.type"
              :isConflictCheck="false"
              :snap="true"
              :snapTolerance="1"
              :lockAspectRatio="item2.lockAspectRatio ? true : false"
              :backImg="item2.backgroundImg ? item2.backgroundImg : ''"
              :bImg2="item2.backImg2"
              :bRadius="item2.borderRadius"
              :fontColor="item2.fColor"
              :text="item2.textarea"
              :o="item2.opacity"
              :l="item2.lock ? true : false"
              dragHandle="false"
              :backColor="item2.bColor"
              :borderColor="item2.bordersColor"
              :borderLeft="item2.bLeft"
              :borderTop="item2.bTop"
              :borderRight="item2.bRight"
              :borderBottom="item2.bBottom"
              :borderStyle="item2.bStyle"
              :paddingLeft="item2.paddingLeft"
              :paddingTop="item2.paddingTop"
              :paddingRight="item2.paddingRight"
              :paddingBottom="item2.paddingBottom"
              :active="false"
              :fontSize="item2.fSize"
            ></vue-draggable-resizable>
          </div>
        </div>
      </vue-draggable-resizable>
      <!--辅助线-->
      <!-- <span
          class="ref-line v-line"
          v-for="item in vLine"
          :key="item.id"
          v-show="item.display"
          :style="{
            left: item.position,
            top: item.origin,
            height: item.lineLength,
          }"
        />
        <span
          class="ref-line h-line"
          v-for="item in hLine"
          :key="item.id"
          v-show="item.display"
          :style="{
            top: item.position,
            left: item.origin,
            width: item.lineLength,
          }"
        /> -->
      <!--辅助线END-->
      <i
        v-if="activeIndex > -1 && drags[activeIndex].type != 4 && !moveMode"
        :style="rotateStyle"
        class="rotatebox iconfont icon-xuanzhuan"
        @mousedown.stop.prevent="handleRotateTouchDown(null, $event)"
        @touchstart.stop.prevent="handleRotateDown(null, $event)"
        @touchend.stop.prevent="handleRotateUp"
      ></i>
      <!-- <div
        v-if="
          activeIndex > -1 && !moveMode &&
            (drags[activeIndex].type == 2 || drags[activeIndex].type == 1 || drags[activeIndex].type == 9)
        "
        :style="moveBoxStyle"
        class="moveBOX"
      >
        <img @click="fangda" src="../assets/fangda.png" alt="" />
        <img
          @mousedown.stop.prevent="handleMoveTouchDown(null, $event)"
          @touchstart.stop.prevent="handleMoveDown(null, $event)"
          @touchend.stop.prevent="handleRotateUp"
          src="../assets/yidong.png"
          alt=""
        />
        <img @click="suoxiao" src="../assets/suoxiao.png" alt="" />
      </div> -->
      <div
        class="leftLine"
        :style="{
          left: haomi + 'px',
          top: haomi + 'px',
          bottom: haomi + 'px',
        }"
      ></div>
      <div
        class="topLine"
        :style="{
          top: haomi + 'px',
          left: haomi + 'px',
          right: haomi + 'px',
        }"
      ></div>
      <div
        class="rightLine"
        :style="{
          right: haomi + 'px',
          top: haomi + 'px',
          bottom: haomi + 'px',
        }"
      ></div>
      <div
        class="bottomLine"
        :style="{
          bottom: haomi + 'px',
          left: haomi + 'px',
          right: haomi + 'px',
        }"
      ></div>
      <div
        v-if="
          kongwei &&
            pages2[page].page_num % 2 == 1 &&
            pages2[page].page_num != 0
        "
        class="circles"
        :style="{ left: haomi * 2.6 + 'px' }"
      >
        <div class="circle">
          <div></div>
        </div>
        <div class="circle">
          <div></div>
        </div>
        <div class="circle">
          <div></div>
        </div>
      </div>
      <div
        v-if="
          kongwei &&
            pages2[page].page_num % 2 == 0 &&
            pages2[page].page_num != 0
        "
        class="circles"
        :style="{ right: haomi * 2.6 + 'px' }"
      >
        <div class="circle">
          <div></div>
        </div>
        <div class="circle">
          <div></div>
        </div>
        <div class="circle">
          <div></div>
        </div>
      </div>
    </div>
    <div @click="visible = true" onselect="return false" class="fixbottom">
      <div @click="showDrawTab(2)" class="item">
        <i class="miconfont icon-pic-right"></i>
        <div class="name">素材</div>
      </div>
      <div @click="showDrawTab(0)" class="item">
        <i class="miconfont icon-image"></i>
        <div class="name">照片</div>
      </div>
      <div @click="showDrawTab(4)" class="item">
        <i class="miconfont icon-border-outer"></i>
        <div class="name">相框</div>
      </div>
      <div @click="showDrawTab(5)" class="item">
        <i class="miconfont icon-fund"></i>
        <div class="name">背景</div>
      </div>
      <div @click="showDrawTab(6)" class="item">
        <i class="miconfont icon-appstoreadd"></i>
        <div class="name">组合</div>
      </div>
    </div>
    <div
      v-show="changePhotoState"
      class="fixbottom"
      onselect="return false"
      style="z-index: 99"
    >
      <div @click="changePhotoState = false" class="item">
        <i class="miconfont icon-fanhui1"></i>
        <div class="name">返回</div>
      </div>
      <div @click="showDrawTab(1)" class="item">
        <i class="miconfont icon-icons03"></i>
        <div class="name">替换照片</div>
      </div>
      <div @click="calcelPhoto" class="item">
        <i class="miconfont icon-rotate-right"></i>
        <div class="name">去除照片</div>
      </div>
      <div @click="showChangeFrame" class="item">
        <i class="miconfont icon-fuzhi1"></i>
        <div class="name">更换相框</div>
      </div>
    </div>
    <a-drawer
      placement="bottom"
      height="120"
      :visible="moveMode"
      :closable="false"
      :mask="false"
      @close="moveMode = false"
    >
      <div class="flex-row" style="align-items: center;height: 120px;">
        <div class="icon-wrapper">
          <div class="item">
            <img @click="fangda" src="../assets/fangda.png" alt="" />
            <div class="name">放大</div>
          </div>
          <div @click="suoxiao" class="item">
            <img @click="suoxiao" src="../assets/suoxiao.png" alt="" />
            <div class="name">缩小</div>
          </div>

          <div
            @click="rotatePhoto"
            v-show="activeIndex > -1 && drags[activeIndex].type == 9"
            class="item"
          >
            <img src="../assets/xz.png" alt="" />
            <div class="name">旋转</div>
          </div>
          <div @click="handleCatePic" class="item">
            <i class="miconfont icon-retweet"></i>
            <div class="name">完成裁切</div>
          </div>
        </div>
      </div>
    </a-drawer>

    <a-drawer
      placement="bottom"
      height="600"
      :mask="true"
      :visible="previewFrame"
      @close="previewFrame = false"
    >
      <div class="frameModal" style="padding: 10px 10px 60px 10px">
        <div
          class="searchbox"
          style="margin-bottom: 10px; padding: 0px 30px 10px 0"
        >
          <a-select
            style="width: 120px; margin-left: 10px"
            v-model="frameType2"
            @change="changeFrameType2"
          >
            <a-select-option :value="1">通用相框</a-select-option>
            <a-select-option :value="2">专属相框</a-select-option>
          </a-select>
          <a-input-search
            placeholder="搜索名称"
            v-model="frameTag2"
            enter-button
            @search="onSearchphotos2"
          />
        </div>
        <div style="height: 538px; overflow-y: scroll">
          <div
            v-for="(item, index) in photos2"
            :key="index"
            class="photo-item"
            style="height: 130px"
          >
            <div @click="changeFrame(item)" :style="item" class="look">
              <img
                ref="frame"
                :style="{ borderRadius: item.borderRadius }"
                class="img"
                :src="item.backgroundImg"
                alt=""
              />
              <img
                v-if="item.backImg2"
                class="img2"
                :src="item.backImg2"
                alt=""
              />
            </div>
            <!-- <div class="name">{{ item.name }}</div> -->
          </div>
        </div>

        <div
          v-if="photoPage2"
          style="text-align: right; padding-right: 20px"
          class="pagebox"
        >
          <a-pagination
            size="small"
            :defaultPageSize="14"
            :current="photoPage2.current_page"
            :total="photoPage2.total"
            show-quick-jumper
            show-less-items
            @change="onChangeframePage2"
          />
        </div>
      </div>
    </a-drawer>
    <a-drawer
      title="评级属性"
      placement="bottom"
      :closable="true"
      height="310"
      :mask="false"
      :visible="showDraw == 'level'"
      @close="showDraw = false"
    >
      <div v-if="activeIndex > -1" class="edit-content">
        <div
          v-if="!drags[activeIndex].lock && drags[activeIndex].type == 4"
          class="section-item"
        >
          <div class="item-line">
            <span class="name2" style="width: 70px">评级颜色</span>
            <div class="flex-1" style="padding-right: 20px">
              <el-color-picker v-model="drags[activeIndex].fColor" show-alpha>
              </el-color-picker>
            </div>
          </div>
          <div class="item-line">
            <span class="name2" style="width: 70px">评级类型</span>
            <div class="flex-1" style="padding-right: 20px">
              <a-select
                @change="changeLevelType"
                v-model="drags[activeIndex].levelType"
                style="width: 100%"
              >
                <a-select-option label="星星" :value="1">星星 </a-select-option>
                <a-select-option label="打钩" :value="2"> 打钩</a-select-option>
              </a-select>
            </div>
          </div>
          <div class="item-line">
                  <span class="name2" style="width: 70px">评级</span>
                  <div class="flex-1" style="padding-right: 20px">
                    <a-select
                      @change="changeCurrnetLevel"
                      v-model="drags[activeIndex].level"
                      style="width:100%"
                    >
                      <a-select-option label="1" :value="1"
                        >1
                      </a-select-option>
                      <a-select-option label="2" :value="2">
                        2</a-select-option
                      >
                      <a-select-option label="3" :value="3">
                        3</a-select-option
                      >
                    </a-select>
                  </div>
                </div>
          <div class="item-line">
            <span class="name2" style="width: 70px">图标大小</span>
            <div class="flex-1" style="padding-right: 20px">
              <a-input-number v-model="drags[activeIndex].fSize" :min="12" />
            </div>
          </div>
          <div v-if="drags[activeIndex].levelType == 2" class="item-line">
            <span class="name2" style="width: 70px">档位</span>
            <div class="flex-1" style="padding-right: 20px">
              <a-select
                v-model="drags[activeIndex].levelNum"
                placeholder="请选择"
                style="width: 100%"
              >
                <a-select-option label="3档" :value="3">3档 </a-select-option>
                <a-select-option
                  v-if="drags[activeIndex].levelType == 2"
                  label="4档"
                  :value="4"
                >
                  4档</a-select-option
                >
              </a-select>
            </div>
          </div>
        </div>
      </div>
    </a-drawer>

    <a-drawer
      title="透明度"
      placement="bottom"
      :closable="true"
      height="180"
      :mask="false"
      :visible="showDraw == 'opacity'"
      @close="showDraw = false"
    >
      <div v-if="activeIndex > -1" class="edit-content">
        <a-row :gutter="[10, 10]">
          <a-col :span="20">
            <a-slider v-model="drags[activeIndex].opacity"></a-slider>
          </a-col>
          <a-col :span="4">
            <a-input v-model="drags[activeIndex].opacity"></a-input>
          </a-col>
        </a-row>
      </div>
    </a-drawer>
    <a-drawer
      title="批量编辑"
      placement="bottom"
      :closable="true"
      :height="500"
      :mask="false"
      :visible="showDraw == 'allEdit'"
      @close="showDraw = false"
    >
      <div
        v-show="editList.length"
        class="edit-content"
        style="height: 540px; overflow-y: scroll"
      >
        <div class="edit-list">
          <div v-for="(item, index) in editList" :key="index" class="edit-cell">
            <div class="name">{{ item.student_name }}</div>
            <a-textarea
              style="height: auto"
              v-if="item.type == 5"
              v-model="item.textarea"
              @blur="pressEnter($event, index)"
              @focus="editorFocus($event, index)"
              @change="changeEditText($event, index)"
            ></a-textarea>
            
          </div>
        </div>
      </div>
    </a-drawer>
    <a-drawer
      title="行高"
      placement="bottom"
      :closable="true"
      height="200"
      :mask="false"
      :visible="showDraw == 'lineHeight'"
      @close="showDraw = false"
    >
      <div v-if="activeIndex > -1" class="edit-content">
        <a-row type="flex" align="middle" style="margin-bottom: 10px">
          <a-col :span="4"> 自动行高 </a-col>
          <a-col :span="20" style="text-align: right">
            <a-switch
              v-model="drags[activeIndex].lineHeightAutoSize"
              checked-children="开"
              un-checked-children="关"
              default-checked
            />
          </a-col>
        </a-row>
        <a-row type="flex" align="middle" :gutter="[10, 10]">
          <a-col :span="3" align-item="center">行高 </a-col>
          <a-col :span="17">
            <a-slider
              :disabled="drags[activeIndex].lineHeightAutoSize ? true : false"
              v-model="drags[activeIndex].lineHeight"
            ></a-slider>
          </a-col>
          <a-col :span="4">
            <a-input
              :disabled="drags[activeIndex].lineHeightAutoSize ? true : false"
              v-model="drags[activeIndex].lineHeight"
            ></a-input>
          </a-col>
        </a-row>
      </div>
    </a-drawer>
    <a-drawer
      title="文字排列"
      placement="bottom"
      :closable="true"
      :mask="false"
      height="160"
      :visible="showDraw == 'writingMode'"
      @close="showDraw = false"
    >
      <div v-if="activeIndex > -1" class="edit-content">
        <a-row type="flex" align="middle" :gutter="[10, 10]">
          <a-col :span="12">
            <div
              @click="drags[activeIndex].writeMode = 'horizontal-tb'"
              :class="
                drags[activeIndex].writeMode == '' ||
                drags[activeIndex].writeMode == 'horizontal-tb'
                  ? 'active'
                  : ''
              "
              class="border-cell"
            >
              <div class="name" style="width: 120px">横排</div>
            </div>
          </a-col>
          <a-col :span="12">
            <div
              @click="drags[activeIndex].writeMode = 'vertical-lr'"
              :class="
                drags[activeIndex].writeMode == 'vertical-lr' ? 'active' : ''
              "
              class="border-cell"
            >
              <div class="name" style="width: 120px">竖排-从左到右</div>
            </div>
          </a-col>
        </a-row>
      </div>
    </a-drawer>
    <div v-show="pageModal" class="dz-drawer">
      <div class="d-title">
        {{ drawTitle }}
      </div>
      <i @click="pageModal = false" class="miconfont icon-close-circle"></i>
      <router-view @emitChangeGrowPage="changeGrowPage"></router-view>
    </div>

    <div v-show="studentVisible" class="dz-drawer">
      <div class="d-title">学生选择</div>
      <i
        @click="studentVisible = false"
        class="miconfont icon-close-circle"
      ></i>
      <div class="content" style="padding-top: 110px">
        <div onselect="return false" class="student-list">
          <div @click="selectAllStudent()" class="selectall">
            {{ selectState ? "取消全选" : "全选" }}
          </div>
          <div
            @click="selectStudent(index, $event)"
            v-for="(item, index) in studentList"
            :key="index"
            :class="{ select: item.select, active: item.id == s_id }"
            class="cell"
          >
            <img
              :src="
                item.head_img ? item.head_img : require('../assets/icon-11.png')
              "
              alt=""
            />
            <div class="name">{{ item.name }}</div>
            <div v-if="item.has_element === false" class="pos-tip">
              无同位组件
            </div>
          </div>
          <div
            style="
              margin-right: 30px;
              margin-bottom: 20px;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              width: 100%;
              padding: 15px;
              border-top: 1px solid #eee;
            "
            class="moreselect"
          >
            <div class="">多选状态</div>
            <a-switch
              checked-children="开"
              un-checked-children="关"
              v-model="moreSelect"
            />
          </div>
          <!-- <div
            class="tip"
            style="
              color: #ff0000;
              text-align: center;
              width: 100%;
              clear: both;
              font-size: 14px;
              padding: 10px;
              box-sizing: border-box;
              padding: 0 30px;
              margin-bottom: 20px;
            "
          >
            按住ctrl点击可多选学生，全选状态按住ctrl则切换当前显示的学生成长册
          </div> -->
        </div>
      </div>
    </div>
    <a-drawer
      title="微调"
      placement="bottom"
      :closable="true"
      height="auto"
      :mask="false"
      :visible="showDraw == 'set'"
      @close="showDraw = false"
    >
      <div onselect="return false" v-if="activeIndex > -1" class="edit-content">
        <a-row
          :gutter="[10, 10]"
          style="text-align: center"
          type="flex"
          align="middle"
          justify="space-around"
        >
          <a-col @click="drags[activeIndex].left--" :span="6">
            <i class="miconfont icon-arrowleft"></i>
            <div class="name">左移</div>
          </a-col>
          <a-col @click="drags[activeIndex].top--" :span="6">
            <i class="miconfont icon-arrowup"></i>
            <div class="name">上移</div>
          </a-col>
          <a-col @click="drags[activeIndex].left++" :span="6">
            <i class="miconfont icon-arrowright"></i>
            <div class="name">右移</div>
          </a-col>
          <a-col @click="drags[activeIndex].top++" :span="6">
            <i class="miconfont icon-arrowdown"></i>
            <div class="name">下移</div>
          </a-col>
        </a-row>
      </div>
    </a-drawer>
    <a-drawer
      title="层位"
      placement="bottom"
      :closable="true"
      height="auto"
      :mask="false"
      :visible="showDraw == 'index'"
      @close="showDraw = ''"
    >
      <div v-if="activeIndex > -1" class="edit-content">
        <a-row type="flex" justify="space-around" align="middle">
          <div @click="up()" class="cz-item">
            <i class="iconfont icon-shangyiyiceng"></i>
            <div class="name">上移一层</div>
          </div>
          <div @click="down()" class="cz-item">
            <i class="iconfont icon-xiayiyiceng"></i>
            <div class="name">下移一层</div>
          </div>
          <div @click="toTop()" class="cz-item">
            <i class="iconfont icon-control-top"></i>
            <div class="name">置顶</div>
          </div>
          <div @click="toBottom()" class="cz-item">
            <i class="iconfont icon-control-bottom"></i>
            <div class="name">置底</div>
          </div>
        </a-row>
      </div>
    </a-drawer>
    <a-drawer
      title="属性"
      placement="bottom"
      :closable="true"
      height="auto"
      :visible="showDraw == 'attr'"
      @close="showDraw = ''"
    >
      <div v-if="activeIndex > -1" class="edit-content" style="padding: 0">
        <div class="tab" style="padding: 0; margin: 0">
          <div
            @click="itemIndex = 0"
            class="item"
            :class="itemIndex == 0 ? 'active' : ''"
          >
            边框粗细
          </div>
          <div
            @click="itemIndex = 1"
            class="item"
            :class="itemIndex == 1 ? 'active' : ''"
          >
            边框样式
          </div>
          <div
            @click="itemIndex = 2"
            class="item"
            :class="itemIndex == 2 ? 'active' : ''"
          >
            颜色设置
          </div>
          <div
            @click="itemIndex = 3"
            class="item"
            :class="itemIndex == 3 ? 'active' : ''"
          >
            更多设置
          </div>
        </div>
        <div class="section">
          <div v-if="itemIndex == 0" class="item" style="padding: 15px">
            <!-- <a-row type="flex" align="middle" :gutter="[10, 10]">
              <a-col :span="3" align-item="center">边框大小 </a-col>
              <a-col :span="17"
                ><a-slider v-model="drags[activeIndex].lineHeight"></a-slider>
              </a-col>
              <a-col :span="4">
                <a-input v-model="drags[activeIndex].lineHeight"></a-input>
              </a-col>
            </a-row> -->
            <a-row type="flex" align="middle" :gutter="[10, 10]">
              <a-col :span="6">
                <div class="flex-row">
                  <i class="iconfont icon-jurassic_border-left"></i>
                  <a-input-number
                    v-model="drags[activeIndex].bLeft"
                    controls-position="right"
                    :min="0"
                    :max="359"
                    size="small"
                  ></a-input-number>
                </div>
              </a-col>
              <a-col :span="6">
                <div class="flex-row">
                  <i class="iconfont icon-jurassic_border-top"></i>
                  <a-input-number
                    v-model="drags[activeIndex].bTop"
                    controls-position="right"
                    :min="0"
                    :max="359"
                    size="small"
                  ></a-input-number>
                </div>
              </a-col>
              <a-col :span="6">
                <div class="flex-row">
                  <i class="iconfont icon-jurassic_border-right"></i>
                  <a-input-number
                    v-model="drags[activeIndex].bRight"
                    controls-position="right"
                    :min="0"
                    :max="359"
                    size="small"
                  ></a-input-number>
                </div>
              </a-col>
              <a-col :span="6">
                <div class="flex-row">
                  <i class="iconfont icon-jurassic_border-bottom"></i>
                  <a-input-number
                    v-model="drags[activeIndex].bBottom"
                    controls-position="right"
                    :min="0"
                    :max="359"
                    size="small"
                  ></a-input-number>
                </div>
              </a-col>
            </a-row>
          </div>

          <div v-if="itemIndex == 1" class="item" style="padding: 15px">
            <a-row type="flex" align="middle" :gutter="[10, 10]">
              <a-col :span="8">
                <div
                  @click="drags[activeIndex].bStyle = 'solid'"
                  :class="
                    drags[activeIndex].bStyle == '' ||
                    drags[activeIndex].bStyle == 'solid'
                      ? 'active'
                      : ''
                  "
                  class="border-cell"
                >
                  <div class="name">实线</div>
                  <div class="border1"></div>
                </div>
              </a-col>
              <a-col :span="8">
                <div
                  @click="drags[activeIndex].bStyle = 'dashed'"
                  :class="drags[activeIndex].bStyle == 'dashed' ? 'active' : ''"
                  class="border-cell"
                >
                  <div class="name">虚线</div>
                  <div class="border2"></div>
                </div>
              </a-col>
              <a-col :span="8">
                <div
                  class="border-cell"
                  @click="drags[activeIndex].bStyle = 'dotted'"
                  :class="drags[activeIndex].bStyle == 'dotted' ? 'active' : ''"
                >
                  <div class="name">点线</div>
                  <div class="border3"></div>
                </div>
              </a-col>
            </a-row>
          </div>

          <div v-if="itemIndex == 2" class="item" style="padding: 15px">
            <a-row>
              <a-col :span="24" style="text-align: center">
                <div style="margin-bottom: 5px">边框颜色</div>
                <el-color-picker
                  v-model="drags[activeIndex].bordersColor"
                ></el-color-picker>
              </a-col>
              <a-col
                v-if="drags[activeIndex].type == 5"
                :span="12"
                style="text-align: center"
              >
                <div style="margin-bottom: 5px">背景颜色</div>
                <el-color-picker
                  v-model="drags[activeIndex].bColor"
                ></el-color-picker>
              </a-col>
            </a-row>
          </div>

          <div v-if="itemIndex == 3" class="item" style="padding: 15px">
            <a-row type="flex" align="middle" style="margin-bottom: 10px">
              <a-col :span="4"> 圆角 </a-col>
              <a-col :span="16" style="text-align: right">
                <a-slider v-model="drags[activeIndex].borderRadius"></a-slider>
              </a-col>
              <a-col :span="4">
                <a-input v-model="drags[activeIndex].borderRadius"></a-input>
              </a-col>
            </a-row>
            <!-- <a-row type="flex" align="middle" style="margin-bottom: 10px">
              <a-col :span="4"> 阴影 </a-col>
              <a-col :span="20" style="text-align: right">
                <a-switch
                  v-model="drags[activeIndex].shadow"
                  checked-children="开"
                  un-checked-children="关"
                  default-checked
                />
              </a-col>
            </a-row> -->
            <a-row type="flex" align="middle">
              <a-col :span="4"> 比例锁定 </a-col>
              <a-col :span="20" style="text-align: right">
                <a-switch
                  v-model="drags[activeIndex].lockAspectRatio"
                  checked-children="开"
                  un-checked-children="关"
                  default-checked
                />
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
    </a-drawer>
    <a-drawer
      title="编辑"
      placement="bottom"
      :closable="true"
      height="auto"
      :visible="showDraw == 'edit'"
      @close="onCloseEdit"
    >
      <div v-if="activeIndex > -1" class="edit-content">
        <div :style="style" style="flex: 1 1 0%;position: relative;">
          <textarea
            :style="style3"
            name=""
            id=""
            v-model="editText"
            cols="10"
            placeholder="请点击此处输入文本"
            rows="2"
          ></textarea>
          <div style="font-size: 12px;color: #8a8a8a;background: #fff;padding: 4px 8px;position: absolute;right: 0;
          bottom: 1px;">点击左侧灰色区域编辑文本</div>
        </div>
        <div class="tab">
          <div
            @click="itemIndex = 0"
            class="item"
            :class="itemIndex == 0 ? 'active' : ''"
          >
            格式
          </div>
          <div
            @click="itemIndex = 1"
            class="item"
            :class="itemIndex == 1 ? 'active' : ''"
          >
            缩进
          </div>
          <div
            @click="itemIndex = 2"
            class="item"
            :class="itemIndex == 2 ? 'active' : ''"
          >
            字号大小
          </div>
          <div
            @click="itemIndex = 3"
            class="item"
            :class="itemIndex == 3 ? 'active' : ''"
          >
            颜色
          </div>
          <div
            @click="itemIndex = 4"
            class="item"
            :class="itemIndex == 4 ? 'active' : ''"
          >
            字体
          </div>
          <!-- <div
            @click="itemIndex = 5"
            class="item"
            :class="itemIndex == 5 ? 'active' : ''"
          >
            清除格式
          </div> -->
        </div>
        <div class="section">
          <div v-if="itemIndex == 0" class="item">
            <div class="row">
              <div
                @click="changeB"
                class="label"
                :class="drags[activeIndex].fontWeight == 'bold' ? 'active' : ''"
              >
                <b>B</b>
              </div>
              <div
                @click="changeI"
                class="label"
                :class="
                  drags[activeIndex].fontStyle == 'italic' ? 'active' : ''
                "
              >
                <em>I</em>
              </div>
              <div
                @click="changeU"
                class="label"
                :class="
                  drags[activeIndex].textDecoration == 'underline'
                    ? 'active'
                    : ''
                "
              >
                <u> U </u>
              </div>
              <div
                @click="changeS"
                class="label"
                :class="
                  drags[activeIndex].textDecoration == 'line-through'
                    ? 'active'
                    : ''
                "
              >
                <s>S</s>
              </div>
              <div @click="clear" class="label">清除</div>
            </div>
            <div class="row">
              <div class="col-3">
                <div
                  @click="drags[activeIndex].textAlign = 'left'"
                  :class="
                    drags[activeIndex].textAlign == 'left' ||
                    !drags[activeIndex].textAlign
                      ? 'active'
                      : ''
                  "
                  class="cell"
                >
                  <i class="miconfont icon-align-left"></i>
                </div>
                <div
                  @click="drags[activeIndex].textAlign = 'center'"
                  :class="
                    drags[activeIndex].textAlign == 'center' ? 'active' : ''
                  "
                  class="cell"
                >
                  <i class="miconfont icon-align-center"></i>
                </div>
                <div
                  @click="drags[activeIndex].textAlign = 'right'"
                  :class="
                    drags[activeIndex].textAlign == 'right' ? 'active' : ''
                  "
                  class="cell"
                >
                  <i class="miconfont icon-align-right"></i>
                </div>
                <div
                  @click="drags[activeIndex].textAlign = 'justify'"
                  :class="
                    drags[activeIndex].textAlign == 'justify' ? 'active' : ''
                  "
                  class="cell"
                >
                  <i class="miconfont icon-menu"></i>
                </div>
              </div>
              <!-- <div class="label">
                <i class="miconfont icon-unorderedlist"></i>
              </div>
              <div class="label">
                <i class="miconfont icon-orderedlist"></i>
              </div> -->
            </div>
          </div>
          <!--缩进-->
          <div v-if="itemIndex == 1" class="item">
            <div class="row">
              <div @click="addTextIndent" class="label outline">
                <i style="font-size: 22px" class="miconfont icon-indent"></i>
              </div>
              <div @click="decTextIndent" class="label outline">
                <i style="font-size: 22px" class="miconfont icon-outdent"></i>
              </div>
            </div>
          </div>
          <!--字号-->
          <div v-if="itemIndex == 2" class="item">
            <div class="row">
              <div
                @click="changeFSize(58.667)"
                :class="drags[activeIndex].fSize == 58.667 ? 'active' : ''"
                class="label"
              >
                初号
              </div>
              <div
                @click="changeFSize(48)"
                :class="drags[activeIndex].fSize == 48 ? 'active' : ''"
                class="label"
              >
                小初号
              </div>
              <div
                @click="changeFSize(32)"
                :class="drags[activeIndex].fSize == 32 ? 'active' : ''"
                class="label"
              >
                小一号
              </div>
              <div
                @click="changeFSize(29.333)"
                :class="drags[activeIndex].fSize == 29.333 ? 'active' : ''"
                class="label"
              >
                二号
              </div>
              <div
                @click="changeFSize(24)"
                :class="drags[activeIndex].fSize == 24 ? 'active' : ''"
                class="label"
              >
                小二号
              </div>
            </div>
            <div class="row">
              <div
                @click="changeFSize(21.333)"
                :class="drags[activeIndex].fSize == 21.333 ? 'active' : ''"
                class="label"
              >
                三号
              </div>
              <div
                @click="changeFSize(18.667)"
                :class="drags[activeIndex].fSize == 18.667 ? 'active' : ''"
                class="label"
              >
                四号
              </div>
              <div
                @click="changeFSize(16)"
                :class="drags[activeIndex].fSize == 16 ? 'active' : ''"
                class="label"
              >
                小四号
              </div>
              <div
                @click="changeFSize(14)"
                :class="drags[activeIndex].fSize == 14 ? 'active' : ''"
                class="label"
              >
                五号
              </div>
              <div
                @click="changeFSize(12)"
                :class="drags[activeIndex].fSize == 12 ? 'active' : ''"
                class="label"
              >
                小五号
              </div>
            </div>
          </div>
          <!--颜色-->
          <div v-if="itemIndex == 3" class="item">
            <a-row>
              <a-col :span="24" style="text-align: center">
                <div style="margin-bottom: 5px">字体颜色</div>
                <el-color-picker
                  color-format="hex"
                  v-model="drags[activeIndex].fColor"
                ></el-color-picker>
              </a-col>
              <!-- <a-col :span="12" style="text-align:center">
                <div style="margin-bottom:5px">背景颜色</div>
                <el-color-picker v-model="drags[activeIndex].bColor"></el-color-picker>
              </a-col> -->
            </a-row>
          </div>
          <div
            v-if="itemIndex == 4"
            class="item"
            style="
              height: 150px;
              overflow-y: scroll;
              padding: 4px;
              box-sizing: border-box;
            "
          >
            <a-row :gutter="[10, 10]">
              <a-col v-for="(item, index) in fonts" :key="index" :span="24">
                <div
                  @click="changeFamily(item)"
                  :style="{ fontFamily: item }"
                  style="
                    border: 1px solid #eee;
                    height: 40px;
                    text-align: center;
                    line-height: 40px;
                    white-space: nowrap;
                    text-align: center;
                    font-size: 12px;
                  "
                >
                  {{ item }}
                </div>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
    </a-drawer>
    <!-- <a-drawer
      title="行高"
      placement="bottom"
      :closable="true"
      :visible="true"
      @close="onClose"
    >
      <p>Some contents...</p>
      <p>Some contents...</p>
      <p>Some contents...</p>
    </a-drawer> -->
    <div v-if="activeIndex > -1 && !changePhotoState" class="fixbottom type2">
      <div onselect="return false;" class="scrolly">
        <i
          @click="activeIndex = -1"
          style="font-size: 52px; margin-top: -1px; color: #67b0dc"
          class="miconfont icon-plus-circle-fill"
        ></i>
        <div v-if="drags[activeIndex].type == 5" @click="Nedit" class="item">
          <i class="miconfont icon-bianji2"></i>
          <div class="name">编辑</div>
        </div>
        <div
          v-if="drags[activeIndex].type == 5"
          @click="Nexchange"
          class="item"
        >
          <i class="miconfont icon-edit-square"></i>
          <div class="name">批量编辑</div>
        </div>
        <div
          v-if="
            drags[activeIndex].type == 1 ||
              drags[activeIndex].type == 2 ||
              drags[activeIndex].type == 9
          "
          @click="NexchangePhoto"
          class="item"
        >
          <i class="miconfont icon-tihuan1"></i>
          <div class="name">替换</div>
        </div>
        <div
          v-if="
            (drags[activeIndex].type == 1 ||
              drags[activeIndex].type == 9 ||
              drags[activeIndex].type == 2) &&
              !moveMode
          "
          @click="catePic"
          class="item"
        >
          <i class="miconfont icon-retweet"></i>
          <div class="name">裁切</div>
        </div>
        <!-- <div
          v-if="(drags[activeIndex].type == 1 || drags[activeIndex].type == 9) && moveMode"
          @click="handleCatePic"
          class="item"
        >
          <i class="miconfont icon-retweet"></i>
          <div class="name">完成裁切</div>
        </div> -->
        <div
          v-if="drags[activeIndex].type == 9"
          @click="toggleAspect"
          class="item"
        >
          <img
            :src="
              drags[activeIndex].lockAspectRatio
                ? require('../assets/01.png')
                : require('../assets/02.png')
            "
            alt=""
          />
          <div class="name">比例锁定</div>
        </div>
        <div @click="handleRemoveDrag" class="item">
          <i class="miconfont icon-rest"></i>
          <div class="name">删除</div>
        </div>
        <div @click="copythisDrag" class="item">
          <i class="miconfont icon-fuzhi1"></i>
          <div class="name">复制</div>
        </div>
        <div @click="pasterDrag" class="item">
          <i class="miconfont icon-niantie"></i>
          <div class="name">粘贴</div>
        </div>
        <div
          v-if="drags[activeIndex].type == 5"
          @click="NlineHeight"
          class="item"
        >
          <i class="miconfont icon-line-height1"></i>
          <div class="name">行高</div>
        </div>
        <div
          v-if="drags[activeIndex].type == 0 && drags[activeIndex].textarea"
          @click="NwriteMode"
          class="item"
        >
          <i class="miconfont icon-ziti"></i>
          <div class="name">文字排列</div>
        </div>
        <div @click="NshowIndex" class="item">
          <i class="miconfont icon-pic-right"></i>
          <div class="name">层位</div>
        </div>
        <div
          v-if="
            drags[activeIndex].type != 0 &&
              drags[activeIndex].type != 2 &&
              drags[activeIndex].type != 4 &&
              drags[activeIndex].type != 5
          "
          @click="showDraw = 'attr'"
          class="item"
        >
          <i class="miconfont icon-insertrowbelow"></i>
          <div class="name">属性</div>
        </div>
        <div
          v-if="drags[activeIndex].type == 4"
          @click="showDraw = 'level'"
          class="item"
        >
          <i class="miconfont icon-insertrowbelow"></i>
          <div class="name">评级属性</div>
        </div>
        <div @click="NshowOpacity" class="item">
          <i class="miconfont icon-toumingdu"></i>
          <div class="name">透明度</div>
        </div>
        <div @click="NshowSet" class="item">
          <i class="miconfont icon-drag"></i>
          <div class="name">微调</div>
        </div>
        <div @click="NlOCK" class="item">
          <i
            class="miconfont"
            :class="drags[activeIndex].lock ? 'icon-suoding' : 'icon-jiesuo'"
          ></i>
          <div class="name">锁定</div>
        </div>
      </div>
    </div>
    <!-- <div
      v-show="activeIndex > -1 && drags[activeIndex].type == 1"
      class="fixbottom type2"
    >
      <div class="scroll">
        <div class="item">
          <i class="miconfont icon-pic-right"></i>
          <div class="name">素材</div>
        </div>
        <div class="item">
          <i class="miconfont icon-image"></i>
          <div class="name">相框</div>
        </div>
        <div class="item">
          <i class="miconfont icon-fund"></i>
          <div class="name">背景</div>
        </div>
        <div class="item">
          <i class="miconfont icon-appstoreadd"></i>
          <div class="name">组合</div>
        </div>
        <div class="item">
          <i class="miconfont icon-pic-right"></i>
          <div class="name">素材</div>
        </div>
        <div class="item">
          <i class="miconfont icon-image"></i>
          <div class="name">相框</div>
        </div>
        <div class="item">
          <i class="miconfont icon-fund"></i>
          <div class="name">背景</div>
        </div>
        <div class="item">
          <i class="miconfont icon-appstoreadd"></i>
          <div class="name">组合</div>
        </div>
      </div>
    </div> -->
    <a-drawer
      :title="tabTitle"
      placement="bottom"
      :closable="true"
      height="620"
      :visible="showDraw == 'tab'"
      @close="maskClosable"
    >
      <div class="rightChat" @click="catchClick">
        <div class="content">
          <div
            class="cell photo-box"
            ref="pic"
            onselectstart="return false"
            v-if="tabIndex == 0"
          >
            <div class="pullbox flex-row" style="width:100%">
              <a-space>
                <a-button @click="pullPhoto">
                  照片导入
                </a-button>
                <a-button @click="clearPhoto">
                  照片清除
                </a-button>
                <a-checkbox v-model:checked="pullPhotoState">多选</a-checkbox>
              </a-space>
            </div>
            <div
              class="searchbox"
              style="
                display: flex;
                flex-direction: row;
                justify-content: center;
              "
            >
              <a-select
                v-if="picturePage"
                style="width: 160px; margin-left: 10px"
                v-model="album_id"
                @change="changeAlbum"
              >
                <a-select-option
                  v-for="item in albumList"
                  :key="item.id"
                  :value="item.id"
                >
                  <div class="flex-row" style="justify-content: space-between">
                    <span>{{ item.name }}</span>
                    <span
                      v-if="item.id == album_id"
                      class="total"
                      style="margin-left: 5px"
                      >({{ picturePage.total }})</span
                    >
                  </div>
                </a-select-option>
              </a-select>
              <a-button @click="uploadModal = true">
                <a-icon type="upload"></a-icon>上传照片
              </a-button>
            </div>
            <a-empty
              description="暂无内容"
              v-show="!photoLoading && pictures.length == 0"
              style="margin-top: 10px; width: 100%"
            />
            <div
              v-show="!photoLoading && pictures.length == 0"
              @click="refreshAlbum"
              style="line-height: 14px;cursor: pointer;color: blue;text-align: center;margin: 10px auto;"
            >
              <i class="miconfont icon-sync"></i>
              刷新重试
            </div>
            <a-spin :spinning="photoLoading" style="width:100%">
              <div
                v-for="(item, index) in pictures"
                :key="index"
                class="back-item"
                style="background: #eee;min-height: 80px;"
              >
                <div
                  @click="togoPhoto(item, index)"
                  class="back"
                  :class="item.select && pullPhotoState ? 'select' : ''"
                  style="margin-bottom: 0;"
                >
                  <img
                    @click="
                      addDragImg(
                        { layerX: wrapperWidth / 2, layerY: 350 },
                        item.img_url
                      )
                    "
                    @mousedown="handleSelectPhoto(item.img_url)"
                    @mouseup="mouseUpPhoto(item.img_url)"
                    class="img"
                    :src="item.img_url"
                    alt=""
                  />
                  <div
                    v-if="item.select && pullPhotoState"
                    class="iconfont3 icon-duigou"
                  ></div>
                  <div v-if="item.use_times" class="times">
                    {{ item.use_times }}
                  </div>
                </div>
              </div>
            </a-spin>

            <div v-if="picturePage" class="pagebox">
              <a-pagination
                show-quick-jumper
                show-less-items
                :defaultPageSize="12"
                size="small"
                :current="picturePage.current_page"
                :total="picturePage.total"
                @change="onChangepicturePage"
              />
            </div>
          </div>
          <div
            class="cell photo-box"
            ref="pic"
            onselectstart="return false"
            v-if="tabIndex == 1"
          >
            <div class="pullbox flex-row" style="width:100%">
              <a-space>
                <a-button @click="pullPhoto">
                  照片导入
                </a-button>
                <a-button @click="clearPhoto">
                  照片清除
                </a-button>
                <a-checkbox v-model:checked="pullPhotoState">多选</a-checkbox>
              </a-space>
            </div>
            <div
              class="searchbox"
              style="
                display: flex;
                flex-direction: row;
                justify-content: center;
              "
            >
              <a-select
                v-if="picturePage"
                style="width: 160px; margin-left: 10px"
                v-model="album_id"
                @change="changeAlbum"
              >
                <a-select-option
                  v-for="item in albumList"
                  :key="item.id"
                  :value="item.id"
                >
                  <div class="flex-row" style="justify-content: space-between">
                    <span>{{ item.name }}</span>
                    <span
                      v-if="item.id == album_id"
                      class="total"
                      style="margin-left: 5px"
                      >({{ picturePage.total }})</span
                    >
                  </div>
                </a-select-option>
              </a-select>
              <a-button @click="uploadModal = true">
                <a-icon type="upload"></a-icon>上传照片
              </a-button>
            </div>
            <a-empty
              description="暂无内容"
              v-show="!photoLoading && pictures.length == 0"
              style="margin-top: 10px; width: 100%"
            />
            <div
              v-show="!photoLoading && pictures.length == 0"
              @click="refreshAlbum"
              style="line-height: 14px;cursor: pointer;color: blue;text-align: center;margin: 10px auto;"
            >
              <i class="miconfont icon-sync"></i>
              刷新重试
            </div>
            <a-spin :spinning="photoLoading" style="width:100%">
              <div
                v-for="(item, index) in pictures"
                :key="index"
                class="back-item"
                style="background: #eee;min-height: 80px;"
              >
                <div
                  @click="togoPhoto(item, index)"
                  class="back"
                  :class="item.select ? 'select' : ''"
                  style="margin-bottom: 0;"
                >
                  <img
                    @click="changeDragImg(item.img_url)"
                    @mousedown="handleSelectPhoto(item.img_url)"
                    @mouseup="mouseUpPhoto(item.img_url)"
                    class="img"
                    :src="item.img_url"
                    alt=""
                  />
                  <div v-if="item.select" class="iconfont3 icon-duigou"></div>
                  <div v-if="item.use_times" class="times">
                    {{ item.use_times }}
                  </div>
                </div>

                <!-- <div class="back" style="margin-bottom: 0;">
                  <img
                    @click="changeDragImg(item.img_url)"
                    @mousedown="handleSelectPhoto(item.img_url)"
                    @mouseup="mouseUpPhoto(item.img_url)"
                    class="img"
                    :src="item.img_url"
                    alt=""
                  />
                  <div v-if="item.use_times" class="times">
                    {{ item.use_times }}
                  </div>
                </div> -->
                <!-- <div class="name">{{ item.p_id }}</div> -->
              </div>
            </a-spin>

            <div v-if="picturePage" class="pagebox">
              <a-pagination
                show-quick-jumper
                show-less-items
                :defaultPageSize="12"
                size="small"
                :current="picturePage.current_page"
                :total="picturePage.total"
                @change="onChangepicturePage"
              />
            </div>
          </div>
          <div
            class="cell photo-box"
            onselectstart="return false"
            v-if="tabIndex == 2"
          >
            <div class="searchbox" style="display: block">
              <a-row>
                <a-col :span="12">
                  <a-select
                    style="width: 100%"
                    v-model="pasterType"
                    @change="changePasterType"
                  >
                    <a-select-option :value="1">通用素材</a-select-option>
                    <a-select-option :value="2">专属素材</a-select-option>
                    <a-select-option :value="3">个人素材</a-select-option>
                  </a-select>
                </a-col>
                <a-col :span="12" style="padding-right: 10px">
                  <a-select
                    style="width: 100%; margin-left: 10px"
                    v-model="pasterClassId"
                    @change="changePasterClassId"
                  >
                    <a-select-option value="">全部</a-select-option>
                    <a-select-option
                      v-for="(item, index) in pasterClass"
                      :key="index"
                      :value="item.pc_id"
                      >{{ item.name }}</a-select-option
                    >
                  </a-select>
                </a-col>
              </a-row>

              <a-input-search
                style="margin-top: 10px"
                placeholder="搜索名称"
                v-model="pasterTag"
                enter-button
                @search="onSearchimgs"
              />
            </div>

            <div class="photo-item">
              <div
                @mousedown="handleSelectText()"
                @click="addText()"
                class="look"
              >
                <img
                  class="img"
                  :src="require('../assets/biaoti.png')"
                  alt=""
                />
              </div>
            </div>
            <div class="photo-item">
              <div
                @mousedown="handleStarSelect()"
                @click="addStar()"
                class="look"
              >
                <img class="img" :src="require('../assets/rant.png')" alt="" />
              </div>
            </div>
            <div v-for="(item, index) in imgs" :key="index" class="back-item">
              <div v-if="pasterType != 3" class="back">
                <img
                  ref="paster"
                  @mousedown="handleSelectPhotoUrl(item.paster, index)"
                  @mouseup="mouseUpPhoto(item.paster)"
                  @click="addPhoto2(item.paster)"
                  class="img"
                  :src="item.paster"
                  alt=""
                />
              </div>
              <div v-if="pasterType == 3" class="back">
                <img
                  ref="paster"
                  @mousedown="handleSelectPhotoUrl(item.img_personal)"
                  @mouseup="mouseUpPhoto(item.img_personal)"
                  @click="addPhoto2(item.img_personal)"
                  class="img"
                  :src="item.img_personal"
                  alt=""
                />
              </div>
              <!-- <div class="name">{{ item.name }}</div> -->
            </div>
            <a-empty
              description="暂无内容"
              v-show="imgs.length == 0"
              style="margin-top: 10px; width: 100%"
            />
            <div class="pagebox">
              <a-pagination
                show-quick-jumper
                show-less-items
                size="small"
                :defaultPageSize="16"
                :current="imgPage.current_page"
                :total="imgPage.total"
                @change="onChangeImgPage"
              />
            </div>
          </div>
          <div class="cell" onselectstart="return false" v-if="tabIndex == 3">
            <div class="photo-item">
              <div
                @mousedown="handleSelectText()"
                @click="addText()"
                class="look"
              >
                <img
                  class="img"
                  :src="require('../assets/biaoti.png')"
                  alt=""
                />
              </div>
              <div class="name">文本框</div>
            </div>
            <div class="photo-item">
              <div
                @mousedown="handleStarSelect()"
                @click="addStar()"
                class="look"
              >
                <img
                  class="img"
                  :src="require('../assets/biaoti.png')"
                  alt=""
                />
              </div>
              <div class="name">文本框</div>
            </div>
          </div>
          <div
            class="cell photo-box"
            onselectstart="return false"
            v-if="tabIndex == 4"
          >
            <div class="searchbox">
              <a-select
                style="width: 120px; margin-left: 10px"
                v-model="frameType"
                @change="changeFrameType"
              >
                <a-select-option :value="1">通用相框</a-select-option>
                <a-select-option :value="2">专属相框</a-select-option>
              </a-select>
              <a-input-search
                placeholder="搜索名称"
                v-model="frameTag"
                enter-button
                @search="onSearchphotos"
              />
            </div>
            <div
              v-for="(item, index) in suireList"
              :key="'squire' + index"
              class="photo-item"
            >
              <div
                @mousedown="handleAddSquire(index)"
                @click="addSquire(index)"
                class="look"
                draggable="true"
                :style="{
                  border: '1px solid #eee',
                  backgroundColor: '#eeeeee',
                }"
              >
                <div
                  :style="{
                    width: '100%',
                    height: (item.height * 100) / item.width + 'px',
                    paddingLeft: item.paddingLeft + 'px',
                    paddingTop: item.paddingTop + 'px',
                    paddingRight: item.paddingRight + 'px',
                    paddingBottom: item.paddingBottom + 'px',
                    backgroundColor: item.bColor,
                    borderRadius: item.borderRadius + 'px',
                    borderColor: item.bordersColor,
                    borderStyle: item.bStyle,
                    borderTopWidth: item.bTop + 'px',
                    borderBottomWidth: item.bBottom + 'px',
                    borderLeftWidth: item.bLeft + 'px',
                    borderRightWidth: item.bRight + 'px',
                  }"
                ></div>
              </div>
            </div>
            <div
              v-for="(item, index) in photos"
              :key="index"
              class="photo-item"
            >
              <div
                @mousedown="handleSelectPhoto2(item, index)"
                @click="addPhoto(item)"
                :style="item"
                class="look"
              >
                <img
                  ref="frame"
                  :style="{ borderRadius: item.borderRadius }"
                  class="img"
                  :src="item.backgroundImg"
                  alt=""
                />
                <img
                  v-if="item.backImg2"
                  class="img2"
                  :src="item.backImg2"
                  alt=""
                />
              </div>
              <!-- <div class="name">{{ item.name }}</div> -->
            </div>
            <div class="pagebox">
              <a-pagination
                size="small"
                :defaultPageSize="14"
                :current="photoPage.current_page"
                :total="photoPage.total"
                show-quick-jumper
                show-less-items
                @change="onChangeframePage"
              />
            </div>
          </div>
          <div class="cell" onselectstart="return false" v-if="tabIndex == 5">
            <div class="searchbox">
              <a-select
                style="width: 120px; margin-left: 10px"
                v-model="backgroundType"
                @change="changeBackType"
              >
                <a-select-option :value="1">通用背景</a-select-option>
                <a-select-option :value="2">专属背景</a-select-option>
              </a-select>
              <a-input-search
                placeholder="搜索名称"
                v-model="backgroundTag"
                enter-button
                @search="onSearchbacks"
              />
            </div>
            <a-empty
              description="暂无内容"
              v-show="backs.length == 0"
              style="margin-top: 10px"
            />
            <div v-for="(item, index) in backs" :key="index" class="back-item">
              <div class="back">
                <img
                  @click="changeBack(item.background)"
                  class="img"
                  :src="item.background"
                  alt=""
                />
              </div>
              <!-- <div class="name">{{ item.name }}</div> -->
            </div>
            <div class="pagebox">
              <a-pagination
                size="small"
                :defaultPageSize="12"
                show-quick-jumper
                show-less-items
                :current="backPage.current_page"
                :total="backPage.total"
                @change="onChangeBackPage"
              />
            </div>
          </div>
          <div class="cell" onselectstart="return false" v-if="tabIndex == 6">
            <div class="searchbox">
              <a-select
                v-model="buildUpType"
                style="width: 120px; margin-left: 10px"
                @change="changeBuildType"
              >
                <a-select-option :value="1">通用组合</a-select-option>
                <a-select-option :value="2">专属组合</a-select-option>
              </a-select>
              <a-input-search
                placeholder="搜索名称"
                enter-button
                v-model="buildUpTag"
                @search="onSearchbuildup"
              />
            </div>
            <a-empty
              description="暂无内容"
              v-show="buildUp.length == 0"
              style="margin-top: 10px"
            />
            <div
              v-for="(build, index) in buildUp"
              :key="index"
              @click="selectBuildup(index)"
              class="build-item"
              draggable="true"
            >
              <div
                @mousedown="handleSelectCombination($event, index)"
                @mouseup="handleEndMovecom"
                ref="comItem"
                class="look"
              >
                <div
                  class="wrap"
                  :style="{
                    width: build.width + 'px',
                    height: build.height + 'px',
                    transform: `scale(${build.scale})`,
                  }"
                >
                  <vue-draggable-resizable
                    v-for="(item, index2) in build.coms"
                    :key="index2"
                    :w="item.width"
                    :h="item.height"
                    :x="item.left"
                    :y="item.top"
                    :r="item.rotate"
                    :z="item.zIndex"
                    :frameId="'buildup' + index + '_' + index2"
                    :photoScale="item.photoScale"
                    :photoLeft="item.photoLeft"
                    :photoTop="item.photoTop"
                    :showPhoto="item.showPhoto"
                    :shadow="item.shadow ? true : false"
                    :allIndex="allIndex"
                    :dIndex="index"
                    :debug="false"
                    :disable="true"
                    :lineHeight="item.lineHeight"
                    :fontWeight="item.fontWeight"
                    :fontStyle="item.fontStyle"
                    :textAlign="item.textAlign"
                    :type="item.type"
                    :isConflictCheck="false"
                    :snap="true"
                    :snapTolerance="1"
                    :lockAspectRatio="item.lockAspectRatio ? true : false"
                    :backImg="item.backgroundImg ? item.backgroundImg : ''"
                    :bImg2="item.backImg2"
                    :bRadius="item.borderRadius"
                    :fontColor="item.fColor"
                    :text="item.textarea"
                    :o="item.opacity"
                    :l="item.lock ? true : false"
                    dragHandle="false"
                    :backColor="item.bColor"
                    :borderColor="item.bordersColor"
                    :borderLeft="item.bLeft"
                    :borderTop="item.bTop"
                    :borderRight="item.bRight"
                    :borderBottom="item.bBottom"
                    :borderStyle="item.bStyle"
                    :paddingLeft="item.paddingLeft"
                    :paddingTop="item.paddingTop"
                    :paddingRight="item.paddingRight"
                    :paddingBottom="item.paddingBottom"
                    :active="false"
                    :fontSize="item.fSize"
                  >
                  </vue-draggable-resizable>
                </div>
              </div>
              <!-- <div class="name">{{ index }}</div> -->
            </div>
            <div class="pagebox">
              <a-pagination
                size="small"
                show-quick-jumper
                show-less-items
                :defaultPageSize="15"
                :current="buildUpPage.current_page"
                :total="buildUpPage.total"
                @change="onChangeBuildPage"
              />
            </div>
          </div>
          <div class="cell" style="width: 100%" v-if="tabIndex == 7">
            <div class="edit-list">
              <div
                v-for="(item, index) in editList"
                :key="index"
                class="edit-cell"
              >
                <div class="name">{{ item.student_name }}</div>
                <a-textarea
                  v-if="item.type == 1 || item.type == 0"
                  v-model="item.textarea"
                  @blur="pressEnter($event, index)"
                  @focus="editorFocus($event, index)"
                  @change="changeEditText($event, index)"
                ></a-textarea>
              </div>
            </div>
          </div>
          <div
            class="fixbtn"
            style="position: fixed;right: 10px;bottom: 100px;"
          >
            <!-- <div class="flex-row">
            <div @click="cancelStep" alt="ctrl+z" class="item">
              <a-tooltip placement="bottom">
                <template #title>
                  <span>ctrl+z</span>
                </template>
                <a-icon
                  :style="{ fontSize: '28px', color: '#1890ff' }"
                  type="swap-left"
                />
                <div class="name">撤销</div>
              </a-tooltip>
            </div>
            <div
              @click="nextStep"
              alt="ctrl+shift+z"
              class="item"
              style="margin-left:16px"
            >当前suo
              <a-tooltip placement="bottom">
                <template #title>
                  <span>ctrl+shift+z</span>
                </template>
                <a-icon
                  :style="{ fontSize: '28px', color: '#1890ff' }"
                  type="swap-right"
                />
                <div class="name">前进</div>
              </a-tooltip>
            </div>
          </div> -->
            <!-- <div class="step">
            <div class="num">当前{{ step }}步</div>
            <div v-for="(item, index) in czHistory" :key="index">
              <div class="index">第{{ index }}步</div>
              <div class="type">{{ czHistory[index].type }}</div>
            </div>
          </div> -->
            <!-- <a-button @click="savePlateContent" type="primary">保存此页</a-button>
          <a-button @click="delPlateContent" type="default">删除此页</a-button> -->
          </div>
        </div>
      </div>
    </a-drawer>
    <a-modal
      v-model="showTypeSelect"
      title="选择新增内容"
      centered
      width="800px"
      @ok="confirmPageType"
    >
      <a-radio-group
        v-show="!pageObject"
        v-model="addType"
        @change="changeAddtype"
        style="margin-bottom: 20px"
      >
        <a-radio key="0" value="">页面</a-radio>
        <a-radio key="3" value="3">封面模板</a-radio>
        <a-radio key="1" value="1">完整模板</a-radio>
      </a-radio-group>

      <a-select
        v-if="!addType"
        style="width: 100%"
        v-model="typeSelect"
        @change="changePage"
      >
        <a-select-option
          v-for="item in typeSelector"
          :key="item.type"
          :value="item.type"
          >{{ item.name }}
        </a-select-option>
      </a-select>

      <div v-if="addType" class="plate">
        <div class="search">
          <a-input-search
            placeholder="输入模板名称搜索"
            v-model="plate_name"
            enter-button
            @search="onPlateSearch"
          >
          </a-input-search>
        </div>
        <a-empty
          description="暂无内容"
          style="margin-top: 20px"
          v-show="plateList.length == 0"
        />
        <div v-show="plateList.length > 0" class="plate-list">
          <div
            @click="selectPlate(index)"
            :class="item.select ? 'select' : ''"
            v-for="(item, index) in plateList"
            :key="index"
            :style="{
              backgroundImage: 'url(' + item.cover + ')',
              backgroundSize: 'contain',
            }"
            class="cell"
          >
            <div class="name">{{ item.name }}</div>
          </div>
        </div>
        <div
          v-show="plateList.length > 0"
          class="page"
          style="clear: both; overflow: hidden; margin-top: 20px"
        >
          <a-pagination
            show-quick-jumper
            show-less-items
            size="small"
            style="float: right"
            :current="currentPage"
            :total="plateTotal"
            :defaultPageSize="10"
            @change="onChangePlatePage"
          />
        </div>
      </div>
    </a-modal>
    <div
      @click="lockPage"
      style="position: fixed;right: 6px;top:70px;width: 60px;height: 60px;z-index: 90;"
      class="fixed-b-icon"
    >
      <i
        class="miconfont"
        style="font-size: 18px;"
        :class="pageDetail.is_locked ? 'icon-suoding' : 'icon-jiesuo'"
      ></i>
      <div class="name" style="margin-top: -4px;font-size: 12px;">页面</div>
    </div>
    <a-modal
      :visible="uploadModal"
      centered
      :title="'添加照片'"
      width="1180px"
      footer=""
      @cancel="uploadModal = false"
    >
      <div class="photos">
        <a-upload-dragger
          name="file"
          list-type="picture-card"
          :multiple="true"
          accept="image/jpeg,image/png,image/gif,image/bmp,image/heic,.jpg,.jpeg,.png,.gif,.bmp,.heic"
          :file-list="fileList"
          :action="$api.domain + $api.addPhoto"
          :before-upload="beforeUpload"
          capture="gallery"
          @preview="handlePreview"
          @change="handleuploadChange"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">
            点击或者拖拽图片到此处
          </p>
        </a-upload-dragger>
        <div v-if="errorUploadState" style="text-align:right">
          <a-space>
            <a-button @click="cancelUpload">
              取消添加
            </a-button>
            <a-button @click="confirmUpload" type="primary">
              忽略并添加相册
            </a-button>
          </a-space>
        </div>
      </div>
    </a-modal>
    <!-- <a-modal
        title="页码"
        width="100%"
        :dialog-style="{ bootom: '0px', margin: 0, left: '0px' }"
        :visible="pageModal"
        :centered="false"
        :mask="false"
        @cancel="pageModal = false"
        footer=""
      >
        <div v-if="pages.length > 0" class="page-list">
          <div
            @click="changeGrowPage(index)"
            v-for="(pageitem, index) in pages2"
            :key="pageitem.c_id"
            class="cell"
          >
            <div
              class="dragbox"
              :style="{ height: (750 * 120) / wrapperWidth + 'px' }"
            >
              <div
                class="wrapper"
                :style="{
                  transform: `scale(${(750 * 120) / wrapperWidth / 750})`,
                }"
              >
                <div
                  class="wrap2"
                  :style="{
                    width: wrapperWidth + 'px',
                    height: 750 + 'px',
                    backgroundImage: 'url(' + pageitem.img_bg + ')',
                    backgroundSize: '100% 100%',
                    backgroundColor: '#cccccc',
                  }"
                >
                  <vue-draggable-resizable
                    v-for="(item, index2) in pageitem.content"
                    :key="item.ec_id"
                    :w="item.width"
                    :h="item.height"
                    :enableNativeDrag="true"
                    :x="item.left"
                    :y="item.top"
                    :r="item.rotate"
                    :z="item.zIndex"
                    :levelType="item.levelType"
                    :frameId="'item' + index + index2"
                    :photoScale="item.photoScale"
                    :photoLeft="item.photoLeft"
                    :photoTop="item.photoTop"
                    :showPhoto="item.showPhoto"
                    :shadow="item.shadow ? true : false"
                    :allIndex="allIndex"
                    :dIndex="index"
                    :debug="false"
                    :disable="true"
                    :lineHeight="item.lineHeight"
                    :fontWeight="item.fontWeight"
                    :fontStyle="item.fontStyle"
                    :textAlign="item.textAlign"
                    :type="item.type"
                    :isConflictCheck="false"
                    :snap="true"
                    :snapTolerance="1"
                    :lockAspectRatio="item.lockAspectRatio ? true : false"
                    :backImg="item.backgroundImg ? item.backgroundImg : ''"
                    :bImg2="item.backImg2"
                    :bRadius="item.borderRadius"
                    :fontColor="item.fColor"
                    :text="item.textarea"
                    :o="item.opacity"
                    :l="item.lock ? true : false"
                    dragHandle="false"
                    :backColor="item.bColor"
                    :borderColor="item.bordersColor"
                    :borderLeft="item.bLeft"
                    :borderTop="item.bTop"
                    :borderRight="item.bRight"
                    :borderBottom="item.bBottom"
                    :borderStyle="item.bStyle"
                    :paddingLeft="item.paddingLeft"
                    :paddingTop="item.paddingTop"
                    :paddingRight="item.paddingRight"
                    :paddingBottom="item.paddingBottom"
                    :active="false"
                    :fontSize="item.fSize"
                  >
                    <div v-if="item.type == 3" class="look" style="z-index:-1">
                      <div
                        class="wrap"
                        :style="{
                          width: item.width + 'px',
                          height: item.height + 'px',
                          transform: `scale(${item.width /
                            item.orignWidth},${item.height /
                            item.orignHeight})`,
                          transformOrigin: '0px 0px',
                        }"
                      >
                        <vue-draggable-resizable
                          v-for="(item2, index2) in item.coms"
                          :key="index2"
                          :w="item2.width"
                          :h="item2.height"
                          :x="item2.left"
                          :y="item2.top"
                          :r="item2.rotate"
                          :z="item2.zIndex"
                          :showPhoto="item2.showPhoto"
                          :shadow="item2.shadow ? true : false"
                          :allIndex="allIndex"
                          :dIndex="index"
                          :debug="false"
                          :disable="true"
                          :lineHeight="item2.lineHeight"
                          :fontWeight="item2.fontWeight"
                          :fontStyle="item2.fontStyle"
                          :textAlign="item2.textAlign"
                          :type="item2.type"
                          :isConflictCheck="false"
                          :snap="true"
                          :snapTolerance="1"
                          :lockAspectRatio="
                            item2.lockAspectRatio ? true : false
                          "
                          :backImg="
                            item2.backgroundImg ? item2.backgroundImg : ''
                          "
                          :bImg2="item2.backImg2"
                          :bRadius="item2.borderRadius"
                          :fontColor="item2.fColor"
                          :text="item2.textarea"
                          :o="item2.opacity"
                          :l="item2.lock ? true : false"
                          dragHandle="false"
                          :backColor="item2.bColor"
                          :borderColor="item2.bordersColor"
                          :borderLeft="item2.bLeft"
                          :borderTop="item2.bTop"
                          :borderRight="item2.bRight"
                          :borderBottom="item2.bBottom"
                          :borderStyle="item2.bStyle"
                          :paddingLeft="item2.paddingLeft"
                          :paddingTop="item2.paddingTop"
                          :paddingRight="item2.paddingRight"
                          :paddingBottom="item2.paddingBottom"
                          :active="false"
                          :fontSize="item2.fSize"
                        ></vue-draggable-resizable>
                      </div>
                    </div>
                  </vue-draggable-resizable>
                </div>
              </div>
            </div>
            <div class="name">
              {{
                pageitem.type == 1
                  ? "封面"
                  : pageitem.type == 3
                  ? "封底"
                  : pageitem.page_num
              }}
            </div>
          </div>
        </div>
      </a-modal> -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <div style="padding: 20px">
        <img alt="example" style="width: 100%" :src="previewImage" />
      </div>
    </a-modal>
    <!-- <a-modal
      :visible="eiditVisible"
      width="100%"
      centered
      @ok="confirmEdit"
      @cancel="handleCancelEdit"
    >
      <div style="padding:10px 0 0 0;height:380px;">
        <quill-editor
          v-model="editText"
          ref="myQuillEditor"
          :options="editorOption"
          @blur="onEditorBlur($event)"
          @focus="onEditorFocus($event)"
          @change="onEditorChange($event)"
        >
        </quill-editor>
      </div>
    </a-modal> -->
  </div>
</template>

<script>
import VueDraggableResizable from "../components/vue-draggable-resizable";
import "../components/vue-draggable-resizable.css";
import axios from "axios";
import { api } from "../api/api.js";
import _ from "lodash";
import { mapState } from "vuex";
import * as Quill from "vue-quill-editor";
import html2canvas from "html2canvas";
import { addQuillTitle } from "../js/quill-title.js";
import { EventBus } from "../utils/eventBus.js";
function getBlob(canvas) {
  //获取blob对象
  var data = canvas.toDataURL("image/png", 1);
  data = data.split(",")[1];
  data = window.atob(data);
  var ia = new Uint8Array(data.length);
  for (var i = 0; i < data.length; i++) {
    ia[i] = data.charCodeAt(i);
  }

  return new Blob([ia], {
    type: "image/jpeg",
  });
}

export default {
  name: "app",
  components: {
    VueDraggableResizable,
  },
  data() {
    return {
      dragKey: 1,
      pageDetail: { is_locked: 0 },
      moveMode: false,
      pasterClass: [],
      pasterClassId: "",
      previewFrame: false,
      moreSelect: false, //苹果电脑多选控制
      editContent: "",
      eiditVisible: false,
      editText: "",
      editorOption2: {
        placeholder: "请在这里输入",
        modules: {
          toolbar: [],
        },
      },
      visible: false,
      editorOption: {
        placeholder: "请在这里输入",
        modules: {
          toolbar: [],
        },
      },
      previewImage: "",
      previewVisible: false,
      uploadModal: false,
      fileList: [],
      addType: "",
      step: -1,
      frameTag2: "",
      sizeSelct: 100,
      saveDraging: false,
      comHtml: null,
      showTypeSelect: false,
      album_id: "",
      typeSelector: [
        { type: 1, name: "封面" },
        { type: 2, name: "内页" },
        { type: 3, name: "封底" },
      ],
      activeIndex: -1,
      drags: [],
      studentVisible: false,
      vLine: [],
      hLine: [],
      kongwei: false,
      tabIndex: 1,
      photoLoading: false,
      imgs: [
        { url: require("../assets/img01.png"), name: "背景1" },
      ],
      pullPhotoState: false,
      suireList: [
        {
          left: null,
          top: null,
          width: 240,
          height: 180,
          rotate: 0,
          lockAspectRatio: false,
          aspectFactor: null,
          textarea: "",
          minW: null,
          minH: null,
          backgroundImg: "",
          maxW: null,
          maxH: null,
          lock: false,
          zIndex: null,
          bColor: "#cccccc",
          fColor: null,
          fSize: 14,
          lHeight: 18,
          bordersColor: "#ffffff",
          bLeft: 5,
          bTop: 5,
          bRight: 5,
          bBottom: 5,
          bStyle: "solid",
          paddingLeft: 0,
          paddingTop: 0,
          paddingRight: 0,
          paddingBottom: 0,
          opacity: 100,
          shadow: false,
          active: false,
          type: 9,
          name: "方块一",
          lineHeight: "18",
          fontStyle: "horizontal-tb",
          fontWeight: "normal",
          textAlign: "left",
          borderRadius: 0,
        },
        {
          left: null,
          top: null,
          width: 240,
          height: 180,
          rotate: 0,
          lockAspectRatio: false,
          aspectFactor: null,
          textarea: "",
          minW: null,
          minH: null,
          backgroundImg: "",
          maxW: null,
          maxH: null,
          lock: false,
          zIndex: null,
          bColor: "#cccccc",
          fColor: null,
          fSize: 14,
          lHeight: 18,
          bordersColor: "#ffffff",
          bLeft: 0,
          bTop: 0,
          bRight: 0,
          bBottom: 0,
          bStyle: "solid",
          paddingLeft: 0,
          paddingTop: 0,
          paddingRight: 0,
          paddingBottom: 0,
          opacity: 100,
          shadow: false,
          active: false,
          type: 9,
          name: "方块一",
          lineHeight: "18",
          fontStyle: "horizontal-tb",
          fontWeight: "normal",
          textAlign: "left",
          borderRadius: 0,
        },
        {
          left: null,
          top: null,
          width: 160,
          height: 208,
          rotate: 0,
          lockAspectRatio: false,
          aspectFactor: null,
          textarea: "",
          minW: null,
          minH: null,
          backgroundImg: "",
          maxW: null,
          maxH: null,
          lock: false,
          zIndex: null,
          bColor: "#cccccc",
          fColor: null,
          fSize: 14,
          lHeight: 18,
          bordersColor: "#ffffff",
          bLeft: 5,
          bTop: 5,
          bRight: 5,
          bBottom: 5,
          bStyle: "solid",
          paddingLeft: 0,
          paddingTop: 0,
          paddingRight: 0,
          paddingBottom: 0,
          opacity: 100,
          shadow: false,
          active: false,
          type: 9,
          name: "方块一",
          lineHeight: "18",
          fontStyle: "horizontal-tb",
          fontWeight: "normal",
          textAlign: "left",
          borderRadius: 0,
        },
        {
          left: null,
          top: null,
          width: 160,
          height: 208,
          rotate: 0,
          lockAspectRatio: false,
          aspectFactor: null,
          textarea: "",
          minW: null,
          minH: null,
          backgroundImg: "",
          maxW: null,
          maxH: null,
          lock: false,
          zIndex: null,
          bColor: "#cccccc",
          fColor: null,
          fSize: 14,
          lHeight: 18,
          bordersColor: "#ffffff",
          bLeft: 0,
          bTop: 0,
          bRight: 0,
          bBottom: 0,
          bStyle: "solid",
          paddingLeft: 0,
          paddingTop: 0,
          paddingRight: 0,
          paddingBottom: 0,
          opacity: 100,
          shadow: false,
          active: false,
          type: 9,
          name: "方块一",
          lineHeight: "18",
          fontStyle: "horizontal-tb",
          fontWeight: "normal",
          textAlign: "left",
          borderRadius: 0,
        },
        {
          left: null,
          top: null,
          width: 180,
          height: 180,
          rotate: 0,
          lockAspectRatio: true,
          aspectFactor: null,
          textarea: "",
          minW: null,
          minH: null,
          backgroundImg: "",
          maxW: null,
          maxH: null,
          lock: false,
          zIndex: null,
          bColor: "#cccccc",
          fColor: null,
          fSize: 14,
          lHeight: 18,
          bordersColor: "#ffffff",
          bLeft: 5,
          bTop: 5,
          bRight: 5,
          bBottom: 5,
          bStyle: "solid",
          paddingLeft: 0,
          paddingTop: 0,
          paddingRight: 0,
          paddingBottom: 0,
          opacity: 100,
          shadow: false,
          active: false,
          type: 9,
          name: "方块一",
          lineHeight: "18",
          fontStyle: "horizontal-tb",
          fontWeight: "normal",
          textAlign: "left",
          borderRadius: 1200,
        },
        {
          left: null,
          top: null,
          width: 180,
          height: 180,
          rotate: 0,
          lockAspectRatio: true,
          aspectFactor: null,
          textarea: "",
          minW: null,
          minH: null,
          backgroundImg: "",
          maxW: null,
          maxH: null,
          lock: false,
          zIndex: null,
          bColor: "#cccccc",
          fColor: null,
          fSize: 14,
          lHeight: 18,
          bordersColor: "#ffffff",
          bLeft: 0,
          bTop: 0,
          bRight: 0,
          bBottom: 0,
          bStyle: "solid",
          paddingLeft: 0,
          paddingTop: 0,
          paddingRight: 0,
          paddingBottom: 0,
          opacity: 100,
          shadow: false,
          active: false,
          type: 9,
          name: "方块一",
          lineHeight: "18",
          fontStyle: "horizontal-tb",
          fontWeight: "normal",
          textAlign: "left",
          borderRadius: 1200,
        },
      ],
      photoPage2: null,
      photos2: [],
      stars: {
        left: null,
        top: null,
        width: 200,
        height: 38,
        rotate: 0,
        lockAspectRatio: false,
        aspectFactor: null,
        textarea: "",
        minW: null,
        minH: null,
        backgroundImg: "",
        maxW: null,
        maxH: null,
        lock: false,
        zIndex: null,
        bColor: "",
        fColor: "#ff6d2c",
        fSize: 14,
        lHeight: 18,
        bordersColor: "",
        bLeft: 0,
        bTop: 0,
        bRight: 0,
        bBottom: 0,
        bStyle: "solid",
        paddingLeft: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        opacity: 100,
        shadow: false,
        active: false,
        borderRadius: 0,
        type: 4,
        name: "评级",
        lineHeight: "1.6",
        fontStyle: "horizontal-tb",
        fontWeight: "normal",
        textAlign: "left",
        levelNum: 3,
        levelType: 1,
        level: 2,
      },
      texts: {
        left: null,
        top: null,
        width: 200,
        height: 28,
        rotate: 0,
        lockAspectRatio: false,
        aspectFactor: null,
        textarea: "",
        minW: null,
        minH: null,
        backgroundImg: "",
        maxW: null,
        maxH: null,
        lock: false,
        zIndex: null,
        bColor: "",
        fColor: null,
        fSize: 14,
        lHeight: 18,
        textIndent: 0,
        writeMode: "horizontal-tb",
        bordersColor: "",
        bLeft: 0,
        bTop: 0,
        bRight: 0,
        bBottom: 0,
        bStyle: "solid",
        paddingLeft: 5,
        paddingTop: 5,
        paddingRight: 5,
        paddingBottom: 5,
        opacity: 100,
        shadow: false,
        active: false,
        borderRadius: 0,
        type: 5,
        name: "文字框",
        lineHeight: "18",
        fontStyle: "horizontal-tb",
        fontWeight: "normal",
        textAlign: "left",
      },
      selectHeight: 0,
      photoPage: null,
      imgPage: null,
      backPage: null,
      photos: [],
      pictures: [],
      backs: [],
      typeSelect: 2,
      currentBuild: 1,
      currentPaster: 1,
      currentPhoto: 1,
      currentBack: 1,
      currentFrame: 1,
      currentPicture: 1,
      api: api,
      fixBtnLeft: 0,
      pageModal: false,
      buildUp: [],
      buildUpPage: null,
      backgroundImage: "",
      allIndex: 0,
      wrapperWidth: 500,
      mouseIn: [],
      selectImg: "",
      maxPage: 0,
      selectPhoto: null,
      pageObject: null,
      selectPageType: 2,
      currentRowPage: 0,
      plateContent: null,
      czHistory: [],
      originDrags: [],
      ComIndex: -1, //拖动的组合
      bodyTranslateX: 0,
      bodyTranslateY: 0,
      leftChatMouseStateMove: false,
      uid: "",
      htmlUrl: "",
      plate_name: "",
      pages2: [],
      currentPage: 1,
      plateList: [],
      plateTotal: 0,
      s_id: "",
      studentList: [],
      pages: [],
      currentStudentIndex: -1,
      selectState: false,
      backgroundTag: "",
      frameTag: "",
      frameType: 1,
      frameType2: 1,
      buildUpType: 1,
      pasterType: 1,
      backgroundType: 1,
      buildUpTag: "",
      pasterTag: "",
      editList: [],
      errorUploadState: false,
      albumList: [],
      picturePage: null,
      pageLists: [],
      haomi: 0,
      studentName: "",
      page: 0,
      cover_size: [],
      editorState: false,
      moveBoxRight: 0,
      moveBoxTop: 0,
      itemIndex: 0,
      moveBoxRotate: 0,
      rotateStyles: { left: 0, top: 0 },
      showDraw: "",
      textarea1: "",
      drawTitle: "页码",
      showDzDraw: false,
      changePhotoState: false,
      class_id: "",
    };
  },
  mounted() {
    window.addEventListener("beforeunload", this.updateHandler);
    var that = this;
    document.ondragover = function(e) {
      e.preventDefault();
    };
    // setTimeout(() => {
    //   this.saveHistoryChange();
    // }, 10000);
    this.$refs["body"].addEventListener(
      "mouseenter",
      (e) => {
        this.mouseEnterBody = true;
      },
      true
    );
    this.$refs["body"].addEventListener(
      "mouseleave",
      (e) => {
        this.mouseEnterBody = false;
      },
      true
    );
    this.$refs["body"].addEventListener("drop", (e) => {
      e.stopPropagation();
      e.preventDefault();
      console.log(this.selectPhoto);
      if (this.selectImg) {
        setTimeout(() => {
          this.selectImg = "";
        }, 20);
      } else if (this.selectPhoto || this.ComIndex > -1) {
        this.addDrag(e);
      }
    });
    this.$refs["app"].addEventListener("drop", (e) => {
      setTimeout(() => {
        this.ComIndex = -1;
        this.selectPhoto = null;
        this.selectImg = "";
      }, 400);
    });
    setTimeout(() => {
      this.allIndex = this.drags.length;
    }, 1000);
    var that = this;
    document.onerror = function(e) {
      console.log(e);
    };
  },
  computed: {
    ...mapState(["headers", "userInfo", "fonts", "netWork"]),
    studentNum() {
      let num = -1;
      this.studentList.forEach((arr) => {
        if (arr.select) num++;
      });
      return num;
    },
    leftChatStyle() {
      return {
        cursor: this.leftChatMouseStateMove ? "grab" : "auto",
      };
    },
    style3() {
      return {
        fontFamily: this.drags[this.activeIndex].fontFamily,
        fontWeight: this.drags[this.activeIndex].fontWeight,
        writingMode: this.drags[this.activeIndex].writingMode,
        webkitWritingMode: this.drags[this.activeIndex].writingMode,
        fontStyle: this.drags[this.activeIndex].fontStyle,
        textDecoration: this.drags[this.activeIndex].textDecoration,
        lineHeight:
          this.drags[this.activeIndex].lineHeight < 5
            ? this.drags[this.activeIndex].lineHeight
            : this.drags[this.activeIndex].lineHeight + "px",
        textAlign: this.drags[this.activeIndex].textAlign,
        color: this.drags[this.activeIndex].fColor,
        textIndent: this.drags[this.activeIndex].textIndent + "em",
        outline: "none",
        fontSize:
          this.drags[this.activeIndex].fSize != 0
            ? this.drags[this.activeIndex].fSize + "px"
            : "",
      };
    },
    tabTitle() {
      switch (this.tabIndex) {
        case 0:
          return "照片";
          break;
        case 1:
          return "照片";
          break;
        case 2:
          return "素材";
          break;
        case 4:
          return "相框";
          break;
        case 5:
          return "背景";
          break;
        case 6:
          return "组合";
          break;
        default:
          break;
      }
    },
    style() {
      return {
        fontFamily: this.drags[this.activeIndex].fontFamily,
        fontWeight: this.drags[this.activeIndex].fWeight,
        writingMode: this.drags[this.activeIndex].fStyle,
        webkitWritingMode: this.drags[this.activeIndex].fStyle,
        lineHeight:
          this.drags[this.activeIndex].lHeight < 5
            ? this.drags[this.activeIndex].lineHeight
            : this.drags[this.activeIndex].lHeight + "px",
        textAlign: this.drags[this.activeIndex].tAlign,
        color: this.drags[this.activeIndex].fColor,
        outline: "none",
        fontSize:
          this.drags[this.activeIndex].fSize != 0
            ? this.drags[this.activeIndex].fSize + "px"
            : "",
      };
    },
    moveBoxStyle() {
      return {
        top: this.moveBoxTop + "px",
        left: this.moveBoxRight + "px",
        transform: `rotate(${this.moveBoxRotate}deg)`,
        transformOrigin: `${this.transformX}px ${this.transformY}px`,
      };
    },
    rotateStyle() {
      return {
        top: this.rotateStyles.top - 66 + "px",
        left: this.rotateStyles.left + "px",
        transform: `rotate(${this.moveBoxRotate}deg)`,
        transformOrigin: `${this.rotateStyles.rotateX}px ${this.rotateStyles
          .rotateY + 66}px`,
      };
    },
    showEditButton() {
      if (this.activeIndex > -1) {
        if (this.drags[this.activeIndex].type == 0) {
          return true;
        } else if (
          this.drags[this.activeIndex].type == 1 ||
          this.drags[this.activeIndex].type == 9
        ) {
          if (this.drags[this.activeIndex].textarea != "") {
            return true;
          } else {
            return false;
          }
        }
      } else {
        return false;
      }
    },

    wrapperStyle() {
      return {
        // width: this.wrapperWidth + "px",
        // height: 750 + "px",
        // transform: `scale(${this.sizeSelct / 100}) translate(${
        //   this.bodyTranslateX
        // }px,${this.bodyTranslateY}px)`,
        width: this.wrapperWidth + "px",
        height: 750 + "px",
        transform: `scale(${this.scaleP}) `,
      };
    },
    leftBtnStyle() {
      return {
        right: 400 + "px",
        top: 120 + "px",
      };
    },
  },
  created() {
    this.studentName = this.$route.query.name;
    this.guc_id = this.$route.params.guc_id;
    this.class_id = this.$route.params.class_id;
    if (!this.class_id) {
      this.$message.error("未获取到班级id");
      return false;
    }
    if (localStorage.getItem("s_id")) {
      this.s_id = this.$route.params.s_id
        ? this.$route.params.s_id
        : localStorage.getItem("s_id");
    } else {
      this.s_id = this.$route.params.s_id;
    }
    this.page = parseInt(this.$route.query.page)
      ? parseInt(this.$route.query.page)
      : 0;
    // if (localStorage.getItem("student_name")) {
    //   this.studentName = localStorage.getItem("student_name");
    // }
    // if (localStorage.getItem("page")) {
    //   this.page = localStorage.getItem("page");
    // }
    if (this.headers) {
      this.studentName = this.$route.query.name;
      this.guc_id = this.$route.params.guc_id;
      this.class_id = this.$route.params.class_id;
      if (!this.class_id) {
        this.$message.error("未获取到班级id");
        return false;
      }
      EventBus.$emit('getFonts')
      this.getStudent();
      this.getGrowupDetail();
      this.getFrame();
      this.getFrame2();
      this.getPasterClass();
      this.getPaster();
      this.getBackground();
      this.getBuiltUp();
      this.checkCompleteTask = setInterval(() => {
        this.checkComplete();
      }, 120000);
    }
    this.timeIndex = setInterval(() => {
      if (this.activeIndex > -1) {
        this.$refs.drag[this.activeIndex].activeDrag();
      }
    }, 1000);
  },
  watch: {
    $route() {
      setTimeout(() => {
        document.title = this.studentName + "-成长册编辑";
      }, 20);
    },
    showDraw(val) {
      if ((val == "edit" || val == "allEdit") && this.activeIndex > -1) {
        let arr = [];
        this.drags[this.activeIndex].textarea
          .split("<br/>")
          .forEach((item) => arr.push(`${item.trim()}`));
        this.editText = arr.join("\n");
        this.confirmEdit();
      }
      if (!val) {
        this.itemIndex = 0;
      }
    },
    textarea1(val) {
      console.log(JSON.stringify(val));
    },
    netWork(val) {
      if (val == 0) {
        this.$message.info("网络已断开");
      } else if (val == 1) {
        this.$message.info("当前网络状态较差");
      }
    },
    drags() {
      // this.$forceUpdate()
    },
    editorState(val) {
      console.log(val);
    },
    s_id() {
      localStorage.setItem("s_id", this.s_id);
    },
    studentName() {
      console.log("locstudent" + this.studentName);
      localStorage.setItem("student_name", this.studentName);
      document.title = this.studentName + "-成长册编辑";
    },
    page() {
      localStorage.setItem("page", this.page);
    },
    fonts(val) {},
    pageModal(val) {
      this.showDzDraw = true;
      this.drawTitle = this.studentName + "-页码";

      if (!val) {
        this.$router.back();
        // this.getGrowPages();
      }
    },
    czHistory(val) {
      // this.historyChangeState = true;
      if (val.length > 20) {
        this.step--;
        this.czHistory.splice(0, 1);
      }
    },
    step() {
      // this.historyChangeState = true;
    },
    headers(val) {
      if (val) {
        EventBus.$emit('getFonts')
        this.getStudent();
        this.getGrowupDetail();
        this.getFrame();
        this.getFrame2();
        this.getPasterClass();
        this.getPaster();
        this.getBackground();
        this.getBuiltUp();
        this.getAlbum();
        this.checkCompleteTask = setInterval(() => {
          this.checkComplete();
        }, 120000);
      }
    },
  },
  beforeDestroy() {
    this.uploadWaitDrag();
    clearTimeout(this.saveTimeout);
    clearTimeout(this.pagesTime);
    localStorage.removeItem("s_id");
    localStorage.removeItem("student_name");
    localStorage.removeItem("page");
    clearInterval(this.checkCompleteTask);
    clearInterval(this.timeIndex);
    // this.changeBack('https://grow-up.obs.cn-east-3.myhuaweicloud.com:443/2021-09-13/2a754ae4cf2bf825b27d7681a2ab9c76.png')
  },
  methods: {
    handleUnlock(index) {
      this.drags[index].lock = false;
    },
    selectionChange(range, oldRange, source) {
      console.log(range, oldRange, source);
    },
    Nedit() {
      this.showDraw = "edit";
      this.editText = this.drags[this.activeIndex].textarea;
    },
    onClose() {
      this.showDraw = "";
    },
    onSearchphotos2(e) {
      this.frameTag2 = e;
      this.currentFrame2 = 1;
      this.getFrame2();
    },
    Nexchange() {
      this.showDraw = "allEdit";
    },
    NlineHeight() {
      this.showDraw = "lineHeight";
    },
    NwriteMode() {
      this.showDraw = "writingMode";
    },
    Nshow() {},
    Ndel() {},
    NshowIndex() {
      this.showDraw = "index";
    },
    NshowOpacity() {
      this.showDraw = "opacity";
    },
    NshowSet() {
      this.showDraw = "set";
    },
    NlOCK() {
      this.drags[this.activeIndex].lock = !this.drags[this.activeIndex].lock;
    },
    checkComplete() {
      this.$axios({
        method: "GET",
        url: this.$api.domain + this.$api.growupDetail,
        headers: { Authorization: this.headers },
        params: {
          guc_id: this.guc_id,
          s_id: this.s_id,
        },
      })
        .then((res) => {
          console.log(res);
          if (res.data.status == 200 && res.data.data) {
            this.is_complete = res.data.data.info.is_complete ? true : false;
            if (this.is_complete) {
              this.$message.error("成长册已提交，不能继续编辑");
              clearInterval(this.checkCompleteTask);
              // setTimeout(() => {
              //   this.$router.back()
              // }, 1500);
            }
          }
        })
        .catch((res) => {
          console.log(res);
          this.$message.error(res.data.msg);
        });
    },
    handleRotateTouchDown(handle, e) {
      this.$refs.drag[this.activeIndex].handleRotateTouchDown(handle, e);
    },
    // 旋转柄按下
    handleRotateDown(handle, e) {
      this.$refs.drag[this.activeIndex].handleRotateDown(handle, e);
    },
    dragRotating(left, top, width, height, rotate, index) {
      this.moveBoxRotate = this.$refs.drag[index].rotate;
    },
    dragResizing(left, top, width, height, rotate, sacle, index) {
      // var orignX =
      //   this.$refs.drag[index].left + this.$refs.drag[index].width / 2;
      // var orignY =
      //   this.$refs.drag[index].top + this.$refs.drag[index].getHeight() / 2;

      //   const right = this.$refs.drag[index].left + this.$refs.drag[index].width + 10;
      // if (right > this.$refs.body.getBoundingClientRect().width - 60) {
      //   this.moveBoxRight =
      //   this.$refs.drag[index].left - 60;
      // } else {
      //   this.moveBoxRight =
      //   this.$refs.drag[index].left + this.$refs.drag[index].width + 10;
      // }

      // this.moveBoxTop =
      //   this.$refs.drag[index].top +
      //   this.$refs.drag[index].getHeight() / 2 -
      //   97;
      // this.transformX = orignX - this.moveBoxRight;
      // this.transformY = orignY - this.moveBoxTop;
      // this.rotateStyles = {
      //   top: this.$refs.drag[index].top - 10,
      //   left:
      //     this.$refs.drag[index].left + this.$refs.drag[index].width / 2 - 33,
      //   rotateX:
      //     orignX -
      //     (this.$refs.drag[index].left + this.$refs.drag[index].width / 2 - 33),
      //   rotateY: orignY - (this.$refs.drag[index].top - 10),
      // };
      // this.moveBoxRotate = this.$refs.drag[index].rotate;

      this.calcPos(this.activeIndex);
    },
    dragMoving(m, n, index) {
      var orignX =
        this.$refs.drag[index].left + this.$refs.drag[index].width / 2;
      var orignY =
        this.$refs.drag[index].top + this.$refs.drag[index].getHeight() / 2;

      const right =
        this.$refs.drag[index].left + this.$refs.drag[index].width + 10;
      if (right > this.$refs.body.getBoundingClientRect().width - 60) {
        this.moveBoxRight = this.$refs.drag[index].left - 60;
      } else {
        this.moveBoxRight =
          this.$refs.drag[index].left + this.$refs.drag[index].width + 10;
      }
      this.moveBoxTop =
        this.$refs.drag[index].top +
        this.$refs.drag[index].getHeight() / 2 -
        97;
      this.transformX = orignX - this.moveBoxRight;
      this.transformY = orignY - this.moveBoxTop;
      this.rotateStyles = {
        top: this.$refs.drag[index].top - 10,
        left:
          this.$refs.drag[index].left + this.$refs.drag[index].width / 2 - 33,
        rotateX:
          orignX -
          (this.$refs.drag[index].left + this.$refs.drag[index].width / 2 - 33),
        rotateY: orignY - (this.$refs.drag[index].top - 10),
      };
      this.moveBoxRotate = this.$refs.drag[index].rotate;
    },
    fangda() {
      this.$refs.drag[this.activeIndex].fangda();
    },
    suoxiao() {
      this.$refs.drag[this.activeIndex].suoxiao();
    },
    handleRotateUp() {
      this.$refs.drag[this.activeIndex].handleRotateUp();
    },
    handleMoveTouchDown(handle, e) {
      this.$refs.drag[this.activeIndex].handleMoveTouchDown(handle, e);
    },
    // 旋转柄按下
    handleMoveDown(handle, e) {
      this.$refs.drag[this.activeIndex].handleMoveDown(handle, e);
    },
    async pasterDrag() {
      var that = this;
      if (that.editorState) return false;
      //粘贴
      if (that.copyDrag) {
        var drag = _.cloneDeep(that.copyDrag);
        // drag.left += 10;
        // drag.top += 10;
        var addState = await that.batchAddDrag([drag]);
        if (addState.length > 0) {
          that.drags = [...that.drags, ...addState];
          that.drags.forEach((arr, index) => {
            arr.active = false;
            if (index == that.drags.length - 1) {
              arr.active = true;
            }
            arr.textarea = arr.textarea.replace(/\\n/g, "<br/>");
            return arr;
          });
          that.activeIndex = that.drags.length - 1;
          that.allIndex = that.drags.length;
          that.selectPhoto = null;
          that.ComIndex = -1;
          var getElement = await that.batchGetElement(addState[0].eguc_id);
          this.copyDrag = null;
          this.$message.success("粘贴成功");
          this.visible = false;
          var ids = [];
          var sids = [];
          if (getElement) {
            that.studentList.forEach((arr) => {
              if (arr.select) {
                that.editList.forEach((edit) => {
                  if (arr.id == edit.s_id) {
                    ids.push(edit.ec_id);
                    sids.push(arr.id);
                  }
                });
              }
            });
          }
          that.czHistory = [
            ...that.czHistory,
            {
              type: "adddrag",
              index: null,
              detail: { new: addState, old: null, sids: sids.join(",") },
              ids: ids.join(","),
            },
          ];
          this.step++;
          that.originDrags = _.cloneDeep(that.drags);
        }
      }
    },
    calcelPhoto() {
      if (
        this.drags[this.activeIndex].type == 1 ||
        this.drags[this.activeIndex].type == 9
      ) {
        this.drags[this.activeIndex].backgroundImg = "";
      } else {
        this.drags[this.activeIndex].showPhoto = "";
        this.drags[this.activeIndex].photoLeft = 0;
        this.drags[this.activeIndex].photoTop = 0;
        this.drags[this.activeIndex].photoScale = 1;
      }
    },
    changeLevelType(e) {
      this.drags[this.activeIndex].levelType = e;
    },
    NframeChange() {},
    async changeCurrnetLevel(e) {
      const index = this.activeIndex 
      const n = e
      if (this.changelevelState) {
        this.hide = this.$message.error("正在保存评级，请稍后");
        return false;
      } else {
        this.changelevelState = true;
        await this.batchGetElement(this.drags[index].eguc_id);
        if (this.check_drag_edit) {
          this.$set(this.drags[index], "level", n);
          await this.changeDragHistory(index);
          this.changelevelState = false;
        } else {
          this.changelevelState = false;
        }
        
        if (this.hide) {
          this.hide();
        }
      }
    },
    changeLevel(n, index) {
      console.log(n);
      this.drags[index].level = n;
      if (!this.saveDraging) {
        this.changeDragHistory(index);
      } else {
        setTimeout(() => {
          this.changeLevel(n, index);
        }, 300);
      }
    },
    async copythisDrag() {
      var that = this;
      that.copyDrag = _.cloneDeep(that.drags[that.activeIndex]);
      this.$message.success("复制成功，请使用粘贴组件");
      delete that.copyDrag.ec_id;
      delete that.copyDrag.eguc_id;
      delete that.copyDrag.guc_id;
      delete that.copyDrag.c_id;
      // var drag = _.cloneDeep(that.copyDrag);
      // var addState = await that.batchAddDrag([drag]);
      // if (addState.length > 0) {
      //   that.drags = [...that.drags, ...addState];
      //   that.drags.forEach((arr, index) => {
      //     arr.active = false;
      //     if (index == that.drags.length - 1) {
      //       arr.active = true;
      //     }
      //     return arr;
      //   });
      //   that.activeIndex = that.drags.length - 1;
      //   that.allIndex = that.drags.length;
      //   that.selectPhoto = null;
      //   that.ComIndex = -1;
      //   that.copyDrag = drag;
      //   this.$forceUpdate()
      //   var getElement = await that.batchGetElement(addState[0].eguc_id);
      //   var ids = [];
      //   if (getElement) {
      //     that.studentList.forEach((arr) => {
      //       if (arr.select) {
      //         that.editList.forEach((edit) => {
      //           if (arr.id == edit.s_id) {
      //             ids.push(edit.ec_id);
      //           }
      //         });
      //       }
      //     });
      //   }
      //   that.czHistory = [
      //     ...that.czHistory,
      //     {
      //       type: "adddrag",
      //       index: null,
      //       detail: { new: addState, old: null },
      //       ids: ids.join(","),
      //     },
      //   ];
      //   this.step++;
      //   that.originDrags = _.cloneDeep(that.drags);
      // }
    },
    backIndex() {
      localStorage.removeItem("s_id");
      localStorage.removeItem("student_name");
      localStorage.removeItem("page");
      this.$router.push({ path: "/plate" });
    },
    changeKongwei(e) {
      console.log(e);
      this.kongwei = e;
    },
    handleCancelEdit() {
      this.eiditVisible = false;
    },
    lockPage() {
      this.saveDraging = true;
      var ids = [];
      this.studentList.forEach((arr) => {
        if (arr.select) {
          ids.push(arr.id);
        }
      });
      axios({
        method: "POST",
        url: api.domain + api.batchEditBg,
        headers: { Authorization: this.$store.state.headers },
        data: {
          guc_id: this.guc_id,
          img_bg: this.backgroundImage,
          is_locked: this.pageDetail.is_locked ? 0 : 1,
          s_ids: ids.join(","),
        },
      })
        .then((res) => {
          setTimeout(() => {
            this.saveDraging = false;
          }, 200);
          if (res.data.status == 200) {
            this.pageDetail.is_locked = this.pageDetail.is_locked ? 0 : 1;
            return false;
          }
        })
        .catch((res) => {
          console.log(res);
          this.$message.error("保存失败");
        });
    },
    matchSpace(text) {
      var rel = />[\s]+/g;
      var match = text.match(rel);
      console.log(match);
      var prifx = "";
      var content = "";
      if (match && match.length > 0) {
        prifx = match[0].replace(/[\s]/g, "&nbsp;");
        content = text.replace(match[0], prifx);
      } else {
        content = text;
      }
      console.log("空格处理");
      console.log(text);
      console.log(match);
      console.log(content);
      content = this.matchSpace2(content);
      return content;
    },
    matchSpace2(text, rel) {
      var rel = /&nbsp;[\s]+/g;
      var match = text.match(rel);
      console.log("空格二次处理");
      console.log(text);
      console.log(match);
      var prifx = "";
      var content = "";
      if (match && match.length > 0) {
        prifx = match[0].replace(/[\s]/g, "&nbsp;");
        content = text.replace(match[0], prifx);
      } else {
        content = text;
      }
      console.log(content);
      return content;
    },
    getMaxFont(txt) {
      var regeQl = /ql-size-([\d]+)|font-size:[\s]*([\d]+)px/;
      var result = [];
      var maxFsize = 0;
      var matched = txt.match(regeQl);
      while (matched != null) {
        if (matched[1] != null) {
          result.push(matched[1]);
          if (matched[1] > maxFsize) {
            maxFsize = matched[1];
          }
        }
        if (matched[2] != null) {
          result.push(matched[2]);
          if (matched[2] > maxFsize) {
            maxFsize = matched[2];
          }
        }
        txt = txt.substr(matched.index + matched[0].length);
        matched = txt.match(regeQl);
      }
      switch (maxFsize) {
        case "175":
          maxFsize = 58.667;
          break;
        case "150":
          maxFsize = 48;
          break;
        case "116":
          maxFsize = 34.667;
          break;
        case "44":
          maxFsize = 14;
          break;
        case "131":
          maxFsize = 32;
          break;

        case "87":
          maxFsize = 29.333;
          break;

        case "66":
          maxFsize = 21.333;
          break;

        case "75":
          maxFsize = 24;
          break;

        case "58":
          maxFsize = 18.667;
          break;

        case "50":
          maxFsize = 16;
          break;

        case "37":
          maxFsize = 12;
          break;
      }
      console.log(maxFsize);
      return maxFsize;
    },
    async confirmEdit() {
      var drags = [];
      var maxFsize = this.drags[this.activeIndex].fSize;
      console.log();
      // this.editText = this.matchSpace(this.editText);
      this.studentList.forEach((arr) => {
        if (arr.select) {
          this.editList = this.editList.map((edit, index) => {
            edit.fSize = this.drags[this.activeIndex].fSize;
            edit.fColor = this.drags[this.activeIndex].fColor;
            edit.textIndent = this.drags[this.activeIndex].textIndent;
            edit.textDecoration = this.drags[this.activeIndex].textDecoration;
            edit.writeMode = this.drags[this.activeIndex].writeMode;
            edit.textAlign = this.drags[this.activeIndex].textAlign;
            edit.fontFamily =  this.drags[this.activeIndex].fontFamily;
            
            if (arr.id == edit.s_id) {
              edit.textarea = this.editText ? this.editText : "";
              if (edit.lineHeightAutoSize) {
                if (maxFsize) {
                  edit.lineHeight = Math.ceil(maxFsize * 1.23);
                } else {
                  edit.lineHeight = 18;
                }
              }
              drags.push(edit);
              this.$nextTick(() => {
                this.editList[index].saveState = false;
              });
            }
            return edit;
          });
        }
      });
      this.$forceUpdate();
      var res = await this.batchChangeDrag2(drags);
      console.log("编辑" + res);
      if (res) {
        this.eiditVisible = false;
        // this.drags.forEach((arr, index) => {
        //   this.editList.forEach((edit) => {
        //     if (arr.ec_id == edit.ec_id) {
        //       this.drags[index].textarea = edit.textarea;
        //     }
        //   });
        // });
        // this.$message.success("编辑成功");
        this.drags[this.activeIndex].textarea = this.editText
          ? this.editText
          : "";
        console.log("321312312312321");
        if (this.drags[this.activeIndex].lineHeightAutoSize) {
          if (maxFsize) {
            this.drags[this.activeIndex].lineHeight = Math.ceil(
              maxFsize * 1.23
            );
          } else {
            this.drags[this.activeIndex].lineHeight = 18;
          }
        }
      } else {
        if (!this.$store.state.online) {
          this.$message.info("网络或服务错误，请确认后刷新重试");
        } else {
          this.$message.info("字体加载中，请稍后保存");
        }
      }
    },
    async batchChangeDrag2(drags) {
      var drags2 = _.cloneDeep(drags);
      // drags2 = drags2.map((arr) => {
      //   if (arr && arr.textarea) arr.textarea = this.matchSpace(arr.textarea);
      //   console.log(arr.textarea);
      //   return arr;
      // });
      this.saveDraging = true;
      drags2.forEach((arr, index) => {
        drags2[index].showPhoto = drags2[index].showPhoto
          ? this.clearUrl(drags2[index].showPhoto)
          : "";
        drags2[index].backgroundImg = drags2[index].backgroundImg
          ? this.clearUrl(drags2[index].backgroundImg)
          : "";
      });
      try {
        var res = await axios({
          method: "POST",
          url: api.domain + api.batchEdit,
          headers: { Authorization: this.$store.state.headers },
          data: {
            content: JSON.stringify(drags2),
          },
        });
        setTimeout(() => {
          this.saveDraging = false;
        }, 800);
        if (res.data.status == 200) {
          drags2.forEach((arr, index) => {
            this.drags.forEach((arr2, index2) => {
              if (arr.ec_id == arr2.ec_id) {
                this.drags[index2].pushState = false;
              }
            });
          });
          this.saveDraging = false;
        } else {
          this.$message.error(res.data.msg);
          this.saveDraging = false;
          return false;
        }
        return true;
      } catch (error) {
        if (this.waitDrag.ec_id && waitId == this.waitDrag.ec_id) {
          this.uploadWaitDrag();
          this.$message.error("保存失败,尝试重新保存");
        } else {
          this.$message.error("保存失败");
        }
        this.saveDraging = false;
        return state;
      }
    },
    addDragImg(e, url) {
      if (this.pullPhotoState) return false;
      var img = new Image();
      img.setAttribute("crossOrigin", "Anonymous");
      img.src = url;
      img.onload = async () => {
        const height = Math.ceil((240 * img.height) / img.width);
        var drag = {
          left: e.layerX - 240 / 2,
          top: e.layerY - height / 2,
          width: 240,
          height: Math.ceil((240 * img.height) / img.width),
          rotate: 0,
          lockAspectRatio: true,
          aspectFactor: null,
          textarea: "",
          minW: null,
          minH: null,
          backgroundImg: this.clearUrl(url),
          maxW: null,
          maxH: null,
          lock: false,
          zIndex: null,
          bColor: "#cccccc",
          fColor: null,
          fSize: 14,
          lHeight: 18,
          bordersColor: "#ffffff",
          bLeft: 0,
          bTop: 0,
          bRight: 0,
          bBottom: 0,
          bStyle: "solid",
          paddingLeft: 0,
          paddingTop: 0,
          paddingRight: 0,
          paddingBottom: 0,
          opacity: 100,
          shadow: false,
          active: false,
          type: 1,
          name: "方块一",
          lineHeight: "18",
          fontStyle: "horizontal-tb",
          fontWeight: "normal",
          textAlign: "left",
          borderRadius: 0,
          zIndex: 0,
        };

        var addState = await this.batchAddDrag([drag]);
        if (addState.length > 0) {
          addState[0].lineHeightAutoSize = 1;
          this.drags = [...this.drags, ...addState];
          this.drags.forEach((arr, index) => {
            arr.active = false;
            if (index == this.drags.length - 1) {
              arr.active = true;
            }
            return arr;
          });
          this.activeIndex = -1;
          this.allIndex = this.drags.length;
          this.selectPhoto = null;
          this.ComIndex = -1;
          var getElement = await this.batchGetElement(addState[0].eguc_id);
          var ids = [];
          var sids = [];
          if (getElement) {
            this.studentList.forEach((arr) => {
              if (arr.select) {
                this.editList.forEach((edit) => {
                  if (arr.id == edit.s_id) {
                    ids.push(edit.ec_id);
                    sids.push(edit.s_id);
                  }
                });
              }
            });
          }
          if (this.step < this.czHistory.length - 1) {
            this.czHistory.splice(
              this.step + 1,
              this.czHistory.length - this.step - 1
            );
          }
          this.czHistory = [
            ...this.czHistory,
            {
              type: "adddrag",
              index: null,
              detail: { new: addState, old: null, sids: sids.join(",") },
              ids: ids.join(","),
            },
          ];
          this.step++;
          this.originDrags = _.cloneDeep(this.drags);
        }
      };
    },
    photoChange(left, top, rotate, scale, index) {
      console.log("photoChange");
      this.drags[index].photoLeft = parseInt(left);
      this.drags[index].photoTop = parseInt(top);
      this.drags[index].photoScale = parseFloat(scale);
      this.drags[index].photoRotate = parseFloat(rotate);
      this.$forceUpdate();
      console.log("nextStepState", this.nextStepState);
      // if (this.changeStepState) {
      //   this.changeStepState = false;
      //   return false;
      // }
      this.changeDragHistory(index);
    },
    showEdit(index) {
      this.batchGetElement(this.drags[index].eguc_id);
      this.editText = "";
      this.editText = this.drags[index].textarea
        .split("<br/>")
        .forEach((item) => arr.push(`<p>${item.trim()}</p>`));
      this.eiditVisible = true;
      setTimeout(() => {
        addQuillTitle();
      }, 40);
    },
    onEditorBlur() {},
    onEditorFocus(e) {},
    editorFocus(e, index) {
      console.log(index);
      setTimeout(() => {
        this.editorState = true;
      }, 20);
    },
    onEditorChange(e) {
      console.log(e, "1111");
      var emojiReg = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi;
      this.editText = e.html.replace(emojiReg, "");
      var match = emojiReg.exec(e.html);
      if (match && match.length > 0) {
        if (this.showEmjo) {
          return false;
        } else {
          this.$message.error("不支持emjo表情功能");
          this.showEmjo = true;
          setTimeout(() => {
            this.showEmjo = false;
          }, 10000);
        }
      }
      console.log(match);
      // this.editText = e.html;
    },
    changeText(item) {
      var select = false;
      this.studentList.forEach((arr) => {
        if (arr.id == item.s_id && arr.select) {
          select = true;
        }
      });
      if (select) {
        this.studentList.forEach((arr) => {
          if (arr.select) {
            this.editList = this.editList.map((edit) => {
              if (arr.id == edit.s_id) {
                edit.textarea = item.textarea;
              }
              return edit;
            });
          }
        });
        this.$forceUpdate();
      }

      console.log(item);
    },
    changeEditText() {
      this.editState = true;
    },
    pressEnter(e, index) {
      console.log(index);
      this.editorState = false;
      if (!this.editState) return false;
      this.editList[index].textarea = this.editList[index].textarea
        ? this.editList[index].textarea
        : "";
      var res = this.batchChangeDrag2([this.editList[index]]);
      if (res) {
        this.editList[index].saveState = false;
        if (this.editList[index].s_id == this.s_id) {
          this.drags.forEach((arr, index2) => {
            if (arr.ec_id == this.editList[index].ec_id) {
              this.drags[index2].textarea = this.editList[index].textarea;
            }
          });
        }
        // this.$message.success("编辑成功");
        this.$forceUpdate();
        this.editState = false;
      } else {
        this.editState = false;
        this.$message.error("编辑失败，请稍后再试");
      }
    },
    toggleAspect() {
      this.drags[this.activeIndex].lockAspectRatio = !this.drags[
        this.activeIndex
      ].lockAspectRatio;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    cancelUpload() {
      this.uploadModal = false;
      this.fileList = [];
      this.errorUploadState = false;
    },
    confirmUpload() {
      if (this.uploadState) return false;
      var img_url = [];
      var errors = [];
      var state = true;
      for (let i = 0; i < this.fileList.length; i++) {
        if (
          this.fileList[i].status == "done" &&
          this.fileList[i].response &&
          this.fileList[i].response.data
        ) {
          img_url.push(this.fileList[i].response.data.url);
        }
      }
      if (img_url.length == 0) {
        this.uploadState = false;
        this.fileList = [];
        this.uploadModal = false;
        return false;
      }
      this.uploadState = true;
      this.$message.loading({
        content: "Loading...",
        key: "uploadState",
        duration: 10,
      });
      var ids = [];
      this.studentList.forEach((arr) => {
        if (arr.select) {
          ids.push(arr.id);
        }
      });
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.albumAdd,
        headers: { Authorization: this.$store.state.headers },
        data: {
          student_id: ids.join(","),
          img_url: img_url.join(","),
          album_id: this.album_id,
        },
      })
        .then((res) => {
          this.uploadState = false;
          this.fileList = [];
          setTimeout(() => {
            this.$message.info({
              content: res.data.msg,
              key: "uploadState",
              duration: 2,
            });
          }, 300);
          if (res.data.status == 200) {
            this.uploadModal = false;
            setTimeout(() => {
              this.getPhoto();
            }, 200);
          }
        })
        .catch(() => {
          this.uploadState = false;
          this.$message.error("网络或服务器未知错误");
        });
    },
    handleUpload() {
      if (this.uploadState) return false;
      var img_url = [];
      var errors = [];
      var state = true;
      for (let i = 0; i < this.fileList.length; i++) {
        if (
          this.fileList[i].status == "done" &&
          this.fileList[i].response &&
          this.fileList[i].response.data
        ) {
          img_url.push(this.fileList[i].response.data.url);
        } else if (this.fileList[i].status == "uploading") {
          state = false;
          break;
        } else if (
          this.fileList[i].status == "error" ||
          this.fileList[i].response != 200
        ) {
          errors.push(i + 1);
          this.errorUploadState = true;
        } else {
          this.fileList[i].status == "error";
        }
      }
      if (!state) return false;
      if (errors.length > 0) {
        this.$message.error(`第${errors.join(",")}文件上传失败`);
        return false;
      }
      if (img_url.length == 0) {
        this.uploadState = false;
        this.fileList = [];
        this.uploadModal = false;
        return false;
      }
      this.uploadState = true;
      this.$message.loading({
        content: "Loading...",
        key: "uploadState",
        duration: 10,
      });
      var ids = [];
      this.studentList.forEach((arr) => {
        if (arr.select) {
          ids.push(arr.id);
        }
      });
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.albumAdd,
        headers: { Authorization: this.$store.state.headers },
        data: {
          student_id: ids.join(","),
          img_url: img_url.join(","),
          album_id: this.album_id,
        },
      })
        .then((res) => {
          this.uploadState = false;
          this.fileList = [];
          setTimeout(() => {
            this.$message.info({
              content: res.data.msg,
              key: "uploadState",
              duration: 2,
            });
          }, 300);
          if (res.data.status == 200) {
            this.uploadModal = false;
            setTimeout(() => {
              this.getPhoto();
            }, 200);
          }
        })
        .catch(() => {
          this.uploadState = false;
          this.$message.error("网络或服务器未知错误");
        });
    },
    //上传照片
    handleuploadChange({ fileList }) {
      this.fileList = fileList;
      this.handleUpload();
    },
    //切换相册
    changeAlbum(e) {
      this.album_id = e;
      this.currentPhoto = 1;
      this.getPhoto();
    },
    catePic() {
      this.$refs.drag[this.activeIndex].catePic();
      this.moveMode = true;
    },
    handleCatePic() {
      this.moveMode = false;
      this.$refs.drag[this.activeIndex].cancelCatePic();
    },
    getAlbum() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.albumList,
        headers: { Authorization: this.$store.state.headers },
        data: {
          class_id: this.class_id,
          limit: 200,
        },
      })
        .then((res) => {
          if (res.data.status == 200 && res.data.data) {
            if (res.data.data.data.length > 0) {
              this.albumList = res.data.data.data;
              this.album_id = this.albumList[0].id;
              this.currentPhoto = 1;
              this.getPhoto();
            }
          }
        })
        .catch((res) => {
          console.log(res);
          console.log("getalbum错误");
          this.$message.error("服务器或网络错误");
        });
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    NexchangePhoto() {
      this.changePhotoState = true;
    },
    onSearchphotos(e) {
      this.frameTag = e;
      this.currentFrame = 1;
      this.getFrame();
    },
    onSearchbacks(e) {
      this.backgroundTag = e;
      this.currentBack = 1;
      this.getBackground();
    },
    onSearchimgs(e) {
      this.pasterTag = e;
      this.currentPaster = 1;
      this.getPaster();
    },
    onSearchbuildup(e) {
      this.buildUpTag = e;
      this.currentBuild = 1;
      this.getBuiltUp();
    },
    changeGrowPage(index) {
      this.uploadWaitDrag();
      setTimeout(() => {
        this.page = index;
        this.activeIndex = -1;
        this.getGrowupPageDetail(1);
      }, 300);
    },
    getGrowupDetail() {
      this.drags = [];
      console.log(this.guc_id);
      this.$message.loading({ content: "读取中", key: "loaddetail" });
      this.$axios({
        method: "GET",
        url: this.$api.domain + this.$api.growupDetail,
        headers: { Authorization: this.headers },
        params: {
          guc_id: this.guc_id,
          s_id: this.s_id,
        },
      })
        .then((res) => {
          if (res.data.status == 200 && res.data.data) {
            this.pages = res.data.data.page;
            this.getGrowupPageDetail();
            this.$message.success({ content: "获取成功", key: "loaddetail" });
          }
        })
        .catch((res) => {
          console.log("sdaas:" + res);
          this.$message.error(res.data.msg);
        });
    },
    getGrowPages() {
      this.$axios({
        method: "GET",
        url: this.$api.domain + this.$api.growPages,
        headers: { Authorization: this.headers },
        params: {
          guc_id: this.pages[this.page].guc_id,
          s_id: this.s_id,
        },
      })
        .then((res) => {
          if (res.data.status == 200 && res.data.data) {
            var pages2 = res.data.data;
            if (
              pages2[this.page].is_lock &&
              pages2[this.page].lock_info.teacher_name !=
                this.userInfo.teacher_name
            ) {
              this.$message.error("此页面已经被占用");
              setTimeout(() => {
                this.$router.back();
              }, 1000);
            }
            pages2.forEach((page, index) => {
              page.img_bg =
                page.img_bg +
                "?x-image-process=image/resize,w_100/quality,Q_40";
              page.content = page.content.map((arr) => {
                // arr.textarea = decodeURI(arr.textarea);
                // arr.draggable = true
                console.log(arr, arr.textarea);
                arr.backgroundImg = this.clearUrl(arr.backgroundImg)
                  ? this.clearUrl(arr.backgroundImg) +
                    "?x-image-process=image/resize,w_50/quality,Q_40"
                  : "";
                arr.backImg2 = this.clearUrl(arr.backImg2)
                  ? this.clearUrl(arr.backImg2) +
                    "?x-image-process=image/resize,w_50/quality,Q_40"
                  : "";
                arr.showPhoto = this.clearUrl(arr.showPhoto)
                  ? this.clearUrl(arr.showPhoto) +
                    "?x-image-process=image/resize,w_50/quality,Q_40"
                  : "";
                if (arr.textarea) {
                  arr.textarea = arr.textarea.replace(/\\n/g, "<br/>");
                }
                if (arr.coms) {
                  arr.coms = JSON.parse(arr.coms);
                  if (arr.coms[0] && arr.coms[0].width >= 0) {
                  } else {
                    arr.coms = [];
                  }
                }
                return arr;
              });
            });
            this.pages2 = pages2;
            this.kongwei = true;
            this.$forceUpdate();
            clearTimeout(this.pagesTime);
            this.pagesTime = setTimeout(() => {
              this.getGrowPages();
            }, 180000);
          }
        })
        .catch((res) => {
          console.log(res);
          this.$message.error(res.data.msg);
        });
    },
    maskClosable() {
      this.visible = false;
      this.showDraw = "";
    },
    studentMaskClosable() {
      this.studentVisible = false;
    },
    catchClick() {
      var that = this;
      setTimeout(() => {
        if (that.activeIndex >= 0) {
          if (that.$refs["drag"][that.activeIndex]) {
            that.$refs["drag"][that.activeIndex].activeDrag();
          }
        }
      }, 100);
    },
    getGrowupPageDetail(state) {
      console.log(this.pages, this.page);
      if (this.pages.length == 0) {
        this.drags = [];
        this.backgroundImage = "";
        return false;
      }
      this.drags = [];
      this.$axios({
        method: "GET",
        url: this.$api.domain + this.$api.growupDetail,
        headers: { Authorization: this.headers },
        params: {
          guc_id: this.pages[this.page].guc_id,
          s_id: this.s_id,
        },
      })
        .then((res) => {
          if (res.data.status == 200 && res.data.data) {
            this.guc_id = this.pages[this.page].guc_id;
            this.pageDetail = res.data.data.info;
            this.drags = res.data.data.info.content.map((arr) => {
              console.log(arr.textarea);
              arr.active = false;
              arr.draggable = false;
              arr.lock = arr.lock ? true : false;
              arr.backgroundImg = this.clearUrl(arr.backgroundImg)
                ? this.clearUrl(arr.backgroundImg) +
                  "?x-image-process=image/resize,w_650/quality,Q_120"
                : "";
              arr.writeMode =
                arr.writeMode == "" ? "horizontal-tb" : arr.writeMode;
              arr.showPhoto = this.clearUrl(arr.showPhoto)
                ? this.clearUrl(arr.showPhoto) +
                  "?x-image-process=image/resize,w_650/quality,Q_120"
                : "";

              arr.textarea = arr.textarea
                ? arr.textarea.replace(/\\n/g, "<br/>")
                : "";
              console.log(arr.textarea.replace(/\\n/g, "<br/>"));
              if (arr.coms) {
                arr.coms = JSON.parse(arr.coms);
                if (arr.coms[0] && arr.coms[0].width >= 0) {
                } else {
                  arr.coms = [];
                }
              }
              return arr;
            });
            console.log(this.drags);
            this.backgroundImage = res.data.data.info.img_bg;
            var cover_size = res.data.data.info.size.cover_size.split("*");
            this.cover_size = cover_size;
            this.haomi = (11.8 * 3 * 750) / cover_size[1];
            this.wrapperWidth = (cover_size[0] * 750) / cover_size[1];
            var screenWidth = document.body.clientWidth;
            this.scaleP = (screenWidth - 30) / this.wrapperWidth;
            this.getBackground();
            setTimeout(() => {
              var dom = this.$refs["body"].getBoundingClientRect();
              this.fixBtnLeft = dom.right + 20;
            }, 600);

            if (state) {
              this.pageModal = false;
            } else {
              this.getGrowPages();
            }
          }
        })
        .catch((res) => {
          console.log(res);
          this.$message.error(res);
        });
    },
    changePasterType(e) {
      this.pasterType = e;
      this.currentPaster = 1;
      this.getPaster();
    },
    changeB() {
      const s = this.drags[this.activeIndex].fontWeight == "bold" ? "" : "bold";
      this.$set(this.drags[this.activeIndex], "fontWeight", s);
    },
    changeI() {
      const s =
        this.drags[this.activeIndex].fontStyle == "italic" ? "" : "italic";
      this.$set(this.drags[this.activeIndex], "fontStyle", s);
    },
    changeFamily(name) {
      this.$set(this.drags[this.activeIndex], "fontFamily", name);
    },
    changeU() {
      const s =
        this.drags[this.activeIndex].textDecoration == "underline"
          ? ""
          : "underline";
      this.$set(this.drags[this.activeIndex], "textDecoration", s);
    },
    changeS() {
      const s =
        this.drags[this.activeIndex].textDecoration == "line-through"
          ? ""
          : "line-through";
      this.$set(this.drags[this.activeIndex], "textDecoration", s);
    },
    clear() {
      this.drags[this.activeIndex].fontWeight = "";
      this.drags[this.activeIndex].fontStyle = "";
      this.drags[this.activeIndex].textDecoration = "";
      this.drags[this.activeIndex].fontFamily = "";

      this.drags[this.activeIndex].fColor = "#101010";
      this.drags[this.activeIndex].textAlign = "left";
      this.drags[this.activeIndex].textIndent = 0;
      this.drags[this.activeIndex].bColor = "";
      if (this.drags[this.activeIndex].lineHeightAutoSize) {
        this.drags[this.activeIndex].lineHeight = Math.ceil(14 * 1.23);
      }
      this.drags[this.activeIndex].fSize = 14;
      this.$forceUpdate();
    },
    changeBuildType(e) {
      this.buildUpType = e;
      this.currentBuild = 1;
      this.getBuiltUp();
    },
    showChangeFrame() {
      if (this.pageDetail.is_locked) {
        this.$message.error('页面已大锁定,不能新增和复制')
        return false 
      }
      this.previewFrame = true
    },
    async changeFrame(item) {
      if (this.pageDetail.is_locked) {
        this.$message.error("页面已锁定不支持新增");
        return false;
      }
      this.drags[this.activeIndex].spinning = true;
      this.drags[this.activeIndex].draggable = false;
      this.$message.loading({ content: "相框更换中", duration: 1 });
      var drags = [];
      var oldDrag = [];
      const backgroundImg = this.clearUrl(
        this.drags[this.activeIndex].backgroundImg
      );
      if (
        this.drags[this.activeIndex].type == 1 ||
        this.drags[this.activeIndex].type == 9
      ) {
        this.drags[this.activeIndex].showPhoto = this.clearUrl(backgroundImg);
        this.drags[this.activeIndex].bLeft = 0;
        this.drags[this.activeIndex].bTop = 0;
        this.drags[this.activeIndex].bRight = 0;
        this.drags[this.activeIndex].bBottom = 0;
      }
      this.drags[this.activeIndex].backgroundImg = this.clearUrl(
        item.backgroundImg
      );
      this.drags[this.activeIndex].backImg2 = this.clearUrl(item.backImg2);
      this.drags[this.activeIndex].height = "auto";

      setTimeout(() => {
        this.drags[this.activeIndex].type = 2;
        this.$refs.drag[this.activeIndex].changeFrame(item);
      }, 10);

      setTimeout(() => {
        this.previewFrame = false;
      }, 1000);
    },
    changeFrameType(e) {
      this.frameType = e;
      this.currentFrame = 1;
      this.getFrame();
    },
    changeFrameType2(e) {
      this.frameType2 = e;
      this.currentFrame2 = 1;
      this.getFrame2();
    },
    getFrame2() {
      axios({
        method: "POST",
        url: api.domain + api.getFrame2,
        headers: { Authorization: this.$store.state.headers },
        data: {
          tags: this.frameTag2,
          type: this.frameType2,
          limit: 18,
          page: this.currentFrame2,
        },
      })
        .then((res) => {
          console.log(res);
          this.photoPage2 = res.data.data;
          this.photos2 = [];
          res.data.data.data.forEach((arr) => {
            this.photos2.push({
              left: null,
              top: null,
              width: 160,
              height: "auto",
              rotate: 0,
              lockAspectRatio: true,
              aspectFactor: null,
              textarea: "",
              minW: null,
              minH: null,
              maxW: null,
              maxH: null,
              lock: false,
              zIndex: null,
              bColor: "",
              fColor: null,
              fSize: 14,
              bordersColor: null,
              bLeft: 0,
              bTop: 0,
              bRight: 0,
              bBottom: 0,
              bStyle: "solid",
              paddingLeft: 0,
              paddingTop: 0,
              paddingRight: 0,
              paddingBottom: 0,
              opacity: 100,
              shadow: false,
              active: false,
              backgroundImg: this.clearUrl(arr.top)
                ? this.clearUrl(arr.top) +
                  "?x-image-process=image/resize,w_100/quality,Q_80"
                : "",
              backImg2: this.clearUrl(arr.shade)
                ? this.clearUrl(arr.shade) +
                  "?x-image-process=image/resize,w_100/quality,Q_80"
                : "",
              borderRadius: 0,
              type: 2,
              name: "相框二（无规则）",
              lineHeight: "18",
              fontStyle: "horizontal-tb",
              fontWeight: "normal",
              textAlign: "left",
            });
          });
        })
        .catch((res) => {
          // this.$message('请求错误')
        });
    },
    changeBackType(e) {
      this.backgroundType = e;
      this.currentBack = 1;
      this.getBackground();
    },
    getStudent() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.studentList,
        headers: { Authorization: this.$store.state.headers },
      })
        .then((res) => {
          this.studentList = res.data.data.rows;
          this.studentList.forEach((arr, index) => {
            if (arr.id == this.s_id) this.studentList[index].select = true;
          });
          this.getAlbum();
        })
        .catch((res) => {
          console.log(res);
          this.$message.error(res.data.msg);
        });
    },
    changeAddtype(e) {
      console.log(this.addType);
      if (this.addType) {
        this.currentPage = 1;
        this.getPlateList();
      }
    },
    showDrawTab(index) {
      this.tabIndex = index;
      this.showDraw = "tab";
    },
    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    urladd(name) {
      let url = window.location.href;
      let str = url.indexOf("?");
      let num = url.slice(str + 1);
      let a = num.split("&");
      var list = {};
      for (var key in a) {
        list[key] = a[key];
        let b = list[key].indexOf("=");
        let c = list[key].substring(0, b);
        if (c == name) {
          let d = list[key].substring(b + 1);
          return d;
        }
      }
    },
    async cancelStep() {
      this.activeIndex = -1;
      if (this.step == -1) return false;
      console.log("cancel", this.czHistory[this.step]);
      if (this.czHistory[this.step].type == "change") {
        this.czHistory[this.step].detail.old = this.czHistory[
          this.step
        ].detail.old.map((arr) => {
          if (arr.type == 3) {
            arr.coms = JSON.parse(arr.coms);
          }
          return arr;
        });
        var changeState = await this.batchChangeDrag2(
          this.czHistory[this.step].detail.old
        );
        console.log(this.czHistory[this.step].detail.old);
        this.drags.forEach((arr, index) => {
          this.czHistory[this.step].detail.old.forEach((oldDrag) => {
            if (oldDrag.ec_id == arr.ec_id) {
              let changeDrag = _.cloneDeep(
                this.czHistory[this.step].detail.changeDrag
              );
              for (const key in changeDrag) {
                changeDrag[key] = oldDrag[key];
              }
              // this.drags[index] = changeDrag;
              this.changeStepState = true;
              this.drags.splice(index, 1);
              setTimeout(() => {
                this.drags.splice(index, 0, changeDrag);
                this.dragKey++;
                // this.drags.push(changeDrag);
              }, 30);
            }
          });
        });
      }
      if (this.czHistory[this.step].type == "changeBack") {
        await axios({
          method: "POST",
          url: api.domain + api.batchEditBg,
          headers: { Authorization: this.$store.state.headers },
          data: {
            guc_id: this.guc_id,
            img_bg: this.czHistory[this.step].detail,
          },
        })
          .then(() => {
            var back = _.cloneDeep(this.backgroundImage);
            this.backgroundImage = this.czHistory[this.step].detail;
            this.czHistory[this.step].detail = back;
          })
          .catch((res) => {});
      }
      if (this.czHistory[this.step].type == "delete") {
        var addState = await this.batchCancelDrag(
          this.czHistory[this.step].detail.eguc_ids,
          this.czHistory[this.step].ids
        );
        if (addState) {
          this.drags = [
            ...this.drags,
            this.czHistory[this.step].detail.cancelDrag,
          ];
        }
      }
      if (this.czHistory[this.step].type == "adddrag") {
        var delres = await this.batchDel(
          this.czHistory[this.step].detail.new[0].eguc_id,
          this.czHistory[this.step].detail.sids
        );
        if (delres) {
          this.drags.splice(this.drags.length - 1, 1);
        }
      }
      if (this.czHistory[this.step].type == "confirmCom") {
        // this.drags = [...this.drags, this.czHistory[this.step].detail];
        var eguc_ids = [];
        console.log(
          "confirmCom",
          this.czHistory[this.step].detail,
          this.drags.length - this.czHistory[this.step].detail.coms.length
        );
        this.drags.forEach(async (arr, index) => {
          if (
            this.drags.length -
              1 -
              this.czHistory[this.step].detail.coms.length <=
            index
          ) {
            eguc_ids.push(arr.eguc_id);
          }
          this.batchDel(arr.eguc_id, this.czHistory[this.step].ids);
        });
        this.drags.splice(
          this.drags.length - this.czHistory[this.step].detail.coms.length,
          this.czHistory[this.step].detail.coms.length
        );
        // this.confirmComb(this.czHistory[this.step].index);
        await this.batchCancelDrag(
          this.czHistory[this.step].detail.eguc_id,
          this.czHistory[this.step].ids
        );
        this.drags.push(this.czHistory[this.step].detail);
      }
      if (this.czHistory[this.step].type == "addCom") {
        this.confirmComb(this.czHistory[this.step].index);
        this.czHistory.splice(this.step, 1);
      }
      this.originDrags = _.cloneDeep(this.drags);
      this.step--;

      this.$forceUpdate();
    },
    togoPhoto(photo, index) {
      if (!this.pullPhotoState) return false;
      this.$set(this.pictures[index], "select", !this.pictures[index].select);
    },
    async pullPhoto() {
      if (this.pictures.length == 0 || !this.pictures) {
        this.$message.error("请先选择相册照片");
        return false;
      }
      let num = 0;
      this.studentList.forEach((arr) => {
        if (arr.select) num++;
      });
      if (num > 1) {
        this.$message.error("多选状态不可批量导入照片");
        return false;
      }
      this.$confirm({
        title: "提示",
        content: "确认自动导入照片吗？",
        centered: true,
        onOk: () => {
          this.pullState = true;
          this.$message.loading({ content: "导入中...", key: "pull" });
          const drags = [];
          let pullIndex = 0;
          let pictures = [];
          this.pictures.forEach((arr) => {
            if (arr.select) {
              pictures.push(arr);
            }
          });
          if (pictures.length == 0) {
            pictures = this.pictures;
          }
          this.drags.forEach((arr) => {
            if (arr.type == 1 || arr.type == 9) {
              if (pullIndex >= pictures.length) {
                return false;
              }
              if (arr.backgroundImg) return false;
              arr.backgroundImg = this.clearUrl(pictures[pullIndex].img_url);
              arr.lockAspectRatio = true;
              pullIndex++;
              drags.push(arr);
            } else if (arr.type == 2) {
              if (pullIndex >= pictures.length) {
                return false;
              }
              if (arr.showPhoto) return false;
              arr.photoLeft = 0;
              arr.photoTop = 0;
              arr.photoScale = 1;
              arr.showPhoto = this.clearUrl(pictures[pullIndex].img_url);
              pullIndex++;
              drags.push(arr);
            }
          });

          this.$forceUpdate();
          this.$nextTick(() => {
            setTimeout(async () => {
              const res = await this.changeBatchDrags(drags);
              this.pullState = false;
            }, 1000);
            this.pictures = this.pictures.map((arr) => {
              arr.select = false;
              return arr;
            });
            this.$message.success({ content: "导入成功", key: "pull" });
            this.showDraw = false;
          });
        },
      });
    },
    async clearPhoto() {
      this.$confirm({
        title: "提示",
        content: "确认清除相框内所有照片吗？",
        centered: true,
        onOk: () => {
          this.pullState = true;
          const drags = [];
          let pullIndex = 0;
          this.drags.forEach((arr) => {
            if (arr.type == 1 || arr.type == 9) {
              arr.backgroundImg = "";
              arr.lockAspectRatio = true;
              pullIndex++;
              drags.push(arr);
            } else if (arr.type == 2) {
              arr.photoLeft = 0;
              arr.photoTop = 0;
              arr.photoScale = 1;
              arr.showPhoto = "";
              pullIndex++;
              drags.push(arr);
            }
          });

          this.$forceUpdate();
          this.$nextTick(() => {
            setTimeout(async () => {
              const res = await this.changeBatchDrags(drags);
              this.pullState = false;
              this.$message.success({ content: "清除成功", key: "pull" });
              this.showDraw = false;
            }, 1000);
          });
        },
      });
    },
    async changeBatchDrags(drags) {
      this.saveDraging = true;
      try {
        var res = await axios({
          method: "POST",
          url: api.domain + api.batchEdit,
          headers: { Authorization: this.$store.state.headers },
          data: {
            content: JSON.stringify(drags),
          },
        });
        if (res.data.status == 200) {
          this.saveDraging = false;
          return res;
        } else {
          this.$message.error(res.data.msg);
          this.saveDraging = false;
          return false;
        }
      } catch (error) {
        this.saveDraging = false;
        return false;
      }
    },
    rotatePhoto() {
      this.$refs.drag[this.activeIndex].rotatePhoto();
    },
    async uploadWaitDrag() {
      return true
      console.log(this.drag_eguc_check, this.waitTimeState);
      if (!this.drag_eguc_check) {
        return false;
      }
      if (!this.waitTimeState) {
        return false;
      }
      if (this.waitDrag) {
        clearTimeout(this.waitTime);
        var drags = [];
        var oldDrag = [];
        this.drags.forEach((arr) => {
          if (arr.ec_id == this.waitDrag.ec_id) {
            this.waitDrag = arr;
          }
        });
        this.studentList.forEach((arr) => {
          if (arr.select) {
            this.waitEditList.forEach((edit) => {
              var drag = _.cloneDeep(this.waitDrag);
              if (arr.id == edit.s_id) {
                console.log(edit.ec_id);
                drag.ec_id = edit.ec_id;
                drag.guc_id = edit.guc_id;
                drag.c_id = edit.c_id;
                drag.eguc_id = edit.eguc_id;
                delete drag.textarea;
                drags.push(drag);
                oldDrag.push(edit);
              }
            });
          }
        });

        var changeState = false;
        var waitId = "";
        this.drags.forEach((arr, index) => {
          drags.forEach((drag, index2) => {
            if (arr.ec_id == drag.ec_id) {
              changeState = true;
              waitId = arr.ec_id;
            }
          });
        });
        this.waitDrag = null;
        this.waitTimeState = false;
        if (!changeState) return false;
        var state = false;
        var drags2 = _.cloneDeep(drags);

        this.saveDraging = true;

        drags2.forEach((arr, index) => {
          drags2[index].showPhoto = this.clearUrl(drags2[index].showPhoto);
          drags2[index].backgroundImg = this.clearUrl(
            drags2[index].backgroundImg
          );
          // this.drags.forEach((arr2, index2) => {
          //   if (arr.ec_id == arr2.ec_id) {
          //     this.drags[index2].pushState = true;
          //   }
          // });
        });
        try {
          console.log(JSON.stringify(drags2));
          var res = await axios({
            method: "POST",
            url: api.domain + api.batchEdit,
            headers: { Authorization: this.$store.state.headers },
            data: {
              content: JSON.stringify(drags2).replace(/\\t/g, "    "),
            },
          });
          setTimeout(() => {
            this.saveDraging = false;
          }, 800);
          if (res.data.status == 200) {
            return true;
          } else {
            this.$message.error(res.data.msg);
            return false;
          }
        } catch (error) {
          this.$message.error("保存失败");
          this.saveDraging = false;
          return state;
        }
      }
    },
    async batchCancelDrag(eguc_ids, sids) {
      try {
        var res = await axios({
          method: "POST",
          url: api.domain + api.batchCancel,
          headers: { Authorization: this.$store.state.headers },
          data: {
            eguc_ids: eguc_ids,
            s_ids: sids,
          },
        });
        if (res.data.status == 200) {
          return true;
        } else {
          this.$message.error(res.data.msg);
          return false;
        }
      } catch (error) {
        return false;
      }
    },
    async batchChangeDrag(drags) {
      console.log(drags);
      var changeState = false;
      var waitId = "";
      var waitDrag = null;
      this.drags.forEach((arr) => {
        drags.forEach((drag) => {
          if (arr.ec_id == drag.ec_id) {
            changeState = true;
            waitDrag = arr;
            waitId = arr.ec_id;
          }
        });
      });
      if (!changeState) return false;
      console.log('咔嚓');
      // drags = drags.map((arr) => {
      //   if (arr && arr.textarea) arr.textarea = this.matchSpace(arr.textarea);
      //   return arr;
      // });
      var students = [];
      var student_num = 0;
      this.studentList.forEach((arr) => {
        if (arr.select) {
          student_num++;
          var has_element = false;
          this.editList.forEach((edit) => {
            if (arr.id == edit.s_id) {
              has_element = true;
              students.push(edit);
            }
          });
          arr.has_element = has_element;
          return arr;
        }
      });
      if (students.length < student_num) {
        // console.log(students, student_num);
        // this.$message.error("同位素缺失，不能编辑");
        // return false;
      }

      var state = false;
      var drags2 = _.cloneDeep(drags);
      // this.waitDrag = _.cloneDeep(waitDrag);
      this.waitEditList = _.cloneDeep(this.editList);
      this.saveDraging = true;
      drags2.forEach((arr, index) => {
        drags2[index].showPhoto = this.clearUrl(drags2[index].showPhoto);
        drags2[index].backgroundImg = this.clearUrl(
          drags2[index].backgroundImg
        );
        // this.drags.forEach((arr2, index2) => {
        //   if (arr.ec_id == arr2.ec_id) {
        //     this.drags[index2].pushState = true;
        //   }
        // });
      });
      try {
        var res = await axios({
          method: "POST",
          url: api.domain + api.batchEdit,
          headers: { Authorization: this.$store.state.headers },
          data: {
            content: JSON.stringify(drags2),
          },
        });
        setTimeout(() => {
          this.saveDraging = false;
        }, 800);
        if (res.data.status == 200) {
          if (this.waitDrag && waitId == this.waitDrag.ec_id) {
            this.uploadWaitDrag();
          }
          drags2.forEach((arr, index) => {
            this.drags.forEach((arr2, index2) => {
              if (arr.ec_id == arr2.ec_id) {
                this.drags[index2].pushState = false;
              }
            });
          });
          this.saveDraging = false;
        } else {
          this.$message.error(res.data.msg);
          this.saveDraging = false;
          return false;
        }
        return true;
      } catch (error) {
        if (this.waitDrag.ec_id && waitId == this.waitDrag.ec_id) {
          this.$message.error("保存失败,尝试重新保存");
        } else {
          this.$message.error("保存失败");
        }
        this.saveDraging = false;
        return state;
      }
    },
    check_drag_edit(id) {
      if (!id) {
        if (this.activeIndex < 0) return false;
        id = this.drags[this.activeIndex].eguc_id;
      }
      var dragIndex = -1;
      var students = [];
      var student_num = 0;
      var originDrag = null;
      this.drags.forEach((arr, index) => {
        if (arr.eguc_id == id) {
          originDrag = arr;
          dragIndex = index;
        }
      });
      try {
        this.studentList.forEach((arr, index) => {
          if (arr.select) {
            student_num++;
            var has_element = false;
            this.editList.forEach((edit) => {
              if (arr.id == edit.s_id) {
                if (edit.type != 1 && edit.type != 2) {
                  has_element = true;
                  students.push(edit);
                }
                if (
                  (edit.type == 1 || edit.type == 9) &&
                  this.clearUrl(originDrag.backgroundImg) ==
                    this.clearUrl(edit.backgroundImg)
                ) {
                  has_element = true;
                  students.push(edit);
                }
                if (
                  edit.type == 2 &&
                  this.clearUrl(originDrag.showPhoto) ==
                    this.clearUrl(edit.showPhoto)
                ) {
                  has_element = true;
                  students.push(edit);
                }
                // if (edit.type == 0 && (this.drags[this.activeIndex].textarea == edit.textarea || edit.textarea == '')) {
                //   has_element = true;
                //   students.push(edit);
                // }
              }
            });
            this.studentList[index].has_element = has_element;
          }
        });
      } catch (error) {
        console.log(error);
      }

      console.log(students, student_num, dragIndex);
      if (students.length < student_num && student_num > 1) {
        this.drag_eguc_check = false;
        this.$message.error("同位素不存在，不能编辑");
        this.$refs.drag[dragIndex].cancelActive();
        this.drags[dragIndex].draggable = false;
        this.activeIndex = -1;
        this.$forceUpdate();
      } else {
        this.drag_eguc_check = true;
        this.drags[dragIndex].draggable = true;
        this.drags[dragIndex].enable = true;
        this.$forceUpdate();
      }
    },
    async batchGetElement(id) {
      this.editState = false;
      this.editList = [];
      this.getElementState = true;
      var state = false;
      try {
        var res = await axios({
          method: "GET",
          url: api.domain + api.batchGetElement,
          headers: { Authorization: this.$store.state.headers },
          params: {
            guc_id: this.guc_id,
            eguc_id: id,
          },
        });
        this.getElementState = false;
        if (res.data.status == 201) {
          this.$message.error(res.data.msg);
          return false;
        }
        if (!res.data.data) return false;
        this.editList = res.data.data;
        this.editList = this.editList.map((arr) => {
          // arr.textarea = decodeURI(arr.textarea);
          arr.enable = false;
          return arr;
        });
        this.check_drag_edit(id);

        // setTimeout(() => {
        //   if (this.tabIndex == 7) {
        //     this.editList = this.editList.map((arr) => {
        //       arr.enable = true;
        //       return arr;
        //     });
        //   }
        // }, 400);
        return true;
      } catch (error) {
        this.getElementState = false;
        this.drag_eguc_check = false;
        return state;
      }
    },
    clearUrl(url) {
      if (!url) {
        url = "";
      } else if (url.indexOf("?") > -1) {
        url = url.split("?")[0];
      }
      return url;
    },
    async batchAddDrag(drag, ids2) {
      var ids = [];
      this.studentList.forEach((arr) => {
        if (arr.select) {
          ids.push(arr.id);
        }
      });
      console.log(drag);
      drag[0].zIndex = this.drags.length;
      drag = drag.map((arr) => {
        arr.backgroundImg = this.clearUrl(arr.backgroundImg);
        arr.showPhoto = this.clearUrl(arr.showPhoto);
        arr.backImg2 = this.clearUrl(arr.backImg2);
        return arr;
      });
      console.log(drag, this.drags.length);
      try {
        this.saveDraging = true;
        var res = await axios({
          method: "POST",
          url: api.domain + api.batchAdd,
          headers: { Authorization: this.$store.state.headers },
          data: {
            s_ids: ids2 ? ids2 : ids.join(","),
            guc_id: this.guc_id,
            content: JSON.stringify(drag),
          },
        });
        setTimeout(() => {
          this.saveDraging = false;
          this.visible = false;
          this.showDraw = "";
        }, 300);
        if (res.data.status == 201) {
          this.$message.error(res.data.msg);
          return false;
        }
        return res.data.data;
      } catch (error) {
        this.$message.error("保存失败");
        return false;
      }
    },
    changeFSize(size) {
      this.$set(this.drags[this.activeIndex], "fSize", size);
    },
    async nextStep() {
      if (this.step < this.czHistory.length - 1) {
        this.step++;
        this.changeStepState = true;
        var drags = _.cloneDeep(this.drags);
        if (this.czHistory[this.step].type == "change") {
          var changeState = await this.batchChangeDrag2(
            this.czHistory[this.step].detail.new
          );
          if (changeState) {
            this.drags.forEach((arr, index) => {
              this.czHistory[this.step].detail.new.map((newDrag) => {
                if (newDrag.ec_id == arr.ec_id) {
                  this.changeStepState = true;
                  this.drags.splice(index, 1);
                  const newdrag2 = _.cloneDeep(newDrag);
                  setTimeout(() => {
                    this.drags.splice(index, 0, newdrag2);
                    this.dragKey++;
                  }, 50);

                  // this.drags[index] = newDrag;
                }
              });
            });
          }
        }
        if (this.czHistory[this.step].type == "changeBack") {
          this.saveDraging = true;
          await axios({
            method: "POST",
            url: api.domain + api.batchEditBg,
            headers: { Authorization: this.$store.state.headers },
            data: {
              guc_id: this.guc_id,
              img_bg: this.czHistory[this.step].detail,
            },
          })
            .then((res) => {
              setTimeout(() => {
                this.saveDraging = false;
              }, 800);
              if (res.data.status == 201) {
                this.$message.error(res.data.msg);
                return false;
              }
              var back = _.cloneDeep(this.backgroundImage);
              this.backgroundImage = this.czHistory[this.step].detail;
              this.czHistory[this.step].detail = back;
            })
            .catch((res) => {
              console.log(res);
              this.$message.error("保存失败");
            });
        }
        if (this.czHistory[this.step].type == "delete") {
          var index = -1;
          this.drags.forEach((element, index2) => {
            if (
              element.ec_id == this.czHistory[this.step].detail.cancelDrag.ec_id
            ) {
              index = index2;
            }
          });
          if (index == -1) return false;
          var that = this;
          var delZindex = that.drags[index].zIndex;
          if (that.drags[index].eguc_id) {
            var res = await that.batchDel(
              that.drags[index].eguc_id,
              this.czHistory[this.step].detail.sids
            );
            if (res) {
              that.activeIndex = -1;
              that.drags.splice(index, 1);
              if (that.drags.length > 0) {
                that.drags.map((arr) => {
                  if (arr.zIndex > delZindex) {
                    arr.zIndex--;
                  }
                  return arr;
                });
              }
            }
          }
        }
        if (this.czHistory[this.step].type == "adddrag") {
          var drags = this.czHistory[this.step].detail.new;
          var addState = await this.batchAddDrag(drags);
          if (addState) {
            this.drags = [...this.drags, ...addState];
            var getElement = await this.batchGetElement(addState[0].eguc_id);
            var ids = [];
            if (getElement) {
              this.studentList.forEach((arr) => {
                if (arr.select) {
                  this.editList.forEach((edit) => {
                    if (arr.id == edit.s_id) {
                      ids.push(edit.ec_id);
                    }
                  });
                }
              });
            }
            this.czHistory[this.step] = {
              type: "adddrag",
              index: null,
              detail: {
                new: addState,
                old: null,
                sids: this.czHistory[this.step].detail.sids,
              },
            };
            console.log(this.czHistory[this.step]);
          }
        }
        if (this.czHistory[this.step].type == "confirmCom") {
          this.confirmComb(this.czHistory[this.step].index, true);
        }
        this.originDrags = _.cloneDeep(this.drags);
        this.$forceUpdate();
      }
    },
    saveHistoryChange() {
      if (this.historyChangeState) {
        this.savePlateContent();
      }
      this.saveTimeout = setTimeout(() => {
        this.saveHistoryChange();
      }, 10000);
    },
    listenMouseDown(e) {
      if (this.leftChatMouseStateMove) {
        this.leftChatPointX = e.layerX;
        this.leftChatPointY = e.layerY;
        this.originbodyTranslateX = this.bodyTranslateX;
        this.originbodyTranslateY = this.bodyTranslateY;
        this.$refs["leftChat"].addEventListener(
          "mousemove",
          this.listenMouseMove
        );
      }
    },
    handleShowPageModel() {
      this.pageModal = true;
      this.$router.push({
        path: `/pages2/${this.s_id}/${this.guc_id}`,
        query: { page: this.page, name: this.studentName },
      });
    },
    changeHeight(height, index) {
      this.drags[index].height = height;
    },
    changeLevelData(type, num, level, size, index) {
      console.log("2321312312");
      if (
        this.drags[this.activeIndex].type == 0 &&
        this.drags[this.activeIndex].lineHeightAutoSize
      ) {
        var maxFsize = size;
        // this.editText = this.matchSpace(this.editText);
        if (maxFsize) {
          this.drags[this.activeIndex].lineHeight = Math.ceil(maxFsize * 1.23);
        } else {
          this.drags[this.activeIndex].lineHeight = 18;
        }
      }
      setTimeout(() => {
        if (this.editList.length) {
          this.changeDragHistory(index);
        }
      }, 100);
    },
    listenMouseMove(e) {
      if (!this.leftChatMouseStateMove) {
        this.$refs["leftChat"].removeEventListener(
          "mousemove",
          this.listenMouseMove
        );
        return false;
      }
      e.stopPropagation();
      var transformX = this.leftChatPointX - e.layerX;
      var transformY = this.leftChatPointY - e.layerY;
      this.bodyTranslateX = this.originbodyTranslateX - transformX;
      this.bodyTranslateY = this.originbodyTranslateY - transformY;
    },
    async changeDragHistory(index, type, editList) {
      try {
        var drags = [];
        var oldDrag = [];
        var sids = [];

        if (this.drags[index].type == 5 && type == "text") {
          this.studentList.forEach((arr) => {
            if (arr.select) {
              editList.forEach((edit) => {
                var drag = _.cloneDeep(this.drags[index]);
                if (arr.id == edit.s_id) {
                  console.log(edit.ec_id);
                  drag.ec_id = edit.ec_id;
                  drag.guc_id = edit.guc_id;
                  drag.c_id = edit.c_id;
                  drag.eguc_id = edit.eguc_id;

                  if (!type) {
                    delete drag.textarea;
                  } else {
                  }
                  drags.push(drag);
                  oldDrag.push(edit);
                  sids.push(edit.s_id);
                }
              });
            }
          });
        } else {
          let editList = [];
          const studentList = _.cloneDeep(this.studentList);

          var res = await axios({
            method: "GET",
            url: api.domain + api.batchGetElement,
            headers: { Authorization: this.$store.state.headers },
            params: {
              guc_id: this.guc_id,
              eguc_id: this.drags[index].eguc_id,
            },
          });
          if (res.data.status == 200) {
            editList = res.data.data;

            studentList.forEach((arr, studentIndex) => {
              if (arr.select) {
                editList.forEach((edit) => {
                  var drag = _.cloneDeep(this.drags[index]);

                  drag.photoScale = drag.photoScale ? drag.photoScale : 1;
                  if (arr.id == edit.s_id) {
                    drag.ec_id = edit.ec_id;
                    drag.guc_id = edit.guc_id;
                    drag.c_id = edit.c_id;
                    drag.eguc_id = edit.eguc_id;

                    if (
                      (edit.type == 1 || edit.type == 9) &&
                      arr.id != this.s_id && drag.type != 2
                    ) {
                      drag.backgroundImg = this.clearUrl(drag.backgroundImg);
                      drag.type = 9
                    }

                    if (edit.type == 2 && arr.id != this.s_id) {
                      drag.backgroundImg = this.clearUrl(drag.backgroundImg);
                      drag.showPhoto = this.clearUrl(drag.showPhoto);
                      // drag.showPhoto = edit.showPhoto
                      // ? this.clearUrl(edit.showPhoto)
                      // : this.clearUrl(drag.showPhoto);
                      // drag.photoLeft = edit.photoLeft;
                      // drag.photoTop = edit.photoTop;
                      // drag.photoScale = edit.photoScale ? edit.photoScale : 1;
                      // console.log(edit.photoScale)
                      // drag.photoRotate = edit.photoRotate;
                    }
                    if (drag.type == 2 && edit.type == 9) {
                      drag.bRight = 0;
                      drag.bBottom = 0;
                      drag.bLeft = 0;
                      drag.bTop = 0;
                      drag.backgroundImg = this.clearUrl(drag.backgroundImg);
                      drag.backImg2 = this.clearUrl(drag.backImg2)
                      drag.showPhoto =  this.clearUrl(edit.showPhoto);
                    }
                    if (!type) {
                      delete drag.textarea;
                    } else {
                    }
                    drags.push(drag);
                    oldDrag.push(edit);
                    sids.push(edit.s_id);
                  }
                });
              }
            });
          }
        }
        var changeDrag = _.cloneDeep(this.drags[index]);

        var changeState;
        if (type) {
          changeState = await this.batchChangeDrag2(drags);
        } else {
          changeState = await this.batchChangeDrag(drags);
        }
        const indexNum = _.cloneDeep(index);
        if (changeState) {
          this.drags[index].spinning = false;
          this.drags[index].draggable = true;
          this.getPhoto();
          this.photoChangeState = "";
          if (this.step < this.czHistory.length - 1) {
            this.czHistory.splice(
              this.step + 1,
              this.czHistory.length - this.step - 1
            );
          }
          console.log(oldDrag, changeDrag);
          this.czHistory = [
            ...this.czHistory,
            {
              type: "change",
              index: index,
              detail: { new: drags, old: oldDrag, changeDrag: changeDrag },
              ids: sids,
            },
          ];
          this.originDrags = _.cloneDeep(this.drags);
          this.step = this.czHistory.length - 1;
        }
      } catch (error) {
        console.log(error);
      }

      return false;
    },
    confirmPageType() {
      if (!this.addType) {
        axios({
          method: "POST",
          url: api.domain + api.addPlateContent,
          data: {
            uid: this.uid,
            t_id: this.plate_id,
            type: this.selectPageType,
            page_num: this.selectPageType == 2 ? this.maxPage + 1 : 0,
            thumb: "",
          },
        })
          .then((res) => {
            if (res.data.status == 200) {
              this.$message.success(res.data.msg);
              this.getPlateRows(true);
              this.showTypeSelect = false;
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((res) => {
            // this.$message('请求错误')
          });
      } else {
        var plate = null;
        this.plateList.forEach((arr) => {
          if (arr.select) {
            plate = arr;
          }
        });
        if (!plate) {
          this.$message.error("请先选择复制的模板");
        } else {
          console.log(plate);
          axios({
            method: "POST",
            url: api.domain + api.copyPlate,
            data: {
              uid: this.uid,
              st_id: plate.t_id,
              tt_id: this.plate_id,
            },
          })
            .then((res) => {
              if (res.data.status == 200) {
                this.$message.success(res.data.msg);
                this.getPlateRows();
                this.showTypeSelect = false;
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch((res) => {
              // this.$message('请求错误')
            });
        }
      }
    },
    onChangeAutoSize(e) {
      console.log(e);
      this.drags[this.activeIndex].lineHeightAutoSize = e.target.checked
        ? 1
        : 0;
      if (e.target.checked) {
        this.drags[this.activeIndex].lineHeight = Math.ceil(
          this.drags[this.activeIndex].fSize * 1.23
        );
      }
      this.changeDragHistory(this.activeIndex);
    },
    changePage(e) {
      this.selectPageType = e;
      console.log(e);
    },
    addPage() {
      this.showTypeSelect = true;
    },
    async handleRemoveDrag2(index2) {
      console.log(index2);
      var index = index2 ? index2 : this.activeIndex;
      console.log(index);
      if (this.drags[index].lock) return false;
      if (index < 0) return false;

      var that = this;
      var delZindex = that.drags[index].zIndex;
      var ids = [];
      var sids = [];
      that.studentList.forEach((arr) => {
        if (arr.select) {
          sids.push(arr.id);
        }
      });
      // this.drags[this.activeIndex].active = true;
      // this.$message.loading({ content: "删除中", key: "del", duration: 2 });
      if (that.drags[index].eguc_id) {
        var drag = that.drags[index];
        var res = await that.batchDel(drag.eguc_id, sids.join(","));
        if (res) {
          that.activeIndex = -1;
          that.drags.splice(index, 1);
          if (this.step < this.czHistory.length - 1) {
            this.czHistory.splice(
              this.step + 1,
              this.czHistory.length - this.step - 1
            );
          }
          that.czHistory = [
            ...this.czHistory,
            {
              type: "delete",
              index: index - 1,
              detail: { eguc_ids: drag.eguc_id, sids: sids, cancelDrag: drag },
              ids: sids.join(","),
            },
          ];
          // this.$message.success({
          //   content: "删除成功",
          //   key: "del",
          //   duration: 2,
          // });
          this.step++;
          if (that.drags.length > 0) {
            that.drags.map((arr) => {
              if (arr.zIndex > delZindex) {
                arr.zIndex--;
              }
              return arr;
            });
          } else {
            that.activeIndex = -1;
          }
        }
      }
    },
    async removeDragNoStep(index) {
      // if (this.drags[index].lock || this.pageDetail.is_locked) return false;
      var that = this;
      var delZindex = that.drags[index].zIndex;
      var sids = [];
      that.studentList.forEach((arr) => {
        if (arr.select) {
          sids.push(arr.id);
        }
      });
      if (that.drags[index].eguc_id) {
        var res = await that.batchDel(
          that.drags[index].eguc_id,
          sids.join(",")
        );
        if (res) {
          that.activeIndex = -1;
          that.drags.splice(index, 1);
          if (that.drags.length > 0) {
            that.drags.map((arr) => {
              if (arr.zIndex > delZindex) {
                arr.zIndex--;
              }
              return arr;
            });
          }
        }
      }
    },
    async confirmComb(index, state = false) {
      console.log(state);
      var drags = _.cloneDeep(this.drags[index].coms);
      var originDrag = _.cloneDeep(this.drags[index]);

      drags = drags.map((arr) => {
        const scaleX = this.drags[index].orignWidth
          ? this.drags[index].width / this.drags[index].orignWidth
          : 1;
        const scaleY = this.drags[index].orignHeight
          ? this.drags[index].height / this.drags[index].orignHeight
          : 1;
        arr.left = arr.left * scaleX + originDrag.left;
        arr.top = arr.top * scaleY + originDrag.top;
        arr.width = arr.width * scaleX;
        arr.height = arr.height * scaleY;
        arr.c_id ? delete arr.c_id : () => {};
        arr.bu_id ? delete arr.bu_id : () => {};
        arr.ebu_id ? delete arr.ebu_id : () => {};
        arr.create_time ? delete arr.create_time : () => {};
        arr.update_time ? delete arr.update_time : () => {};
        return arr;
      });
      var ids = [];
      this.studentList.forEach((arr) => {
        if (arr.select) {
          ids.push(arr.id);
        }
      });
      drags.forEach((drag) => {
        this.saveDraging = true;
        axios({
          method: "POST",
          url: api.domain + api.batchAdd,
          headers: { Authorization: this.$store.state.headers },
          data: {
            s_ids: ids.join(","),
            guc_id: this.guc_id,
            content: JSON.stringify([drag]),
          },
        })
          .then((res) => {
            setTimeout(() => {
              this.saveDraging = false;
            }, 800);
            this.drags = [...this.drags, ...res.data.data];
          })
          .catch((res) => {
            this.$message.error("保存失败");
          });
      });
      const drag = _.cloneDeep(this.drags[index]);
      await this.removeDragNoStep(index);
      this.allIndex = this.drags.length;
      console.log(state, 1);
      if (state) return;
      console.log(state, 2);
      if (this.step < this.czHistory.length - 1) {
        this.czHistory.splice(
          this.step + 1,
          this.czHistory.length - this.step - 1
        );
      } else {
        this.czHistory = [
          ...this.czHistory,
          {
            type: "confirmCom",
            index: index,
            detail: drag,
            ids: ids.join(","),
          },
        ];
      }
      this.step++;
      // var ids = [];
      //   this.studentList.forEach((arr) => {
      //     if (arr.select) {
      //       ids.push(arr.id);
      //     }
      //   });
      //   this.saveDraging = true;
      //   axios({
      //     method: "POST",
      //     url: api.domain + api.batchAdd,
      //     headers: { Authorization: this.$store.state.headers },
      //     data: {
      //       s_ids: ids.join(","),
      //       guc_id: this.guc_id,
      //       content: JSON.stringify(drags),
      //     },
      //   })
      //     .then((res) => {
      //       setTimeout(() => {
      //         this.saveDraging = false;
      //       }, 800);
      //       this.drags = [...this.drags, ...res.data.data];
      //     })
      //     .catch((res) => {
      //       this.$message.error("保存失败");
      //     });
    },
    async addDrag(e) {
      console.log("adddrag" + JSON.stringify(e.y));
      if (this.pageDetail.is_locked) {
        this.$message.error("页面已锁定不支持新增");
        return false;
      }
      var drag;
      if (this.ComIndex >= 0) {
        console.log(this.buildUp);
        drag = _.cloneDeep(this.buildUp[this.ComIndex]);
        drag.left = e.layerX - drag.width / 2;
        drag.top = e.layerY - drag.height / 2;
        drag.orignWidth = drag.width;
        drag.orignHeight = drag.height;
      } else if (this.selectPhoto) {
        console.log(e.layerY, this.selectHeight);
        this.selectPhoto.left = e.layerX - this.selectPhoto.width / 2;
        this.selectPhoto.top = e.layerY;
        drag = {
          allIndex: this.drags.length + 1,
          left: e.layerX - this.selectPhoto.width / 2,
          top:
            e.layerY -
            (this.selectPhoto.height != "auto"
              ? this.selectPhoto.height
              : this.selectHeight) /
              2,
          width: this.selectPhoto.width,
          height: this.selectPhoto.height ? this.selectPhoto.height : "auto",
          rotate: this.selectPhoto.rotate,
          lockAspectRatio: this.selectPhoto.lockAspectRatio,
          textarea: this.selectPhoto.textarea,
          minW: this.selectPhoto.minW,
          minH: this.selectPhoto.minH,
          type: this.selectPhoto.type,
          backgroundImg: this.selectPhoto.backgroundImg,
          backImg2: this.selectPhoto.backImg2,
          maxW: this.selectPhoto.maxW,
          maxH: this.selectPhoto.maxH,
          lock: this.selectPhoto.lock,
          zIndex: this.drags.length,
          bColor: this.selectPhoto.bColor,
          fSize: this.selectPhoto.fSize,
          fColor: this.selectPhoto.fColor,
          bordersColor: this.selectPhoto.bordersColor,
          bLeft: this.selectPhoto.bLeft,
          bTop: this.selectPhoto.bTop,
          bRight: this.selectPhoto.bRight,
          bBottom: this.selectPhoto.bBottom,
          bStyle: this.selectPhoto.bStyle,
          borderRadius: this.selectPhoto.borderRadius,
          paddingLeft: this.selectPhoto.paddingLeft,
          paddingTop: this.selectPhoto.paddingTop,
          paddingRight: this.selectPhoto.paddingRight,
          paddingBottom: this.selectPhoto.paddingBottom,
          opacity: this.selectPhoto.opacity,
          showPhoto: this.selectPhoto.showPhoto,
          lineHeight: this.selectPhoto.lineHeight,
          fontWeight: this.selectPhoto.fontWeight,
          fontStyle: this.selectPhoto.fontStyle,
          textAlign: this.selectPhoto.textAlign,
          combs: this.selectPhoto.type == 3 ? this.selectPhoto.combs : null,
          level: this.selectPhoto.level,
          levelType: this.selectPhoto.levelType,
          levelNum: this.selectPhoto.levelNum,
        };
      }
      var addState = await this.batchAddDrag([drag]);
      if (addState.length > 0) {
        addState[0].lineHeightAutoSize = 1;
        this.drags = [...this.drags, ...addState];
        this.drags = this.drags.map((arr, index) => {
          arr.active = false;
          if (index == this.drags.length - 1) {
            arr.active = true;
          }
          return arr;
        });
        this.activeIndex = this.drags.length - 1;
        this.$nextTick(() => {
          this.calcPos(this.activeIndex);
        });
        this.allIndex = this.drags.length;
        this.selectPhoto = null;
        this.ComIndex = -1;
        var getElement = await this.batchGetElement(addState[0].eguc_id);
        var ids = [];
        var sids = [];
        if (getElement) {
          this.studentList.forEach((arr) => {
            if (arr.select) {
              this.editList.forEach((edit) => {
                if (arr.id == edit.s_id) {
                  ids.push(edit.ec_id);
                  sids.push(arr.id);
                }
              });
            }
          });
        }
        this.czHistory = [
          ...this.czHistory,
          {
            type: "adddrag",
            index: null,
            detail: { new: addState, old: null, sids: sids.join(",") },
            ids: ids.join(","),
          },
        ];
        this.step++;
        this.originDrags = _.cloneDeep(this.drags);
      }
    },
    beforeUpload(file) {
      const isBig = file.size / 1024 / 1024 > 1.5;
      return true;
      if (!isBig) {
        this.$message.error("照片不得小于1.5MB!");
      }
      return isBig;
    },
    save() {
      if (this.drags.length == 0) {
        this.$message.error("请先添加组件");
        return false;
      }
      axios({
        method: "POST",
        url: api.domain + api.getBuiltUp,
        data: {
          uid: this.uid,
          thumb: "",
          content: this.drags,
        },
      })
        .then((res) => {
          this.$message.info("保存组合成功");
          if (res.data.status == 200) {
            this.drags = [];
          }
        })
        .catch(() => {});
    },
    getBuiltUp() {
      axios({
        method: "GET",
        url: api.domain + api.getBuiltUp2,
        headers: { Authorization: this.$store.state.headers },
        params: {
          tags: this.buildUpTag,
          type: this.buildUpType,
          limit: 15,
          page: this.currentBuild,
        },
      })
        .then((res) => {
          this.buildUpPage = res.data.data;
          this.buildUp = [];
          res.data.data.data.forEach((arr, index) => {
            var coms = arr.content;
            let data;
            coms.forEach((com, index) => {
              if (index == 0) {
                data = arr.content[0];
                var maxL = data.width > data.height ? data.width : data.height;
                data.scale = 99 / maxL;
                data.type = 3;
                data.coms = [];
              } else {
                data.coms.push(com);
              }
            });
            this.buildUp.push(data);
          });
          console.log(this.buildUp);
        })
        .catch((res) => {});
    },
    refreshAlbum() {
      this.getPhoto();
    },
    getFrame() {
      axios({
        method: "POST",
        url: api.domain + api.getFrame2,
        headers: { Authorization: this.$store.state.headers },
        data: {
          tags: this.frameTag,
          type: this.frameType,
          limit: 14,
          page: this.currentFrame,
        },
      })
        .then((res) => {
          console.log(res);
          this.photoPage = res.data.data;
          this.photos = [];
          res.data.data.data.forEach((arr) => {
            this.photos.push({
              left: null,
              top: null,
              width: 160,
              height: "auto",
              rotate: 0,
              lockAspectRatio: true,
              aspectFactor: null,
              textarea: "",
              minW: null,
              minH: null,
              maxW: null,
              maxH: null,
              lock: false,
              zIndex: null,
              bColor: "",
              fColor: null,
              fSize: 14,
              bordersColor: null,
              bLeft: 0,
              bTop: 0,
              bRight: 0,
              bBottom: 0,
              bStyle: "solid",
              paddingLeft: 0,
              paddingTop: 0,
              paddingRight: 0,
              paddingBottom: 0,
              opacity: 100,
              shadow: false,
              active: false,
              backgroundImg: this.clearUrl(arr.top)
                ? this.clearUrl(arr.top) +
                  "?x-image-process=image/resize,w_100/quality,Q_80"
                : "",
              backImg2: this.clearUrl(arr.shade)
                ? this.clearUrl(arr.shade) +
                  "?x-image-process=image/resize,w_100/quality,Q_80"
                : "",
              borderRadius: 0,
              type: 2,
              name: "相框二（无规则）",
              lineHeight: "18",
              fontStyle: "horizontal-tb",
              fontWeight: "normal",
              textAlign: "left",
            });
          });
        })
        .catch((res) => {
          // this.$message('请求错误')
        });
    },
    getPhoto() {
      var ids = [];
      // this.studentList.forEach((arr) => {
      //   if (arr.select) {
      //     ids.push(arr.id);
      //   }
      // });
      this.photoLoading = true;
      axios({
        method: "GET",
        url: api.domain + api.getPhoto2,
        headers: { Authorization: this.$store.state.headers },
        params: {
          s_id: this.s_id,
          album_id: this.album_id,
          limit: 12,
          page: this.currentPhoto,
        },
      })
        .then((res) => {
          this.picturePage = res.data.data;
          this.pictures = res.data.data.data.map((arr) => {
            arr.img_url += "?x-image-process=image/resize,w_180/quality,Q_80";
            return arr;
          });
          setTimeout(() => {
            this.photoLoading = false;
          }, 600);
          this.$forceUpdate();
        })
        .catch((res) => {
          // this.$message('请求错误')
          setTimeout(() => {
            this.photoLoading = false;
          }, 600);
        });
    },
    getPasterClass() {
      axios({
        method: "POST",
        url: this.$api.domain + this.$api.pasterClass,
        data: {
          uid: 18,
          limit: 100,
        },
        headers: { Authorization: this.$store.state.headers },
      })
        .then((res) => {
          this.pasterClass = res.data.data.rows;
        })
        .catch((res) => {
          // this.$message('请求错误')
        });
    },
    getPaster() {
      if (this.pasterType == 3) {
        axios({
          method: "GET",
          url: this.$api.domain + this.$api.personalPhoto,
          headers: { Authorization: this.$store.state.headers },
          params: {
            limit: 16,
            page: this.currentPaster,
          },
        })
          .then((res) => {
            if (res.data.status == 200 && res.data.data) {
              this.imgs = res.data.data.list;
              this.imgPage = {
                total: res.data.data.count,
                current_page: this.currentPaster,
              };
              console.log(this.imgPage);
            }
          })
          .catch((res) => {
            console.log(res);
            console.log("getpaster错误");
            this.$message.error("服务器或网络错误");
          });
        return false;
      }
      axios({
        method: "POST",
        url: api.domain + api.getPaster2,
        headers: { Authorization: this.$store.state.headers },
        data: {
          tags: this.pasterTag,
          type: this.pasterType,
          limit: 16,
          page: this.currentPaster,
        },
      })
        .then((res) => {
          this.imgPage = res.data.data;
          console.log(this.imgPage);
          this.imgs = [];
          for (var index in res.data.data.data) {
            res.data.data.data[index].paster +=
              "?x-image-process=image/resize,w_100/quality,Q_80";
            this.imgs.push(res.data.data.data[index]);
          }
          console.log(this.imgs);
        })
        .catch((res) => {
          // this.$message('请求错误')
        });
    },
    getBackground() {
      axios({
        method: "POST",
        url: api.domain + api.getBackground2,
        headers: { Authorization: this.$store.state.headers },
        data: {
          tags: this.backgroundTag,
          size: this.cover_size.join("*"),
          limit: 12,
          type: this.backgroundType,
          page: this.currentBack,
        },
      })
        .then((res) => {
          this.backPage = res.data.data;
          this.backs = res.data.data.data.map((arr) => {
            arr.background = arr.background
              ? arr.background +
                "?x-image-process=image/resize,w_100/quality,Q_80"
              : "";
            return arr;
          });
        })
        .catch((res) => {});
    },
    onCloseEdit() {
      this.showDraw = "";
      this.confirmEdit();
      this.$forceUpdate();
    },
    onChangeImgPage(e) {
      this.currentPaster = e;
      this.getPaster();
    },
    onChangeBuildPage(e) {
      this.currentBuild = e;
      this.getBuiltUp();
    },
    onChangeframePage(e) {
      this.currentFrame = e;
      this.getFrame();
      this.getFrame2();
    },
    onChangeframePage2(e) {
      this.currentFrame2 = e;
      this.getFrame2();
    },
    onChangepicturePage(e) {
      this.currentPhoto = e;
      this.getPhoto();
    },
    changePageNum(index) {
      this.currentRowPage = index;
      this.czHistory = [];
      this.historyChangeState = false;
      this.activeIndex = -1;
      this.getPlateContent(this.pageObject[index].tc_id);
    },
    selectStudent(index, $event) {
      this.uploadWaitDrag();
      this.activeIndex = -1;
      this.studentList = this.studentList.map((arr) => {
        arr.has_element = true;
        return arr;
      });
      if (this.moreSelect && !this.selectState) {
        this.studentList[index].select = !this.studentList[index].select;
        this.getPhoto();
        this.$forceUpdate();
        return false;
      }
      if ($event.ctrlKey && !this.selectState) {
        this.studentList[index].select = !this.studentList[index].select;
        this.getPhoto();
        this.$forceUpdate();
        return false;
      }
      if ($event.ctrlKey && this.selectState) {
        this.studentName = this.studentList[index].name;
        this.s_id = this.studentList[index].id;
        this.getGrowupDetail();
        this.getPhoto();
        this.$forceUpdate();
        return false;
      }
      if (this.moreSelect && this.selectState) {
        this.studentName = this.studentList[index].name;
        this.s_id = this.studentList[index].id;
        this.getGrowupDetail();
        this.getPhoto();
        this.$forceUpdate();
        return false;
      }
      this.studentList = this.studentList.map((arr) => {
        arr.select = false;
        return arr;
      });
      this.studentList[index].select = true;
      this.selectState = false;
      this.studentName = this.studentList[index].name;
      this.s_id = this.studentList[index].id;
      this.getGrowupDetail();
      this.getPhoto();
      this.$forceUpdate();
    },
    onChangeBackPage(e) {
      this.currentBack = e;
      this.getBackground();
    },
    // changeContent(content, height, oldContent, index) {
    //   console.log('changetext' + index)
    //   console.log(content, height, oldContent, index)
    //   this.$set(this.drags[index], 'textarea', content)
    //   // this.drags[index].textarea = content;
    //   this.changeDragHistory(index, "text", oldContent);
    //   // this.$forceUpdate();
    // },
    changeContent(content, height, oldContent, index) {
      console.log("changetext" + index);
      console.log(content, height, oldContent, index);
      oldContent = this.drags[index].textarea;
      this.$set(this.drags[index], "textarea", content);
      this.changeDragHistory(index, "text", oldContent);
      // this.$forceUpdate();
    },
    handleMoveCom(e) {
      e.preventDefault;
      e.stopPropagation;
    },

    rightClick(e) {
      console.log(e);
    },
    handleSelectCombination(e, index) {
      e.preventDefault;
      e.stopPropagation;
      console.log(index);
      this.ComIndex = index;
      // var fixcom = document.getElementById("fixcom");
      // console.log(this.$refs.comItem[index]);
      // this.comHtml = this.$refs.comItem[index];
    },
    handleEndMovecom() {
      setTimeout(() => {
        this.ComIndex = -1;
      }, 400);
    },
    mouseUpCombination() {},
    handleSelectPhoto2(photo, index) {
      this.selectPhoto = photo;
      this.selectHeight = (160 / 100) * this.$refs.frame[index].height;
    },
    async changeDragImg(url) {
      
      if (this.pullPhotoState) return false;
      if (this.activeIndex > -1) {
        let index = this.activeIndex
        if (!this.selectImg) return false;
        if (this.drags[index].spinning) {
          this.$message.error("组件正在保存，请稍后");
          return;
        }
        this.drags[index].spinning = true;
        await this.batchGetElement(this.drags[index].eguc_id);
        if (!this.drag_eguc_check) {
          this.drags[index].spinning = false;
          return false;
        }
        this.changeStepState = false;
        if (this.drags[index].type == 1 || this.drags[index].type == 9) {
          if (
            this.clearUrl(this.selectImg) !=
            this.clearUrl(this.drags[index].backgroundImg)
          ) {
            this.drags[index].spinning = true;
            this.drags[index].draggable = false;
          } else {
            this.drags[index].spinning = false;
          }

          this.drags[index].lockAspectRatio = true;
          this.drags[index].backgroundImg =
            this.clearUrl(this.selectImg) +
            "?x-image-process=image/resize,w_650/quality,Q_120";
        } else if (this.drags[index].type == 2) {
          if (
            this.clearUrl(this.selectImg) !=
            this.clearUrl(this.drags[index].showPhoto)
          ) {
            this.drags[index].spinning = true;
            this.drags[index].draggable = false;
            this.drags[index].showPhoto =
              this.clearUrl(this.selectImg) +
              "?x-image-process=image/resize,w_650/quality,Q_120";
          } else {
            this.drags[index].spinning = false;
            console.log("ha2");
          }
        }
        this.selectImg = "";
        this.showDraw = "";
        this.$forceUpdate();
      }
      setTimeout(() => {
        this.visible = false;
      }, 100);
    },
    handleSelectPhotoUrl(url, index) {
      this.selectPhoto = {
        left: null,
        top: null,
        width: 160,
        height: "auto",
        rotate: 0,
        lockAspectRatio: true,
        aspectFactor: null,
        textarea: "",
        minW: null,
        minH: null,
        maxW: null,
        maxH: null,
        lock: false,
        zIndex: null,
        bColor: "",
        fColor: null,
        fSize: 14,
        bordersColor: null,
        bLeft: 0,
        bTop: 0,
        bRight: 0,
        bBottom: 0,
        bStyle: "solid",
        paddingLeft: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        opacity: 100,
        shadow: false,
        active: false,
        backgroundImg: url,
        backImg2: "",
        borderRadius: 0,
        type: 0,
        lineHeight: "18",
        fontStyle: "horizontal-tb",
        fontWeight: "normal",
        textAlign: "left",
      };
      console.log(this.$refs.paster[index].height);
      this.selectHeight = (160 / 100) * this.$refs.paster[index].height;
      console.log(this.selectPhoto);
    },
    handleStarSelect() {
      this.selectPhoto = this.stars;
    },
    addStar() {
      this.selectPhoto = this.stars;
      this.addDrag({ layerX: this.wrapperWidth / 2, layerY: 350 });
      setTimeout(() => {
        this.visible = false;
      }, 100);
    },
    handleSelectText() {
      this.selectPhoto = this.texts;
    },
    handleAddSquire(index) {
      this.selectPhoto = this.suireList[index];
    },
    addSquire(index) {
      this.selectPhoto = this.suireList[index];
      this.addDrag({ layerX: this.wrapperWidth / 2, layerY: 350 });
      setTimeout(() => {
        this.visible = false;
      }, 100);
    },
    addTextIndent() {
      if (this.drags[this.activeIndex].textIndent == 9) return false;

      const s = this.drags[this.activeIndex].textIndent
        ? this.drags[this.activeIndex].textIndent + 1
        : 1;
      this.$set(this.drags[this.activeIndex], "textIndent", s);
    },
    decTextIndent() {
      if (this.drags[this.activeIndex].textIndent == 0) return false;
      console.log(this.drags[this.activeIndex].textIndent);
      const s = this.drags[this.activeIndex].textIndent
        ? this.drags[this.activeIndex].textIndent - 1
        : 0;
      this.$set(this.drags[this.activeIndex], "textIndent", s);
    },
    changePasterClassId(e) {
      this.pasterClassId = e;
      this.currentPaster = 1;
      this.getPaster();
    },
    calcelPhoto() {
      if (
        this.drags[this.activeIndex].type == 1 ||
        this.drags[this.activeIndex].type == 9
      ) {
        this.drags[this.activeIndex].backgroundImg = "";
      } else {
        this.drags[this.activeIndex].showPhoto = "";
        this.drags[this.activeIndex].photoLeft = 0;
        this.drags[this.activeIndex].photoTop = 0;
        this.drags[this.activeIndex].photoScale = 1;
      }
      this.visible = false;
    },
    async selectBuildup(index) {
      console.log("comindex");
      this.ComIndex = index;
      await this.addDrag({ layerX: this.wrapperWidth / 2, layerY: 350 });
      this.visible = false;
    },
    async dropImg(index, e) {
      if (this.selectPhoto || this.ComIndex > -1) {
        await this.addDrag(e);
        return false;
      }
      if (!this.selectImg) return false;
      this.activeIndex = index;
      await this.batchGetElement(this.drags[index].eguc_id);
      this.hasChangePhoto = true;
      if (this.drags[index].type == 1 || this.drags[index].type == 9) {
        this.drags[index].backgroundImg = this.clearUrl(this.selectImg);
      } else {
        this.drags[index].showPhoto = this.clearUrl(this.selectImg);
        this.drags[index].photoLeft = 0;
        this.drags[index].photoTop = 0;
        this.drags[index].photoScale = 1;
      }
      this.$forceUpdate();
      this.selectImg = "";
    },
    mouseUpPhoto() {
      setTimeout(() => {
        this.selectPhoto = null;
      }, 80);
    },
    handleSelectPhoto(img) {
      this.selectPhoto = null;
      this.selectImg = img;
    },
    listenMouseEnter(dragIndex, zIndex) {
      this.mouseIn.push(this.dragIndex);
    },
    listenMouseLeave(dragIndex, zIndex) {
      this.mouseIn.forEach((arr, index) => {
        if (arr == dragIndex) {
          this.mouseIn.splice(index, 1);
        }
      });
    },
    up() {
      if (this.drags[this.activeIndex].zIndex == this.drags.length - 1)
        return false;

      this.drags = this.drags.map((arr, index) => {
        if (
          this.drags[index].zIndex ==
          this.drags[this.activeIndex].zIndex + 1
        ) {
          arr.zIndex--;
        }
        return arr;
      });
      this.drags[this.activeIndex].zIndex++;
      this.changeDragHistory(this.activeIndex);
    },
    edit() {
      this.$refs.drag[this.activeIndex].showEdit();
    },
    down() {
      if (this.drags[this.activeIndex].zIndex == 0) return false;

      this.drags = this.drags.map((arr, index) => {
        if (
          this.drags[index].zIndex ==
          this.drags[this.activeIndex].zIndex - 1
        ) {
          arr.zIndex++;
        }
        return arr;
      });
      this.drags[this.activeIndex].zIndex--;
      this.changeDragHistory(this.activeIndex);
    },
    toTop() {
      if (this.drags[this.activeIndex].zIndex == this.drags.length - 1)
        return false;

      this.drags = this.drags.map((arr, index) => {
        if (this.drags[index].zIndex > this.drags[this.activeIndex].zIndex) {
          arr.zIndex--;
        }
        return arr;
      });
      this.drags[this.activeIndex].zIndex = this.drags.length - 1;
      this.changeDragHistory(this.activeIndex);
    },
    toBottom() {
      if (this.drags[this.activeIndex].zIndex == 0) return false;
      this.drags = this.drags.map((arr, index) => {
        if (this.drags[index].zIndex < this.drags[this.activeIndex].zIndex) {
          arr.zIndex++;
        }
        return arr;
      });
      this.drags[this.activeIndex].zIndex = 0;
      this.changeDragHistory(this.activeIndex);
    },
    handledownZJ() {
      this.drags[this.activeIndex].active = true;
    },
    rotating(left, top, width, height, rotate, index) {
      this.drags[index].rotate = parseInt(rotate);
      this.$forceUpdate();
      this.changeDragHistory(index);
    },
    pmoving(left, top, rotate, scale, index) {
      this.drags[index].photoLeft = parseInt(left);
      this.drags[index].photoTop = parseInt(top);
      this.drags[index].photoScale = parseFloat(scale);
      this.drags[index].photoRotate = parseFloat(rotate);
      this.$forceUpdate();
      console.log(scale);
      this.changeDragHistory(index);
    },
    movingStop(left, top, scale, index) {
      this.drags[index].photoLeft = parseInt(left);
      this.drags[index].photoTop = parseInt(top);
      this.drags[index].photoScale = parseFloat(scale);
      this.$forceUpdate();
      console.log(scale);
      this.changeDragHistory(index);
    },
    resizing(left, top, width, height, picLeft, picTop, index, radius) {
      console.log("resizing");
      this.drags[index].left = parseInt(left) ? parseInt(left) : 0;
      this.drags[index].top = parseInt(top);
      this.drags[index].width = parseInt(width);
      this.drags[index].height = parseInt(height);
      this.drags[index].photoLeft = parseInt(picLeft);
      this.drags[index].photoTop = parseInt(picTop);
      if (radius) {
        this.drags[index].borderRadius = parseInt(radius);
      }
      this.$forceUpdate();
      this.changeDragHistory(index);
    },
    dragging(left, top, dragIndex) {
      console.log("dragging:" + left, top, dragIndex);
      this.drags[dragIndex].left = parseInt(left);
      this.drags[dragIndex].top = parseInt(top);
      this.$forceUpdate();
      this.changeDragHistory(dragIndex);
    },
    async batchDel(ids, s_ids) {
      this.saveDraging = true;
      try {
        var res = await axios({
          method: "POST",
          url: api.domain + api.batchDel,
          headers: { Authorization: this.$store.state.headers },
          data: {
            eguc_ids: ids,
            s_ids: s_ids,
          },
        });
        setTimeout(() => {
          this.saveDraging = false;
        }, 800);
        this.getPhoto();
        return true;
      } catch (error) {
        this.$message.error("请求失败");
        return false;
      }
    },
    async handleRemoveDrag() {
      console.log("删除");
      var index = this.activeIndex;
      if (this.drags[index].lock) return false;
      if (index < 0) return false;

      var that = this;
      var delZindex = that.drags[index].zIndex;
      var ids = [];
      var sids = [];
      that.studentList.forEach((arr) => {
        if (arr.select) {
          sids.push(arr.id);
        }
      });
      // this.drags[this.activeIndex].active = true;
      // this.$message.loading({ content: "删除中", key: "del", duration: 2 });
      if (that.drags[index].eguc_id) {
        var drag = that.drags[index];
        var res = await that.batchDel(drag.eguc_id, sids.join(","));
        if (res) {
          that.activeIndex = -1;
          that.drags.splice(index, 1);
          if (this.step < this.czHistory.length - 1) {
            this.czHistory.splice(
              this.step + 1,
              this.czHistory.length - this.step - 1
            );
          }
          that.czHistory = [
            ...this.czHistory,
            {
              type: "delete",
              index: index - 1,
              detail: { eguc_ids: drag.eguc_id, sids: sids, cancelDrag: drag },
              ids: sids.join(","),
            },
          ];
          console.log("删除是否正确的eguc_id" + drag.eguc_id);
          // this.$message.success({
          //   content: "删除成功",
          //   key: "del",
          //   duration: 2,
          // });
          this.step++;
          if (that.drags.length > 0) {
            that.drags.map((arr) => {
              if (arr.zIndex > delZindex) {
                arr.zIndex--;
              }
              return arr;
            });
          } else {
            that.activeIndex = -1;
          }
        }
      }
    },
    async removeDrag(index) {
      if (index < 0) return false;
      var that = this;
      var delZindex = that.drags[index].zIndex;
      var ids = [];
      var sids = [];
      that.studentList.forEach((arr) => {
        if (arr.select) {
          sids.push(arr.id);
        }
      });

      if (index > that.activeIndex) {
        var res = await that.batchDel(
          that.drags[that.activeIndex].eguc_id,
          sids.join(",")
        );
        if (res) {
          that.drags.splice(index + 1, 1);
          this.drags[this.activeIndex].active = true;
          that.czHistory = [
            ...this.czHistory,
            {
              type: "delete",
              index: index,
              detail: { new: that.editList[0], old: null },
              ids: sids.join(","),
            },
          ];
          this.step++;
        }
      } else {
        that.activeIndex--;
        this.drags[this.activeIndex].active = true;
        var res = await that.batchDel(
          that.drags[that.activeIndex].eguc_id,
          sids.join(",")
        );
        if (res) {
          this.visible = false;
          that.drags.splice(index, 1);
          that.czHistory = [
            ...this.czHistory,
            {
              type: "delete",
              index: index,
              detail: { new: that.editList[0], old: null },
              ids: sids.join(","),
            },
          ];
          this.step++;
        }
      }
      if (that.drags.length > 0) {
        that.drags.map((arr) => {
          if (arr.zIndex > delZindex) {
            arr.zIndex--;
          }
          return arr;
        });
      }
    },
    calcPos(index) {
      var orignX =
        this.$refs.drag[index].left + this.$refs.drag[index].width / 2;
      var orignY =
        this.$refs.drag[index].top + this.$refs.drag[index].getHeight() / 2;

      const right =
        this.$refs.drag[index].left + this.$refs.drag[index].width + 10;
      if (right > this.$refs.body.getBoundingClientRect().width - 60) {
        this.moveBoxRight = this.$refs.drag[index].left - 60;
      } else {
        this.moveBoxRight =
          this.$refs.drag[index].left + this.$refs.drag[index].width + 10;
      }
      this.moveBoxTop =
        this.$refs.drag[index].top +
        this.$refs.drag[index].getHeight() / 2 -
        67;
      this.transformX = orignX - this.moveBoxRight;
      this.transformY = orignY - this.moveBoxTop;
      this.rotateStyles = {
        top: this.$refs.drag[index].top - 10,
        left:
          this.$refs.drag[index].left + this.$refs.drag[index].width / 2 - 22,
        rotateX:
          orignX -
          (this.$refs.drag[index].left + this.$refs.drag[index].width / 2 - 22),
        rotateY: orignY - (this.$refs.drag[index].top - 10),
      };
      this.moveBoxRotate = this.$refs.drag[index].rotate;
    },
    changeDrag2(index) {
      this.activeIndex = index;
      this.changePhotoState = false;
      var orignX =
        this.$refs.drag[index].left + this.$refs.drag[index].width / 2;
      var orignY =
        this.$refs.drag[index].top + this.$refs.drag[index].getHeight() / 2;

      const right =
        this.$refs.drag[index].left + this.$refs.drag[index].width + 10;
      if (right > this.$refs.body.getBoundingClientRect().width - 60) {
        this.moveBoxRight = this.$refs.drag[index].left - 60;
      } else {
        this.moveBoxRight =
          this.$refs.drag[index].left + this.$refs.drag[index].width + 10;
      }
      this.moveBoxTop =
        this.$refs.drag[index].top +
        this.$refs.drag[index].getHeight() / 2 -
        97;
      this.transformX = orignX - this.moveBoxRight;
      this.transformY = orignY - this.moveBoxTop;
      this.rotateStyles = {
        top: this.$refs.drag[index].top - 10,
        left:
          this.$refs.drag[index].left + this.$refs.drag[index].width / 2 - 33,
        rotateX:
          orignX -
          (this.$refs.drag[index].left + this.$refs.drag[index].width / 2 - 33),
        rotateY: orignY - (this.$refs.drag[index].top - 10),
      };
      this.moveBoxRotate = this.$refs.drag[index].rotate;
      this.drags.forEach((arr, index2) => {
        if (index == index2) return false;
        this.$set(this.drags[index2], "active", false);
        this.$set(this.drags[index2], "enable", false);
        this.$refs.drag[index2].cancelActive();
      });
      this.batchGetElement(this.drags[index].eguc_id);
    },
    changeDrag(index) {
      this.changePhotoState = false;
      this.uploadWaitDrag()
        .then(() => {
          this.changeDrag2(index);
        })
        .catch(() => {
          this.changeDrag2(index);
        });
    },
    selectAllStudent() {
      this.uploadWaitDrag();
      this.studentList = this.studentList.map((arr) => {
        if (this.selectState) {
          arr.select = false;
        } else {
          arr.select = true;
        }
        if (arr.id == this.s_id) {
          arr.select = true;
        }
        arr.has_element = true;
        return arr;
      });
      if (this.selectState) {
        this.selectState = false;
      } else {
        this.selectState = true;
      }
      this.getPhoto();
      this.check_drag_edit()
    },
    changeSwitch(e) {
      console.log(e);
      this.drags[this.activeIndex].shadow = e;
      this.$forceUpdate();
    },
    // 辅助线回调事件
    getRefLineParams(params) {
      const { vLine, hLine } = params;
      let id = 0;
      this.vLine = vLine.map((item) => {
        item["id"] = ++id;
        return item;
      });
      this.hLine = hLine.map((item) => {
        item["id"] = ++id;
        return item;
      });
    },
    async addText() {
      var item = this.texts;
      var drag = {
        allIndex: this.drags.length + 1,
        left: 216 - item.width / 2,
        top: 350 - (item.height ? item.height : 0) / 2,
        width: item.width,
        height: item.height ? item.height : "auto",
        rotate: item.rotate,
        lockAspectRatio: item.lockAspectRatio,
        textarea: item.textarea,
        minW: item.minW,
        minH: item.minH,
        type: item.type,
        backgroundImg:
          item.type == 1 || item.type == 9 ? "" : item.backgroundImg,
        backImg2: item.backImg2,
        maxW: item.maxW,
        maxH: item.maxH,
        lock: item.lock,
        zIndex: this.drags.length + 1,
        bColor: item.bColor,
        fColor: item.fColor,
        fSize: item.fSize,
        textIndent: item.textIndent,
        writeMode: item.writeMode,
        bordersColor: item.bordersColor,
        bLeft: item.bLeft,
        bTop: item.bTop,
        bRight: item.bRight,
        bBottom: item.bBottom,
        bStyle: item.bStyle,
        fSize: item.fSize,
        textIndent: item.textIndent,
        writeMode: item.writeMode,
        paddingLeft: item.paddingLeft,
        paddingTop: item.paddingTop,
        paddingRight: item.paddingRight,
        paddingBottom: item.paddingBottom,
        opacity: item.opacity,
        showPhoto: item.showPhoto,
        lineHeight: item.lineHeight,
        fontWeight: item.fontWeight,
        fontStyle: item.fontStyle,
        textAlign: item.textAlign,
        lineHeightAutoSize: 1,
        combs: this.selectPhoto.type == 3 ? this.selectPhoto.combs : null,
      };
      var sids = [];
      this.studentList.forEach((arr) => {
        if (arr.select) {
          sids.push(arr.id);
        }
      });
      var addState = await this.batchAddDrag([drag]);
      if (addState.length > 0) {
        addState[0].lineHeightAutoSize = 1;
        this.drags = [...this.drags, ...addState];
        this.visible = false;
        this.drags.forEach((arr, index) => {
          arr.active = false;
          if (index == this.drags.length - 1) {
            arr.active = true;
          }
          return arr;
        });
        this.changeDrag(this.drags.length - 1);
        this.allIndex = this.drags.length;

        this.czHistory = [
          ...this.czHistory,
          {
            type: "adddrag",
            index: null,
            detail: { new: addState, old: null, sids: sids.join(",") },
          },
        ];
        this.originDrags = _.cloneDeep(this.drags);
        this.$forceUpdate();
      } else {
        this.$message.error("添加失败");
      }
    },
    async addPhoto2(url) {
      this.selectPhoto = {
        left: null,
        top: null,
        width: 160,
        height: "auto",
        rotate: 0,
        lockAspectRatio: true,
        aspectFactor: null,
        textarea: "",
        minW: null,
        minH: null,
        maxW: null,
        maxH: null,
        lock: false,
        zIndex: null,
        bColor: "",
        fColor: null,
        fSize: 14,
        bordersColor: null,
        bLeft: 0,
        bTop: 0,
        bRight: 0,
        bBottom: 0,
        bStyle: "solid",
        paddingLeft: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        opacity: 100,
        shadow: false,
        active: false,
        backgroundImg: url,
        backImg2: "",
        borderRadius: 0,
        type: 0,
        lineHeight: "18",
        borderRadius: 0,
        fontStyle: "horizontal-tb",
        fontWeight: "normal",
        textAlign: "left",
      };
      this.addDrag({ layerX: this.wrapperWidth / 2, layerY: 350 });
      setTimeout(() => {
        this.visible = false;
      }, 100);
    },
    async addPhoto(item) {
      this.selectPhoto = item;
      this.addDrag({ layerX: this.wrapperWidth / 2, layerY: 350 });
      setTimeout(() => {
        this.visible = false;
      }, 100);
    },
    changeTab(index) {
      console.log(this.activeIndex);
      this.tabIndex = index;
      if (this.tabIndex == 7) {
        setTimeout(() => {
          this.editState = true;
        }, 400);
      } else {
        this.editState = false;
      }
    },
    selectPlate(index) {
      this.plateList = this.plateList.map((arr) => {
        arr.select = false;
        return arr;
      });
      this.plateList[index].select = true;
      this.$forceUpdate();
    },
    changeBack2(url) {
      var s_ids = [];
      this.studentList.forEach((arr) => {
        if (arr.select) {
          s_ids.push(arr.id);
        }
      });
      axios({
        method: "POST",
        url: api.domain + api.batchEditBg,
        headers: { Authorization: this.$store.state.headers },
        data: {
          guc_id: this.guc_id,
          img_bg: url,
          s_ids: s_ids.join(","),
        },
      })
        .then((res) => {})
        .catch((res) => {});
    },
    changeBack(url) {
      this.$confirm({
        title: "确认替换背景吗?",
        content: "背景替换后可能无法撤销，请谨慎使用",
        centered: true,
        onOk: () => {
          var originUrl = this.backgroundImage;
          var s_ids = [];
          if (url.indexOf("?")) {
            url = url.split("?")[0];
          }
          this.studentList.forEach((arr) => {
            if (arr.select) {
              s_ids.push(arr.id);
            }
          });
          axios({
            method: "POST",
            url: api.domain + api.batchEditBg,
            headers: { Authorization: this.$store.state.headers },
            data: {
              guc_id: this.guc_id,
              img_bg: url,
              s_ids: s_ids.join(","),
            },
          })
            .then((res) => {
              if (res.data.status == 201) {
                this.$message.error(res.data.msg);
                return false;
              }
              this.backgroundImage = url;
              // this.$message.success('切换背景成功')
              if (this.step < this.czHistory.length - 1) {
                this.czHistory.splice(
                  this.step + 1,
                  this.czHistory.length - this.step - 1
                );
              }
              this.czHistory = [
                ...this.czHistory,
                {
                  type: "changeBack",
                  index: null,
                  detail: originUrl,
                },
              ];

              this.step = this.czHistory.length - 1;
              console.log(this.czHistory, this.step);
            })
            .catch((res) => {});
        },
        onCancel() {},
      });
    },
    changeImgs(url) {
      this.drags[this.activeIndex].active = true;
      if (
        this.drags[this.activeIndex].type == 1 ||
        this.drags[this.activeIndex].type == 9
      ) {
        this.drags[this.activeIndex].backgroundImg = url;
      } else {
        this.drags[this.activeIndex].showPhoto = url;
        this.drags[this.activeIndex].photoLeft = 0;
        this.drags[this.activeIndex].photoTop = 0;
        this.drags[this.activeIndex].photoScale = 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-modal-body ::v-deep .quill-editor {
  height: 240px !important;
}

::v-deep .ant-drawer-title {
  line-height: 22px;
  text-align: center;
}

.rotatebox {
  position: absolute;
  width: 66px;
  height: 66px;
  z-index: 1100;
  right: 0;
  top: 0;
  text-align: center;

  &::before {
    font-size: 38px;
    color: #399fe4;
    font-weight: bold;
    line-height: 66px;
    text-shadow: #fff 1px 0 0, #fff 0 1px 0, #fff -1px 0 0, #fff 0 -1px 0;
  }

  i {
    font-size: 38px;
    color: #399fe4;
    font-weight: bold;
    line-height: 66px;
  }
}

.moveBOX {
  position: absolute;
  width: 60px;
  z-index: 1100;
  display: flex;
  // background: #fff;
  padding: 4px 0px;
  right: -40px;
  top: 0;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  i {
    font-size: 32px;
    color: #399fe4;
  }

  img {
    width: 40px;
    height: 40px;
    margin: 10px 0;
    cursor: move;
  }
}

.raduis .el-input-number {
  width: 90px;
  margin-right: 3px;
}

::v-deep .ql-container {
  -webkit-text-size-adjust: none;
  height: 240px;
}

.raduis .el-input-number {
  width: 90px;
  margin-right: 3px;
}

.edit-content {
  padding: 15px 12px;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  textarea {
    background: #ececec;
    height: 200px;
  }

  .tab {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 10px 0;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;

    .item {
      flex: 1 1 0%;
      text-align: center;
      font-size: 14px;
      padding: 8px 0;
      color: #333;

      &.active {
        color: #67b0dc;
      }
    }
  }

  .section {
    width: 100%;
    min-height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .row {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 15px;

      .label {
        flex: 1 1 0%;
        border-radius: 5px;
        border: 1px solid #eee;
        text-align: center;
        margin-left: 10px;
        font-weight: bold;
        padding: 2px 0;

        &.active {
          background: #e1eff8;
        }

        &:first-child {
          margin-left: 0;
        }

        &.outline {
          border: none;
        }
      }
    }

    .col-3 {
      flex: 3.2 0%;
      display: flex;
      flex-direction: row;
      align-items: center;
      background: #f3f3f3;
      padding: 5px;
      border-radius: 5px;

      .cell {
        flex: 1 1 0%;
        border-radius: 5px;
        border: 1px solid #eee;
        text-align: center;
        margin-right: 10px;
        font-weight: bold;
        color: #333;
        padding: 2px 0;

        &.active {
          background: #fff;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .quill-editor {
    flex: 1 1 0%;
    height: 320px;

    ::v-deep .ql-toolbar {
      display: none !important;
    }

    ::v-deep .ql-container {
      border-top: 1px solid #ccc;
      height: 320px;
    }

    ::v-deep .ql-editor {
      padding: 15px;
      box-sizing: border-box;
      background: #efefef;
      white-space: pre-wrap;
    }
  }
}

.fixtop {
  position: fixed;
  left: 0;
  right: 0;
  box-sizing: border-box;
  top: 0;
  height: 54px;
  background: #ffffff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  z-index: 30;

  .btn {
    margin-right: 10px;
  }

  .left {
    widows: 385px;
    display: flex;
    flex-direction: row;
    position: absolute;
    left: 20px;
    top: 0;
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    align-items: center;

    .icon {
      width: 55px;

      i {
        color: #67b0dc;
      }
    }

    .network {
      text-align: center;
      height: 45px;
      width: 65px;
      display: flex;
      align-items: center;
      justify-content: center;

      .name {
        margin-top: 2px;
        width: 65px;
      }

      img {
        margin: auto;
      }
    }

    .name {
      width: 55px;
      cursor: poin ter;
      font-size: 12px;
    }

    .main {
      font-size: 16px;
      margin-left: 5px;
    }
  }

  .right {
    position: absolute;
    right: 10px;
    top: 0;
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .save {
      background: #746bff;
      color: #fff;
      text-align: center;
      padding: 4px 12px;
      font-size: 12px;
      border-radius: 2px;
    }
  }

  .cz {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 250px;
    margin-left: 40px;
    text-align: center;
    font-size: 12px;
    color: #5d5d5d;

    .cz-item {
      flex: 1 1 0%;
      cursor: pointer;

      .name {
        margin-top: 4px;
      }
    }
  }
}

.cz-item {
  text-align: center;

  i {
    font-size: 24px;
  }
}

.leftLine {
  position: absolute;
  width: 1px;
  background: #c70a0a;
}

.topLine {
  position: absolute;
  height: 1px;
  background: #c70a0a;
}

.rightLine {
  position: absolute;
  width: 1px;
  background: #c70a0a;
}

.bottomLine {
  position: absolute;
  height: 1px;
  background: #c70a0a;
}

.circles {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 20px;

  .circle {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    div {
      width: 18px;
      height: 18px;
      border-radius: 18px;
      border: 1px solid #c70a0a;
      background: transparent;
    }
  }
}

.item-line .input {
  width: 120px;
}

.edit-list {
  width: 100%;

  .edit-cell {
    padding: 10px;
    box-sizing: border-box;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .quill-editor {
      flex: 1 1 0%;
      height: auto;
      width: 100%;

      ::v-deep .ql-toolbar {
        display: none !important;
      }

      ::v-deep .ql-container {
        border-top: 1px solid #ccc;
        height: auto;
      }
    }

    .name {
      width: 4em;
      margin-right: 6px;
      margin-bottom: 6px;
      text-align: left;
      width: 100%;
    }
  }
}

.num-item {
  display: flex;
  flex-direction: row;
  align-items: center;

  .num-cell {
    margin-right: 10px;
  }

  i {
    margin-right: 8px;
  }

  .el-input-number {
    width: 90px;
  }
}

.flex-1 {
  flex: 1 1 0%;
}

.section {
  width: 100%;

  .section-item {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #ccc;

    .item-line {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      box-sizing: border-box;
      margin-bottom: 10px;

      span.name2 {
        font-size: 14px;
        color: rgb(141, 158, 167);
        line-height: 38px;
        margin: 0 10px;
        box-sizing: border-box;
        width: 20px;
      }

      .title {
        flex: 1 1 0%;
      }

      .cell {
        box-sizing: border-box;
        width: 160px;
        display: flex;
        margin-right: 12px;
        flex-direction: row;
        align-items: center;
        color: rgb(125, 139, 148);

        span.name {
          font-size: 14px;
          color: rgb(141, 158, 167);
          line-height: 38px;
          margin: 0 10px;
          box-sizing: border-box;
          width: 20px;
        }
      }

      .el-input-number {
        flex: 1 1 0%;
      }
    }
  }
}

.dz-drawer {
  position: fixed;
  background: #fff;
  bottom: 0;
  left: 0;
  height: 88%;
  right: 0;
  border-radius: 5px 0 0 5px;
  z-index: 1000;

  &::before {
    position: fixed;
    content: "";
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba($color: #000000, $alpha: 0.6);
    z-index: -1;
  }

  .d-title {
    position: absolute;
    background: #399fe4;
    color: #fff;
    z-index: 10;
    line-height: 50px;
    font-size: 14px;
    width: 100%;
    padding: 0 15px;
    z-index: 99;
  }

  .miconfont {
    position: absolute;
    right: 15px;
    height: 50px;
    line-height: 50px;
    font-size: 17px;
    color: #fff;
    z-index: 100;
  }

  .content {
    height: 100%;
    background: #fff;
    overflow-y: scroll;
    padding-top: 50px;
  }
}

.fixbtn {
  position: fixed;
  display: flex;
  flex-direction: column;

  .ant-btn {
    margin-bottom: 10px;
  }

  .flex-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    user-select: none;

    .item {
      cursor: pointer;
    }
  }
}

.backimg {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  bottom: 0;
}

.photo-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

.build-item {
  width: 30%;
  height: 99px;
  background: #eee;
  overflow: hidden;
  float: left;
  box-sizing: border-box;
  padding: 10px;
  -webkit-user-drag: element;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 5px;

  .wrap {
    position: relative;
  }

  .img {
    width: 100%;
    height: auto;
  }

  .img2 {
    width: 100%;
    height: auto;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
  }
}

.searchbox {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px 20px 10px 10px;
  box-sizing: border-box;

  ::v-deep .ant-input-search {
    flex: 1 1 0%;
  }
}

.fixtop div,
.tabbar div {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}

.body {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}

.student-list {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}

.content img {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}

.photo-item {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
  width: 33.33%;
  float: left;
  box-sizing: border-box;
  padding: 10px;
  position: relative;

  .img {
    width: 100%;
    height: auto;
  }

  .img2 {
    width: 100%;
    height: auto;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
  }
}

.dragtext {
  width: 99px;
  height: 99px;
  text-align: center;
  line-height: 99px;
  color: #333;
  border: 1px solid #666;
  margin-bottom: 10px;
}

.photo-item .look {
  width: 100%;
  margin-bottom: 10px;
  box-sizing: border-box;
  overflow: hidden;
}

.back-item {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
  width: 33.33%;
  float: left;
  box-sizing: border-box;
  padding: 10px;
}

.plate-list {
  margin-top: 20px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;

  .cell {
    width: 134px;
    margin-right: 20px;
    height: 180px;
    background: #eee;
    position: relative;
    margin-bottom: 60px;

    &.select {
      border: 2px solid #9ebee4;
    }

    .name {
      position: absolute;
      left: 0;
      top: 185px;
      color: #888;
      line-height: 1.2;
      padding: 5px;
      box-sizing: border-box;
    }

    &:nth-child(5n) {
      margin-right: 0;
    }
  }
}

.back-item .back {
  width: 100%;
  margin-bottom: 10px;
  box-sizing: border-box;
  position: relative;
  &.select {
    // border: 4px solid #55aaff;
    border-radius: 2px;
    position: relative;
    &::after {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      content: "";
      line-height: 100%;
      font-family: "iconfont";
      background: rgba($color: #000000, $alpha: 0.3);
      z-index: 100;
      color: #fff;
      font-size: 30px;
      text-align: center;
    }

    .iconfont3 {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      font-size: 30px;
      color: #fff;
      z-index: 101;
    }
  }
  .times {
    position: absolute;
    right: 0;
    top: 0;
    padding: 4px 6px;
    color: #fff;
    background: #ff0000;
    border-radius: 16px;
    text-align: center;
    font-size: 12px;
    line-height: 1;
    transform: translate(50%, -50%);
  }
}

.back-item .back .img {
  width: 100%;
  height: auto;
  max-height: 160px;
  background: #f3f3f3;
  display: block;
}

.photo-item .look .img {
  width: 100%;
  background: #f3f3f3;
  display: block;
}
.fixed-b-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #eee;
  border-radius: 100px;
  justify-content: center;
}
.photo-item .name {
  text-align: center;
}

.section-item {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;

  .item-line {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    box-sizing: border-box;
    margin-bottom: 10px;

    span.name2 {
      font-size: 14px;
      color: rgb(141, 158, 167);
      line-height: 38px;
      margin: 0 10px;
      box-sizing: border-box;
      width: 20px;
    }

    .title {
      flex: 1 1 0%;
    }

    .cell {
      box-sizing: border-box;
      width: 160px;
      display: flex;
      margin-right: 12px;
      flex-direction: row;
      align-items: center;
      color: rgb(125, 139, 148);

      span.name {
        font-size: 14px;
        color: rgb(141, 158, 167);
        line-height: 38px;
        margin: 0 10px;
        box-sizing: border-box;
        width: 20px;
      }
    }

    .el-input-number {
      flex: 1 1 0%;
    }
  }
}

body,
html {
  background: #f3f3f3;
  padding: 0;
  box-sizing: border-box;
  margin: 0;
}

.page-list {
  width: 100%;
  overflow: hidden;

  .cell {
    float: left;
    width: 33.33%;
    margin: 10px 0;
    position: relative;
    overflow: hidden;

    &::after {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      content: "";
    }

    .dragbox {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }

    .cover {
      width: 120px;
      height: 170px;
      background: #eee;
      margin-bottom: 15px;
      background-size: contain;
    }

    .name {
      color: #666666;
      font-size: 14px;
      text-align: center;
      height: 20px;
      margin-top: 10px;
      line-height: 20px;
      z-index: 100;
    }
  }
}

.student-list {
  // position: fixed;
  // left: 0;
  // top: 60px;
  // bottom: 0;
  width: 100%;
  background: #fff;
  z-index: 100;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-around;

  .selectall {
    width: 200px;
    text-align: center;
    padding: 8px;
    background: #e8e8f3;
    color: #666;
    cursor: pointer;
    margin: 10px auto 10px auto;
    border-radius: 100px;
    position: absolute;
    top: 50px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1001;

    &::before {
      position: absolute;
      content: "";
      left: 66%;
      width: 70%;
      height: 1px;
      top: 50%;
      background: #e8e8f3;
    }

    &::after {
      position: absolute;
      content: "";
      right: 66%;
      width: 70%;
      height: 1px;
      top: 48%;
      background: #e8e8f3;
    }
  }

  .cell {
    width: 23%;
    text-align: center;
    padding: 10px;
    float: left;
    position: relative;
    margin: 5px 0;

    .pos-tip {
      position: absolute;
      background: #ff0000;
      color: #fff;
      top: -4px;
      left: 0;
      right: 0;
      border-radius: 4px;
    }

    &.select {
      background: #dfe7ec;
      border-radius: 4px;
    }

    &.active {
      background: #4e9ecf;
      border-radius: 4px;

      .name {
        color: #fff;
      }
    }

    img {
      width: 44px;
      height: 44px;
      border-radius: 60px;
    }

    .name {
      text-align: center;
      color: #999;
      margin-top: 10px;
    }
  }
}

::v-deep .ant-input {
  border: 1px solid #eee;
}

::v-deep .ant-upload.ant-upload-drag {
  margin-bottom: 8px;
}

::v-deep .ant-upload-list {
  overflow: hidden;
}

.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;

  .iconfont {
    margin-right: 6px;
    font-size: 20px;
  }
}

.leftChat {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100vh;
  overflow: hidden;
}

.body {
  position: fixed;
  width: 432px;
  height: 700px;
  -webkit-text-size-adjust: none;
  // overflow: hidden;
  min-height: 600px;
  border: 1px solid #999;
  background: linear-gradient(-90deg, rgba(0, 0, 0, 0.1) 1px, transparent 1px)
      10px 10px / 20px 20px,
    linear-gradient(rgba(0, 0, 0, 0.1) 1px, transparent 1px) 0% 0% / 20px 20px;
}

.test1 {
  background-color: #fff;
}

.test1 img {
  width: 100%;
  height: 100%;
}

textarea {
  background: transparent;
}
.rightChat {
  // position: fixed;
  // right: 0;
  // top: 0;
  width: 100%;
  height: 555px;
  transform-origin: 0 0;
  background: #fff;
  overflow-y: scroll;
  z-index: 20;
  display: flex;
  flex-direction: column;

  .content {
    overflow-x: hidden;
    flex: 1 1 0%;
    padding-bottom: 55px;
    box-sizing: border-box;
  }
}

.fixtop .icon {
  text-align: center;
}

.fixtop .icon {
  text-align: center;
}

.rightChat .tabbar {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 5px 50px 0 5px;
}

.rightChat .tabbar .tab-item {
  padding: 8px 8px;
  cursor: pointer;
  font-size: 14px;
}

.rightChat .tabbar .tab-item.active {
  color: #746bff;
  position: relative;
}

.rightChat .tabbar .tab-item.active::after {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 12px;
  height: 2px;
  background: #746bff;
  content: "";
}

textarea {
  width: 100%;
  height: auto;
  max-height: 100%;
  border: none;
  // outline: none;
}

.text {
  box-sizing: border-box;
}

::v-deep .el-color-dropdown__value {
  margin-top: 5px !important;
}

#app,
.app {
  background: #f3f3f3;
  width: 100%;
}

.app {
  background: #f3f3f3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  align-items: center;
}

.pagebox {
  position: absolute;
  bottom: 0px;
  padding: 15px 0;
  left: 5px;
  right: 5px;
  background: #fff;
}

.bottomChat {
  position: fixed;
  left: 0;
  bottom: 0;
  right: 381px;
  background: #fff;
  height: 50px;

  .pagebox {
    width: 100%;
    display: flex;
    flex-direction: row;
    padding-left: 10px;
    box-sizing: border-box;
    align-items: center;

    .item {
      width: 28px;
      height: 28px;
      border-radius: 2px;
      line-height: 25px;
      font-size: 12px;
      text-align: center;
      border: 1px solid #10ddbe;
      margin-right: 4px;
      color: #16bda4;
      cursor: pointer;
    }

    .add-page {
      width: 28px;
      height: 28px;
      border-radius: 2px;
      line-height: 25px;
      font-size: 12px;
      text-align: center;
      border: 1px solid #10ddbe;
      box-sizing: border-box;
      padding: 0;
      color: #16bda4;
      margin-right: 4px;
      cursor: pointer;
    }

    .active {
      background: #00d182;
      color: #fff;
    }
  }
}

.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.savebox {
  margin-right: 12px;
  text-align: center;
  font-size: 12px;
  height: 42px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  i {
    margin-top: 5px;
    font-size: 14px;
  }

  div {
    margin-top: 3px;
  }

  span {
    margin-left: 5px;
  }
}

.sizebox {
  .name {
    margin-right: 5px;
  }
}

.border-cell {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  &.active .name {
    background: #e2f0f8;
  }

  .name {
    line-height: 26px;
    width: 80px;
    text-align: center;
    background: #fff;
    border-radius: 100px;
    border: 1px solid #eee;
    margin-bottom: 16px;
    color: #333;
    font-size: 14px;
  }

  .border1 {
    border-top: 3px solid #666;
    width: 70%;
  }

  .border2 {
    border-top: 3px dashed #666;
    width: 70%;
  }

  .border3 {
    border-top: 3px dotted #666;
    width: 70%;
  }
}

.fixbottom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #67b0dc;
  padding: 8px 15px 23px 15px;
  text-align: right;
  display: flex;
  flex-direction: row;
  align-items: center;

  .name {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .item {
    flex: 1 1 0%;
    text-align: center;
    color: #fff;
  }

  &.type2 {
    background: #f3f3f3;

    .scrolly {
      width: 100%;
      overflow-y: scroll;
      // display: flex;
      // flex-direction: row;
      // justify-content: flex-start;
      white-space: nowrap;
      text-align: left;
      padding: 2px 0 12px 0;

      .item {
        display: inline-block;
        text-align: center;
        color: #333;
        width: 55px;

        .miconfont {
          color: #67b0dc;
          font-size: 22px;
        }
      }
    }
  }
}
.pullbox {
  padding: 10px 10px 0 10px;
  width: 100%;
  height: 42px;
  .a-button {
    margin-right: 10px;
  }
}
.ant-drawer-body {
  padding: 0 !important;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;
}

::v-deep .ant-drawer-body {
  padding: 0 !important;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;
}

::v-deep .ql-editor {
  padding: 82px 15px 12px 15px;
}

::v-deep .ant-select-selection-selected-value .total {
  display: none;
}

.icon-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.icon-wrapper .item {
  flex: 1 1 0%;
  font-size: 12px;
  color: #30b2ed;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.icon-wrapper .item i {
  color: #30b2ed;
  width: 16px;
  height: 16px;
  line-height: 16px;
}
.icon-wrapper .item img {
  width: 16px;
  margin-left: -2px;
}
.fixbottom .scrolly .item {
  height: 54px;
}
.fixbottom .item img {
  width: 22px;
  height: 22px;
  margin-bottom: 5px;
}
</style>
